import { Component, HostListener, ViewChild, Input, ElementRef, QueryList, ViewChildren, OnDestroy, NgZone, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { AbstractControl, FormControl, FormsModule, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { NgClass, NgStyle, DatePipe, CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import axios from "axios";
import { Router } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { forkJoin, of } from 'rxjs';
import * as d3 from 'd3';
import { HierarchyRectangularNode } from 'd3-hierarchy';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTooltip,
  ApexStroke,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexPlotOptions,
  ApexFill,
  ApexLegend,
  ApexYAxis,
  ApexMarkers,
  ApexTitleSubtitle
} from "ng-apexcharts";
import { ActivatedRoute } from '@angular/router';
import { NgApexchartsModule } from "ng-apexcharts";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { CrmService } from 'src/app/service/crm.service';
import { UserService } from 'src/app/service/user.service';
import moment from "moment";
import {
  CdkDragDrop,
  CdkDragMove,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollable, ScrollingModule } from '@angular/cdk/scrolling';
import { firstValueFrom, take, Subscription } from 'rxjs';
import { ChatService } from 'src/app/service/chat.service';
import { WhatsappMessagesCardComponent } from 'src/app/component/whatsapp-messages-card/whatsapp-messages-card.component';
import { Socket } from "socket.io-client";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { alertModalDelete, alertModalWithoutConfirm, alertModalConfirm, alertModalNextTaskReminder } from '../../helpers/alert';
import { environment } from 'src/environments/environment';
import { NotificationSoundService } from 'src/app/service/notification-sound.service';
import { ThemeService } from '../../../service/theme.service';
import { ImageCropperComponent, ImageCroppedEvent } from "ngx-image-cropper";
import { DISPOSITION_EVENT } from 'src/app/constants/disposition.constants';

const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB
const MIN_CHUNK_SIZE = 10 * 1024 * 1024;


export interface Disposition {
  _id: string;
  leadId: string;
  note?: string;
  userName?: string;
  profileImg?: string;
  updatedAt?: string;
  status?: string;
  prevStatus?: string;
  type?: 'User' | 'System';
  event?: string;
  hasClosingPotential?: any;
  createdAt?: string;
}




type TerritoryNode = {
  name: string;
  assignedLeads: number;
  convertedLeads: number;
};


type TextBlock = {
  id: string;
  type: 'text';
  value: string;
};

type FileBlock = {
  id: string;
  type: 'text' | 'file';
  value?: string;
  fileName: string;
  fileSize: number;
  rawFile: File;
  uploading: boolean;
  progress: number;
  uploadId?: string;
  mediaId?: string;
  url?: string;
  uploadedAt?: Date | string;
  extension?: string;
  thumbnailUrl?: string;
  parts: { PartNumber: number; ETag: string }[];
  leadId?: string;
};

type EditorBlock = TextBlock | FileBlock;

export type RadialChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
};

export type DonutChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels?: any;
  colors?: any;
  plotOptions?: ApexPlotOptions;
  dataLabels?: ApexDataLabels;
  legend?: ApexLegend;
  fill?: ApexFill;
};



export type SalesChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  legend: ApexLegend;
  fill: ApexFill;
  markers: ApexMarkers;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  grid?: any;
  focus?: any;
};

@Component({
  selector: 'app-sales-dashboard',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    DatePipe,
    NgClass,
    InfiniteScrollModule,
    NgApexchartsModule,
    MatSelectModule,
    MatAutocompleteModule,
    NgStyle,
    DragDropModule,
    ScrollingModule,
    CdkScrollable,
    NgxDaterangepickerMd,
    ReactiveFormsModule,
    WhatsappMessagesCardComponent,
    ImageCropperComponent
  ],
  templateUrl: './sales-dashboard.component.html',
  styleUrls: [
    '../styles/leads.css',
    './sales-dashboard.component.css'
  ]
})
export class SalesDashboardComponent implements OnDestroy {
  private themeSub!: Subscription;
  private leadsBreakdownSummary: any = null;

  @Input() project: string = "";

  // @ViewChild("chart", { static: true }) chart: ChartComponent;
  @ViewChild("donutchart", { static: false }) donutchart: ChartComponent;
  @ViewChild("radialchart", { static: false }) radialchart: ChartComponent;
  @ViewChild("saleschart") saleschart: ChartComponent;
  @ViewChild('chart', { static: false }) chart!: ElementRef;
  @ViewChildren('editorTextarea') editorTextareas!: QueryList<ElementRef<HTMLTextAreaElement>>;

  public saleschartOptions: Partial<SalesChartOptions>;
  radialChartData: any[] = [];
  socket!: Socket;
  productAData: { x: number; y: number }[] = [];
  productBData: { x: number; y: number }[] = [];
  productCData: { x: number; y: number }[] = [];
  leadForm: FormGroup;
  loggedInUserName = '';
  leadData: any[] = [];
  searchQuery: string = '';
  startDate: any = ''
  endDate: any = '';
  currentPageNume: number = 1;
  currentLimit: number = 100;
  selectedType: string = 'Contact Us';
  isSpinnerLoader: boolean = false;
  showNoDataMessage: boolean = false;
  loggedInUser: any = null;
  assistantUser: boolean = false;
  singleLead: any;
  selectedLead: any = null;
  get dropListIds(): string[] {
    return [
      "assigned-list",
      ...this.emptyColumns.filter(col => col.status !== 'Follow-up Task' && col.status !== 'Closing Pool').map(col => "drop-list-" + col.index)
    ];
  }

  get bannerHeight(): string {
    return '70vh';
  }

  readonly dragStartDelay = { touch: 250, mouse: 0 };

  isCanvasLoading: boolean = true;

  dispositionControl = new FormControl('');
  dispositions: Disposition[] = [];
  isCreatingDisposition = false;

  audioSpeeds: number[] = [1, 1.5, 2, 3];
  selectedAudioSpeed: number = 1;
  isPlayingAudio: boolean = false;
  currentAudioTime: number = 0;
  audioDuration: number = 0;
  isAudioMuted: boolean = false;
  isDraggingAudio: boolean = false;

  resetAudioPlayer(): void {
    this.currentAudioTime = 0;
    this.audioDuration = 0;
    this.isPlayingAudio = false;
    this.isAudioMuted = false;
    this.selectedAudioSpeed = 1;
    this.isDraggingAudio = false;
    const player = document.getElementById('ivrRecordingSales') as HTMLAudioElement;
    if (player) {
      player.pause();
    }
  }

  toggleAudioSpeed(audioEl?: HTMLAudioElement): void {
    const currentIndex = this.audioSpeeds.indexOf(this.selectedAudioSpeed);
    const nextIndex = (currentIndex + 1) % this.audioSpeeds.length;
    this.selectedAudioSpeed = this.audioSpeeds[nextIndex];

    const player = audioEl || (document.getElementById('ivrRecordingSales') as HTMLAudioElement);
    if (player) {
      player.playbackRate = this.selectedAudioSpeed;
    }
  }

  togglePlayPause(audioEl: HTMLAudioElement): void {
    if (!audioEl) return;
    if (audioEl.paused) {
      const playPromise = audioEl.play();
      if (playPromise !== undefined) {
        playPromise.then(() => {
          this.isPlayingAudio = true;
        }).catch((err: any) => {
          console.error('Audio playback failed:', err);
          this.isPlayingAudio = false;
        });
      } else {
        this.isPlayingAudio = true;
      }
    } else {
      audioEl.pause();
      this.isPlayingAudio = false;
    }
  }

  onAudioTimeUpdate(audioEl: HTMLAudioElement): void {
    if (!audioEl || this.isDraggingAudio) {
      return;
    }

    this.currentAudioTime = audioEl.currentTime;

    if (Number.isFinite(audioEl.duration)) {
      this.audioDuration = audioEl.duration;
    }
  }

  onAudioEnded(): void {
    this.isPlayingAudio = false;
    this.currentAudioTime = 0;
  }

  onAudioSeekInput(event: Event): void {
    this.isDraggingAudio = true;
    const input = event.target as HTMLInputElement;
    this.currentAudioTime = Number(input.value);
  }

  onAudioSeekChange(event: Event, audioEl: HTMLAudioElement): void {
    const input = event.target as HTMLInputElement;
    const seekTime = Number(input.value);

    if (!audioEl || !Number.isFinite(seekTime)) {
      this.isDraggingAudio = false;
      return;
    }

    this.currentAudioTime = seekTime;

    try {
      if (audioEl.readyState > 0) {
        audioEl.currentTime = seekTime;
      } else {
        audioEl.load();
        audioEl.addEventListener('loadedmetadata', () => {
          audioEl.currentTime = seekTime;
        }, { once: true });
      }
    } catch (err) {
      console.error('Seeking failed:', err);
    }

    setTimeout(() => {
      this.isDraggingAudio = false;
    }, 150);
  }

  onAudioSeek(event: any, audioEl: HTMLAudioElement): void {
    const seekTime = parseFloat(event.target.value);
    if (audioEl) {
      audioEl.currentTime = seekTime;
      this.currentAudioTime = seekTime;
    }
  }

  toggleMute(audioEl: HTMLAudioElement): void {
    if (audioEl) {
      audioEl.muted = !audioEl.muted;
      this.isAudioMuted = audioEl.muted;
    }
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  }

  formatDuration(value: number | string | undefined): string {
    if (value == null || value === '') return '0:00';
    if (typeof value === 'string') {
      if (value.includes(':')) return value;
      const parsed = Number(value);
      if (!isFinite(parsed)) return '0:00';
      value = parsed;
    }
    const seconds = typeof value === 'number' ? value : Number(value);
    if (!isFinite(seconds)) return '0:00';
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }

  onAudioPlay(event: Event): void {
    this.isPlayingAudio = true;
    const player = event.target as HTMLAudioElement;
    if (player) {
      player.playbackRate = this.selectedAudioSpeed;
    }
  }

  onAudioLoaded(event: Event): void {
    const player = event.target as HTMLAudioElement;
    if (player) {
      player.playbackRate = this.selectedAudioSpeed;
      if (player.duration && isFinite(player.duration) && !isNaN(player.duration) && player.duration > 0) {
        this.audioDuration = player.duration;
      }
    }
  }
  followUpLeadsCanvas: any[] = [];

  get isSalesDepartment(): boolean {
    const dept = (this.userDepartment || localStorage.getItem("department") || "").toLowerCase();
    const role = (localStorage.getItem("role") || "").toLowerCase();
    if (dept.includes("admin") || role.includes("admin")) return false;
    if (dept.includes("assistant") || role.includes("assistant")) return false;
    return true;
  }

  get canCreateFollowUpTask(): boolean {
    if (this.isAdmin || this.isAssistantSalesUser || this.assistantUser) return false;
    return this.isSalesDepartment;
  }

  canvasTabs = [
    { id: 0, label: "Follow-up Task", icon: "/assets/leads/follow-up-task.svg", status: 'Follow-up Task', isFollowUpTask: true },
    { id: 1, label: "Not started", icon: "/assets/leads/assigned-lead-icon.png", status: 'Not started', notStarted: true },
    { id: 2, label: "Contacted", icon: "/assets/leads/circle-phone.png", status: 'Contacted', isProgress: true },
    { id: 3, label: "Email introduction", icon: "/assets/leads/email-tab.png", status: 'Email introduction', isProgress: true },
    { id: 4, label: "Meetings in Video call", icon: "/assets/leads/video-meeting.png", status: 'Meetings in Video call', isProgress: true },
    { id: 5, label: "Meetings in person", icon: "/assets/leads/meeting-icon.png", status: 'Meetings in person', isProgress: true },
    { id: 6, label: "Presentation", icon: "/assets/leads/presentation-icon.png", status: 'Presentation', isProgress: true },
    { id: 7, label: "Cost sheet", icon: "/assets/leads/cost-sheet-icon.png", status: 'Cost sheet', isProgress: true },
    { id: 8, label: "Closing Pool", icon: "/assets/leads/unicorn.svg", status: 'Closing Pool', isClosingPool: true },
    { id: 9, label: "Closed", icon: "/assets/leads/closed.png", status: 'Closed', isSuccess: true },
    { id: 10, label: "Lost", icon: "/assets/leads/lost-icon.png", status: 'Lost', isDanger: true },
    { id: 11, label: "Unqualified", icon: "/assets/leads/unqualified.png", status: 'Unqualified', isUnqualified: true }
  ];
  statusList = this.canvasTabs.map(tab => tab.label).filter(label => label !== 'Closing Pool' && label !== 'Follow-up Task');
  columnStatusMap = {
    0: "Follow-up Task",
    1: "Not started",
    2: "Contacted",
    3: "Email introduction",
    4: "Meetings in Video call",
    5: "Meetings in person",
    6: "Presentation",
    7: "Cost sheet",
    8: "Closing Pool",
    9: "Closed",
    10: "Lost",
    11: "Unqualified"
  };

  neverEnterPredicate = () => false;
  alwaysEnterPredicate = () => true;

  activeTabIndex = 0;
  emptyColumns = Array.from({ length: 10 }, (_, i) => ({
    index: i + 1,
    status: this.columnStatusMap[i + 2],
    items: [],
    pageNum: 1,
    totalCount: 0,
    loading: false
  }));



  // canvas / details
  // showCanvasUI = false;
  showDetailsPanel = false;
  assignedLeadsCanvas: any[] = [];
  selectedLeadForDetails: any = null;
  totalColumnsToLoad = 8;
  columnsLoaded = 0;
  autoScrollInterval: any = null;
  editorBlocks: EditorBlock[] = [
    { id: crypto.randomUUID(), type: 'text', value: '' }
  ];
  fullscreenPreview: {
    url: string;
    type: 'image' | 'video' | 'document';
    fileName: string;
  } | null = null;

  assistantTaskNote: string = '';
  assistantTaskReminderDueAt: string = '';
  isUpdatingTaskNote: boolean = false;
  isCompletingTask: boolean = false;
  updatedTaskIds: Set<string> = new Set<string>();

  // ================= FOLLOW-UP REMINDERS SECTION ================= //
  activeReminderTab: 'Today' | 'Upcoming' | 'Pending' | 'Completed' = 'Today';
  remindersTabs: Array<'Today' | 'Upcoming' | 'Pending' | 'Completed'> = ['Today', 'Upcoming', 'Pending', 'Completed'];
  remindersData: { [key: string]: any[] } = {
    Today: [],
    Upcoming: [],
    Pending: [],
    Completed: []
  };
  reminderCounts: { [key: string]: number } = {
    Today: 0,
    Upcoming: 0,
    Pending: 0,
    Completed: 0
  };
  isRemindersLoading: boolean = false;
  remindersPage: { [key: string]: number } = {
    Today: 1,
    Upcoming: 1,
    Pending: 1,
    Completed: 1
  };
  remindersLimit: number = 20;
  remindersHasMore: { [key: string]: boolean } = {
    Today: true,
    Upcoming: true,
    Pending: true,
    Completed: true
  };
  remindersLoadingMore: boolean = false;

  get displayedReminders(): any[] {
    return this.remindersData[this.activeReminderTab] || [];
  }

  getReminderCount(tab: string): number {
    return this.reminderCounts[tab] ?? (this.remindersData[tab]?.length || 0);
  }

  fetchFollowUpReminders(status?: 'Today' | 'Upcoming' | 'Pending' | 'Completed', isLoadMore = false) {
    const targetStatus = status || this.activeReminderTab;
    if (isLoadMore) {
      if (this.remindersLoadingMore || !this.remindersHasMore[targetStatus]) return;
      this.remindersLoadingMore = true;
      this.remindersPage[targetStatus] = (this.remindersPage[targetStatus] || 1) + 1;
    } else {
      this.isRemindersLoading = true;
      this.remindersPage[targetStatus] = 1;
      this.remindersHasMore[targetStatus] = true;
    }

    const isOutbound = (this.project || '').toUpperCase() === 'OUTBOUND';
    const payload: any = {
      project: this.project,
      page: this.remindersPage[targetStatus],
      limit: this.remindersLimit
    };

    if (targetStatus !== 'Today') {
      payload.status = targetStatus;
    }

    if (isOutbound) {
      payload.leadType = 'Outbound';
    }

    this.crmService.getFollowUpReminders(payload).subscribe({
      next: (res: any) => {
        if (isLoadMore) {
          this.remindersLoadingMore = false;
        } else {
          this.isRemindersLoading = false;
        }

        const resData = res?.data;
        let list: any[] = [];
        let totalCount = 0;

        if (Array.isArray(resData?.followUpReminders)) {
          list = resData.followUpReminders;
          totalCount = resData.totalCount ?? list.length;
        } else if (Array.isArray(resData?.reminders)) {
          list = resData.reminders;
          totalCount = resData.totalCount ?? list.length;
        } else if (Array.isArray(resData?.followUpRemindersData)) {
          list = resData.followUpRemindersData;
          totalCount = resData.totalCount ?? list.length;
        } else if (Array.isArray(resData?.data)) {
          list = resData.data;
          totalCount = resData.totalCount ?? list.length;
        } else if (Array.isArray(resData)) {
          list = resData;
          totalCount = res?.totalCount ?? res?.count ?? list.length;
        } else if (Array.isArray(res?.followUpReminders)) {
          list = res.followUpReminders;
          totalCount = res.totalCount ?? list.length;
        } else if (Array.isArray(res?.reminders)) {
          list = res.reminders;
          totalCount = res.totalCount ?? list.length;
        } else if (Array.isArray(res)) {
          list = res;
          totalCount = list.length;
        }

        if (isLoadMore) {
          this.remindersData[targetStatus] = this.sortRemindersByDate([
            ...(this.remindersData[targetStatus] || []),
            ...list
          ]);
        } else {
          this.remindersData[targetStatus] = this.sortRemindersByDate(list);
        }

        this.reminderCounts[targetStatus] = totalCount || this.remindersData[targetStatus].length;
        if (list.length < this.remindersLimit || (this.remindersData[targetStatus].length >= totalCount && totalCount > 0)) {
          this.remindersHasMore[targetStatus] = false;
        }
      },
      error: (err: any) => {
        if (isLoadMore) {
          this.remindersLoadingMore = false;
        } else {
          this.isRemindersLoading = false;
        }
        console.error(`Error fetching follow-up reminders (${targetStatus}):`, err);
      }
    });
  }

  fetchAllReminderCounts() {
    const isOutbound = (this.project || '').toUpperCase() === 'OUTBOUND';
    this.remindersTabs.forEach(tab => {
      if (tab !== this.activeReminderTab) {
        const payload: any = {
          project: this.project,
          page: 1,
          limit: this.remindersLimit
        };
        if (tab !== 'Today') {
          payload.status = tab;
        }
        if (isOutbound) payload.leadType = 'Outbound';

        this.crmService.getFollowUpReminders(payload).subscribe({
          next: (res: any) => {
            const resData = res?.data;
            let list: any[] = [];
            let total = 0;

            if (Array.isArray(resData?.followUpReminders)) {
              list = resData.followUpReminders;
              total = resData.totalCount ?? list.length;
            } else if (Array.isArray(resData?.reminders)) {
              list = resData.reminders;
              total = resData.totalCount ?? list.length;
            } else if (Array.isArray(resData?.followUpRemindersData)) {
              list = resData.followUpRemindersData;
              total = resData.totalCount ?? list.length;
            } else if (Array.isArray(resData?.data)) {
              list = resData.data;
              total = resData.totalCount ?? list.length;
            } else if (Array.isArray(resData)) {
              list = resData;
              total = res?.totalCount ?? res?.count ?? resData.length;
            } else if (Array.isArray(res?.followUpReminders)) {
              list = res.followUpReminders;
              total = res.totalCount ?? list.length;
            } else if (Array.isArray(res?.reminders)) {
              list = res.reminders;
              total = res.totalCount ?? list.length;
            } else if (Array.isArray(res)) {
              list = res;
              total = list.length;
            } else if (resData?.totalCount !== undefined) {
              total = resData.totalCount;
            } else if (res?.totalCount !== undefined) {
              total = res.totalCount;
            }

            this.reminderCounts[tab] = total || list.length;
            if (list.length > 0 && (!this.remindersData[tab] || this.remindersData[tab].length === 0)) {
              this.remindersData[tab] = this.sortRemindersByDate(list);
              if (list.length < this.remindersLimit || (list.length >= total && total > 0)) {
                this.remindersHasMore[tab] = false;
              }
            }
          },
          error: () => { }
        });
      }
    });
  }

  onReminderTabChange(tab: 'Today' | 'Upcoming' | 'Pending' | 'Completed') {
    this.activeReminderTab = tab;
    this.fetchFollowUpReminders(tab);
  }

  sortRemindersByDate(reminders: any[]): any[] {
    if (!Array.isArray(reminders)) return [];
    return [...reminders].sort((a, b) => {
      const dateA = new Date(a.dueAt || a.reminderDate || a.date || a.createdAt || 0).getTime() || 0;
      const dateB = new Date(b.dueAt || b.reminderDate || b.date || b.createdAt || 0).getTime() || 0;
      return dateA - dateB;
    });
  }

  hasReminderTime(dueAt?: string | Date | null): boolean {
    if (!dueAt) return false;
    const str = String(dueAt).trim();
    if (!str.includes('T') && !str.includes(':')) {
      return false;
    }
    if (str.includes('T00:00:00') || str.includes(' 00:00:00') || str.endsWith('T00:00:00.000Z') || str.endsWith('T00:00:00Z')) {
      return false;
    }
    return true;
  }

  getReminderLeadName(item: any): string {
    if (!item) return 'Lead';
    const lead = item.leadId || item.lead;
    if (typeof lead === 'object' && lead !== null) {
      return lead.name || lead.customerName || lead.companyName || lead.contactName || item.name || item.companyName || 'Lead';
    }
    return item.name || item.companyName || item.customerName || item.leadName || 'Lead';
  }

  getReminderLeadPhone(item: any): string {
    if (!item) return '';
    const lead = item.leadId || item.lead;
    if (typeof lead === 'object' && lead !== null) {
      return lead.phone || lead.phoneNumber || lead.mobile || '';
    }
    return item.phone || item.phoneNumber || item.mobile || '';
  }

  getReminderLeadProject(item: any): string {
    if (!item) return '';
    const lead = item.leadId || item.lead;
    if (typeof lead === 'object' && lead !== null) {
      return lead.project || item.project || '';
    }
    return item.project || '';
  }

  getReminderStatusBadge(status: string): { bg: string; color: string; border: string; icon: string } {
    const s = (status || '').toLowerCase();
    if (s === 'completed') {
      return { bg: '#dcfce7', color: '#15803d', border: '#bbf7d0', icon: 'fas fa-check-circle' };
    }
    if (s === 'upcoming') {
      return { bg: '#e0e7ff', color: '#4338ca', border: '#c7d2fe', icon: 'fas fa-calendar-alt' };
    }
    if (s === 'today') {
      return { bg: '#e0f2fe', color: '#0369a1', border: '#bae6fd', icon: 'fas fa-calendar-day' };
    }
    if (s === 'incomplete') {
      return { bg: '#fee2e2', color: '#b91c1c', border: '#fecaca', icon: 'fas fa-exclamation-circle' };
    }
    return { bg: '#fef3c7', color: '#b45309', border: '#fde68a', icon: 'fas fa-clock' };
  }

  updatingReminderId: string | null = null;

  hasUpcomingTaskScheduled(item: any): boolean {
    if (!item) return false;
    const targetStatus = (
      item?.targetStatus ||
      item?.status ||
      item?.meta?.targetStatus ||
      item?.meta?.status ||
      ''
    ).toString().trim().toLowerCase();

    const isClosed = targetStatus === 'closed' || targetStatus === 'closed won';
    return isClosed || item?.meta?.hasNextTaskScheduled === true || item?.hasNextTaskScheduled === true;
  }

  markReminderAsDone(item: any, event?: Event) {
    if (event) event.stopPropagation();
    if (!item) return;

    // Feature: only allow users to mark a reminder as "Completed" when they have an upcoming task scheduled or targetStatus is Closed
    const hasNextTask = this.hasUpcomingTaskScheduled(item);

    if (!hasNextTask) {
      const nextStatus = item?.targetStatus || item?.status || 'Next Status';
      alertModalNextTaskReminder(nextStatus).then(() => {
        this.openLeadFromReminder(item);
      });
      return;
    }

    const reminderId = item?._id || item?.id;
    if (!reminderId || this.updatingReminderId === reminderId) return;

    this.updatingReminderId = reminderId;
    const body: any = {
      status: 'Completed'
    };
    if (item.project) body.project = item.project;
    if (item.leadType) body.leadType = item.leadType;
    if (item.projectTab) body.projectTab = item.projectTab;

    this.crmService.updateFollowUpReminder(reminderId, body).subscribe({
      next: (res: any) => {
        this.updatingReminderId = null;
        alertModalWithoutConfirm('success', 'Reminder marked as Completed');

        // Immediate UI Update
        const oldStatus = item.status || this.activeReminderTab;
        item.status = 'Completed';

        if (this.activeReminderTab !== 'Completed') {
          if (this.remindersData[this.activeReminderTab]) {
            this.remindersData[this.activeReminderTab] = this.remindersData[this.activeReminderTab].filter(
              (r: any) => (r._id || r.id) !== reminderId
            );
          }
          this.reminderCounts[this.activeReminderTab] = Math.max(0, (this.reminderCounts[this.activeReminderTab] || 1) - 1);
        }

        if (oldStatus && oldStatus !== this.activeReminderTab && oldStatus !== 'Completed' && this.reminderCounts[oldStatus] !== undefined) {
          this.reminderCounts[oldStatus] = Math.max(0, (this.reminderCounts[oldStatus] || 1) - 1);
        }
        this.reminderCounts['Completed'] = (this.reminderCounts['Completed'] || 0) + 1;

        if (this.remindersData['Completed']) {
          const exists = this.remindersData['Completed'].some((r: any) => (r._id || r.id) === reminderId);
          if (!exists) {
            this.remindersData['Completed'] = [item, ...this.remindersData['Completed']];
          }
        }
      },
      error: (err: any) => {
        this.updatingReminderId = null;
        console.error('Failed to update follow-up reminder:', err);
        const errMsg = err?.error?.message || err?.message || 'Failed to mark reminder as Done';
        alertModalWithoutConfirm('error', errMsg);
      }
    });
  }

  openLeadFromReminder(item: any) {
    if (!item) return;
    const rawLead = item.leadId || item.lead;
    const isLeadObj = typeof rawLead === 'object' && rawLead !== null;
    const leadId = isLeadObj ? (rawLead._id || rawLead.id) : (typeof rawLead === 'string' ? rawLead : (item.lead_id || item._id));
    const proj = (isLeadObj && rawLead.project) ? rawLead.project : (item.project || this.project);
    const source = (isLeadObj && (rawLead.source || rawLead.projectTab)) ? (rawLead.source || rawLead.projectTab) : (item.projectTab || item.source || item.sourceLead || 'Email');

    const initialLeadData: any = {
      _id: leadId,
      id: leadId,
      leadName: (isLeadObj && (rawLead.leadName || rawLead.name || rawLead.customerName || rawLead.contactName)) || item.name || item.leadName || item.customerName || item.contactName || '',
      name: (isLeadObj && (rawLead.name || rawLead.leadName || rawLead.customerName || rawLead.contactName)) || item.name || item.leadName || item.customerName || item.contactName || '',
      companyName: (isLeadObj && rawLead.companyName) || item.companyName || '',
      phoneNo: (isLeadObj && (rawLead.phoneNo || rawLead.phone || rawLead.phoneNumber || rawLead.mobile)) || item.phone || item.phoneNumber || item.mobile || '',
      email: (isLeadObj && rawLead.email) || item.email || '',
      designation: (isLeadObj && rawLead.designation) || item.designation || '',
      status: (isLeadObj && rawLead.status) || item.targetStatus || item.status || '',
      customerValue: (isLeadObj && (rawLead.customerValue || rawLead.badge)) || item.customerValue || item.badge || '',
      project: proj,
      source: source,
      projectTab: source,
      ...(isLeadObj ? rawLead : {})
    };

    if (leadId) {
      const currentSectionProject = this.project || 'ALL';
      const moduleRoute = this.getModuleRouteByProject(currentSectionProject);

      this.currentView = 'kanban';
      if (!this.salesUsers || this.salesUsers.length === 0) {
        this.getSalesUserList();
      }
      this.router.navigate([`/lead-track/${moduleRoute}`], { queryParams: { view: 'kanban' } });
      this.loadAllColumns();
      this.openDetailsPanel(initialLeadData);
    }
  }

  updateRemindersHasNextTaskScheduled(leadId: string) {
    if (!leadId) return;
    const targetLeadId = String(leadId);
    Object.keys(this.remindersData).forEach(tabKey => {
      if (Array.isArray(this.remindersData[tabKey])) {
        this.remindersData[tabKey].forEach((rem: any) => {
          const remLeadId = String(rem?.leadId?._id || rem?.leadId || rem?.lead?._id || rem?.lead || '');
          if (remLeadId === targetLeadId) {
            if (!rem.meta) rem.meta = {};
            rem.meta.hasNextTaskScheduled = true;
            rem.hasNextTaskScheduled = true;
          }
        });
      }
    });
  }



  isFollowUpTaskUpdated(task?: any): boolean {
    const t = task || this.activeFollowUpTask;
    if (!t) return false;
    const taskId = String(t._id || t.id || '');

    if (taskId && this.updatedTaskIds.has(taskId)) {
      return true;
    }

    if (t.note && typeof t.note === 'string' && t.note.trim().length > 0) {
      return true;
    }

    const rawDispositions = this.dispositions || this.singleLead?.dispositionStatus || [];
    if (Array.isArray(rawDispositions) && rawDispositions.length > 0) {
      const hasUpdateEvent = rawDispositions.some((d: any) => {
        const ev = String(d?.event || '').trim().toLowerCase();
        const dTaskId = String(d?.meta?.taskId || d?.taskId || d?._id || '');
        return (ev.includes('task updated') || ev.includes('task note updated') || ev.includes('follow-up updated')) && (!taskId || dTaskId === taskId);
      });
      if (hasUpdateEvent) return true;
    }

    return false;
  }

  get activeFollowUpTask(): any {
    const tasks = this.followUpTasks || this.singleLead?.followUpTasks || this.selectedLead?.followUpTasks || this.selectedLeadForDetails?.followUpTasks || [];
    if (Array.isArray(tasks) && tasks.length > 0) {
      const active = tasks.find((t: any) => {
        if (!t) return false;
        const isDone = t.isCompleted === true || t.isCompleted === 'true' || String(t.status || '').toLowerCase() === 'completed' || String(t.status || '').toLowerCase() === 'done';
        return !isDone;
      });
      if (active) return active;
    }

    const rawDispositions = this.dispositions || this.singleLead?.dispositionStatus || this.selectedLead?.dispositionStatus || [];
    if (Array.isArray(rawDispositions) && rawDispositions.length > 0) {
      const createdTasks = new Map<string, any>();
      const completedTaskIds = new Set<string>();

      rawDispositions.forEach((d: any) => {
        if (!d) return;
        const ev = String(d.event || '').trim().toLowerCase();
        const taskId = String(d.meta?.taskId || d.taskId || d._id || '');
        if (ev.includes('completed')) {
          if (taskId) completedTaskIds.add(taskId);
        } else if (ev.includes('created') || ev.includes('updated')) {
          if (taskId && !createdTasks.has(taskId)) {
            createdTasks.set(taskId, d);
          }
        }
      });

      for (const [tId, d] of createdTasks.entries()) {
        if (!completedTaskIds.has(tId)) {
          return {
            _id: tId,
            id: tId,
            isCompleted: false,
            assignee: d.meta?.assignee || d.assignee,
            taskDescription: d.meta?.taskDescription || d.note || ''
          };
        }
      }
    }

    return null;
  }

  get hasActiveFollowUpTask(): boolean {
    return !!this.activeFollowUpTask;
  }

  get canShowAssistantTaskActionBox(): boolean {
    const task = this.activeFollowUpTask;
    if (!task || task.isCompleted) return false;

    const loggedInId = String(this.userId || localStorage.getItem("guestID") || localStorage.getItem("userId") || localStorage.getItem("_id") || "").trim();
    const loggedInName = String(this.loggedInUserName || localStorage.getItem("username") || localStorage.getItem("userName") || localStorage.getItem("name") || "").trim().toLowerCase();

    if (!loggedInId && !loggedInName) return false;

    const assigneeObj = task.assignee || task.assignedTo || task.followUpAssignedTo;
    if (!assigneeObj) return false;

    const checkMatch = (item: any): boolean => {
      if (!item) return false;
      if (typeof item === 'string') {
        const trimmed = item.trim().toLowerCase();
        if (loggedInId && trimmed === loggedInId.toLowerCase()) return true;
        if (loggedInName && trimmed === loggedInName) return true;
        return false;
      }
      if (typeof item === 'object') {
        const id = String(item.userId || item._id || item.id || '').trim();
        const name = String(item.userName || item.username || item.name || '').trim().toLowerCase();

        if (id && loggedInId && id.toLowerCase() === loggedInId.toLowerCase()) return true;
        if (name && loggedInName && name === loggedInName) return true;
      }
      return false;
    };

    if (Array.isArray(assigneeObj)) {
      return assigneeObj.some(item => checkMatch(item));
    }

    return checkMatch(assigneeObj);
  }

  get formattedFollowUpTaskLogs(): any[] {
    const rawDispositions = this.dispositions || this.singleLead?.dispositionStatus || [];

    if (rawDispositions.length > 0) {
      const logs: any[] = [];
      rawDispositions.forEach((item: any, index: number) => {
        if (!item) return;
        const eventName = (item.event || '').trim().toLowerCase();
        if (
          eventName === 'follow up task created' ||
          eventName === 'follow-up task created' ||
          eventName === 'followup task created' ||
          eventName === 'follow up task updated' ||
          eventName === 'follow-up task updated' ||
          eventName === 'followup task updated' ||
          eventName === 'follow up task completed' ||
          eventName === 'follow-up task completed' ||
          eventName === 'followup task completed'
        ) {
          const meta = item.meta || {};
          const timestamp = item.createdAt || item.updatedAt || meta.createdAt || meta.updatedAt;
          const seqNo = index + 1;

          if (eventName.includes('completed')) {
            logs.push({
              id: item._id,
              seqNo: seqNo,
              taskId: meta.taskId || item._id,
              logType: 'completed',
              timestamp: timestamp,
              assigneeName: meta.assignee?.userName || meta.assignee?.name || item.assignee?.userName || '-',
              note: meta.note || item.note || ''
            });
          } else if (eventName.includes('updated')) {
            logs.push({
              id: item._id,
              seqNo: seqNo,
              taskId: meta.taskId || item._id,
              logType: 'updated',
              timestamp: timestamp,
              assigneeName: meta.assignee?.userName || meta.assignee?.name || item.assignee?.userName || '-',
              note: meta.note || item.note || ''
            });
          } else {
            // Created
            logs.push({
              id: item._id,
              seqNo: seqNo,
              taskId: meta.taskId || item._id,
              logType: 'created',
              timestamp: timestamp,
              assignedByName: meta.assignedBy?.userName || meta.assignedBy?.name || item.assignedBy?.userName || 'Sales',
              assigneeName: meta.assignee?.userName || meta.assignee?.name || item.assignee?.userName || '-',
              note: meta.taskDescription || item.taskDescription || meta.note || item.note || ''
            });
          }
        }
      });

      if (logs.length > 0) {
        return logs.sort((a: any, b: any) => {
          const timeA = new Date(a.timestamp).getTime() || 0;
          const timeB = new Date(b.timestamp).getTime() || 0;
          return timeB - timeA;
        });
      }
    }

    // Fallback: If no disposition task events exist, use followUpTasks array
    if (!this.followUpTasks || !this.followUpTasks.length) return [];
    const fallbackLogs: any[] = [];
    let currentSeq = 1;

    this.followUpTasks.forEach((task: any) => {
      const assigneeName = task.assignee?.userName || task.assignee?.name || '-';
      const assigneeProfileImg = task.assignee?.profileImg || this.salesUsers?.find((u: any) => u.userName === assigneeName)?.profileImg || '';
      const assignedByName = task.assignedBy?.userName || task.assignedBy?.name || 'Sales';
      const assignedByProfileImg = task.assignedBy?.profileImg || this.salesUsers?.find((u: any) => u.userName === assignedByName)?.profileImg || '';

      // 1. Task Created entry
      fallbackLogs.push({
        id: (task._id || task.id) + '_created',
        seqNo: currentSeq++,
        taskId: task._id || task.id,
        isFollowUpTaskEvent: true,
        logType: 'created',
        timestamp: task.createdAt || task.updatedAt,
        assignedByName: assignedByName,
        assignedByProfileImg: assignedByProfileImg,
        assigneeName: assigneeName,
        assigneeProfileImg: assigneeProfileImg,
        note: task.taskDescription || ''
      });

      // 2. Task Updated entry if updated and not completed
      if (task.note && task.note.trim() && !task.isCompleted) {
        fallbackLogs.push({
          id: (task._id || task.id) + '_updated',
          seqNo: currentSeq++,
          taskId: task._id || task.id,
          isFollowUpTaskEvent: true,
          logType: 'updated',
          timestamp: task.updatedAt || task.createdAt,
          assigneeName: assigneeName,
          assigneeProfileImg: assigneeProfileImg,
          note: task.note
        });
      }

      // 3. Task Completed entry
      if (task.isCompleted) {
        fallbackLogs.push({
          id: (task._id || task.id) + '_completed',
          seqNo: currentSeq++,
          taskId: task._id || task.id,
          isFollowUpTaskEvent: true,
          logType: 'completed',
          timestamp: task.updatedAt || task.createdAt,
          assigneeName: assigneeName,
          assigneeProfileImg: assigneeProfileImg,
          note: task.note || ''
        });
      }
    });

    return fallbackLogs.sort((a: any, b: any) => {
      const timeA = new Date(a.timestamp).getTime() || 0;
      const timeB = new Date(b.timestamp).getTime() || 0;
      return timeB - timeA;
    });
  }

  get formattedDispositions(): any[] {
    const rawDispositions = this.dispositions || this.singleLead?.dispositionStatus || [];
    if (!rawDispositions || !rawDispositions.length) return [];


    const sortedChronological = [...rawDispositions].sort((a: any, b: any) => {
      const timeA = new Date(a.createdAt || a.timestamp || a.updatedAt || a.meta?.createdAt || a.meta?.updatedAt || 0).getTime() || 0;
      const timeB = new Date(b.createdAt || b.timestamp || b.updatedAt || b.meta?.createdAt || b.meta?.updatedAt || 0).getTime() || 0;
      return timeA - timeB;
    });

    const mapped = sortedChronological.map((item: any, index: number) => {
      const eventName = (item.event || '').trim().toLowerCase();
      const meta = item.meta || {};
      const timestamp = item.createdAt || item.updatedAt || item.timestamp || meta.createdAt || meta.updatedAt;
      const seqNo = index + 1;

      // 1. Follow Up Task Events
      if (
        eventName === DISPOSITION_EVENT.FOLLOW_UP_TASK_CREATED.toLowerCase() ||
        eventName === DISPOSITION_EVENT.FOLLOW_UP_TASK_UPDATED.toLowerCase() ||
        eventName === DISPOSITION_EVENT.FOLLOW_UP_TASK_COMPLETED.toLowerCase() ||
        eventName.includes('follow up task') ||
        eventName.includes('follow-up task') ||
        eventName.includes('followup task')
      ) {
        const taskId = meta.taskId || item.taskId || item._id;
        const matchedTask = (this.followUpTasks || []).find((t: any) => (t._id || t.id) === taskId);
        const assigneeName = meta.assignee?.userName || meta.assignee?.name || item.assignee?.userName || matchedTask?.assignee?.userName || '-';
        const assigneeProfileImg = meta.assignee?.profileImg || item.assignee?.profileImg || matchedTask?.assignee?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assigneeName || u.name === assigneeName)?.profileImg) || '';
        const assignedByName = meta.assignedBy?.userName || meta.assignedBy?.name || item.assignedBy?.userName || matchedTask?.assignedBy?.userName || 'Sales';
        const assignedByProfileImg = meta.assignedBy?.profileImg || item.assignedBy?.profileImg || matchedTask?.assignedBy?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assignedByName || u.name === assignedByName)?.profileImg) || '';

        if (eventName.includes('completed')) {
          return {
            ...item,
            isFollowUpTaskEvent: true,
            id: item._id,
            seqNo: seqNo,
            taskId: taskId,
            logType: 'completed',
            timestamp: timestamp,
            createdAt: item.createdAt || timestamp,
            updatedAt: item.updatedAt || timestamp,
            assigneeName: assigneeName,
            assigneeProfileImg: assigneeProfileImg,
            note: meta.note || item.note || ''
          };
        } else if (eventName.includes('updated')) {
          return {
            ...item,
            isFollowUpTaskEvent: true,
            id: item._id,
            seqNo: seqNo,
            taskId: taskId,
            logType: 'updated',
            timestamp: timestamp,
            createdAt: item.createdAt || timestamp,
            updatedAt: item.updatedAt || timestamp,
            assigneeName: assigneeName,
            assigneeProfileImg: assigneeProfileImg,
            note: meta.note || item.note || ''
          };
        } else {
          return {
            ...item,
            isFollowUpTaskEvent: true,
            id: item._id,
            seqNo: seqNo,
            taskId: taskId,
            logType: 'created',
            timestamp: timestamp,
            createdAt: item.createdAt || timestamp,
            updatedAt: item.updatedAt || timestamp,
            assignedByName: assignedByName,
            assignedByProfileImg: assignedByProfileImg,
            assigneeName: assigneeName,
            assigneeProfileImg: assigneeProfileImg,
            note: meta.taskDescription || item.taskDescription || meta.note || item.note || ''
          };
        }
      }

      // 2. Lead Reassigned Event
      if (
        eventName === DISPOSITION_EVENT.LEAD_REASSIGNED.toLowerCase() ||
        eventName === 'lead reassigned' ||
        eventName === 'lead_reassigned'
      ) {
        const reassignedByName = meta.reassignedBy?.userName || meta.reassignedBy?.name || item.reassignedBy?.userName || item.userName || 'System';
        const reassignedByProfileImg = meta.reassignedBy?.profileImg || item.reassignedBy?.profileImg || (this.salesUsers?.find((u: any) => u.userName === reassignedByName || u.name === reassignedByName)?.profileImg) || '';
        const reassignedToName = meta.reassignedTo?.userName || meta.reassignedTo?.name || item.reassignedTo?.userName || item.followUpAssignedTo?.userName || '-';
        const reassignedToProfileImg = meta.reassignedTo?.profileImg || item.reassignedTo?.profileImg || (this.salesUsers?.find((u: any) => u.userName === reassignedToName || u.name === reassignedToName)?.profileImg) || '';
        const previousAssigneeName = meta.previousAssignee?.userName || meta.previousAssignee?.name || item.previousAssignee?.userName || '';
        const previousAssigneeProfileImg = meta.previousAssignee?.profileImg || item.previousAssignee?.profileImg || (this.salesUsers?.find((u: any) => u.userName === previousAssigneeName || u.name === previousAssigneeName)?.profileImg) || '';

        return {
          ...item,
          isLeadReassignedEvent: true,
          id: item._id,
          seqNo: seqNo,
          timestamp: timestamp,
          createdAt: item.createdAt || timestamp,
          updatedAt: item.updatedAt || timestamp,
          reassignedByName: reassignedByName,
          reassignedByProfileImg: reassignedByProfileImg,
          reassignedToName: reassignedToName,
          reassignedToProfileImg: reassignedToProfileImg,
          previousAssigneeName: previousAssigneeName,
          previousAssigneeProfileImg: previousAssigneeProfileImg,
          note: ''
        };
      }

      // 3. Lead Follow Up Assigned Event
      if (
        eventName === DISPOSITION_EVENT.LEAD_FOLLOW_UP_ASSIGNED.toLowerCase() ||
        eventName === 'lead follow up assigned' ||
        eventName === 'lead follow-up assigned' ||
        eventName === 'lead followup assigned'
      ) {
        const assignedByName = meta.assignedBy?.userName || meta.assignedBy?.name || item.assignedBy?.userName || item.userName || 'System';
        const assignedByProfileImg = meta.assignedBy?.profileImg || item.assignedBy?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assignedByName || u.name === assignedByName)?.profileImg) || '';
        const assignedToName = meta.assignedTo?.userName || meta.assignedTo?.name || item.assignedTo?.userName || meta.assignee?.userName || item.userName || '-';
        const assignedToProfileImg = meta.assignedTo?.profileImg || item.assignedTo?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assignedToName || u.name === assignedToName)?.profileImg) || '';

        return {
          ...item,
          isLeadFollowUpAssignedEvent: true,
          id: item._id,
          seqNo: seqNo,
          timestamp: timestamp,
          createdAt: item.createdAt || timestamp,
          updatedAt: item.updatedAt || timestamp,
          assignedByName: assignedByName,
          assignedByProfileImg: assignedByProfileImg,
          assignedToName: assignedToName,
          assignedToProfileImg: assignedToProfileImg,
          note: meta.note || item.note || ''
        };
      }

      // 4. Lead Assigned Event
      if (
        eventName === DISPOSITION_EVENT.LEAD_ASSIGNED.toLowerCase() ||
        eventName === 'lead assigned' ||
        eventName === 'lead_assigned'
      ) {
        const assignedByName = meta.assignedBy?.userName || meta.assignedBy?.name || item.assignedBy?.userName || item.userName || 'System';
        const assignedByProfileImg = meta.assignedBy?.profileImg || item.assignedBy?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assignedByName || u.name === assignedByName)?.profileImg) || '';
        const assignedToName = meta.assignedTo?.userName || meta.assignedTo?.name || item.assignedTo?.userName || meta.assignee?.userName || item.userName || '-';
        const assignedToProfileImg = meta.assignedTo?.profileImg || item.assignedTo?.profileImg || (this.salesUsers?.find((u: any) => u.userName === assignedToName || u.name === assignedToName)?.profileImg) || '';

        return {
          ...item,
          isLeadAssignedEvent: true,
          id: item._id,
          seqNo: seqNo,
          timestamp: timestamp,
          createdAt: item.createdAt || timestamp,
          updatedAt: item.updatedAt || timestamp,
          assignedByName: assignedByName,
          assignedByProfileImg: assignedByProfileImg,
          assignedToName: assignedToName,
          assignedToProfileImg: assignedToProfileImg,
          note: ''
        };
      }

      // 5. Closing Pool Update Event
      if (
        eventName === DISPOSITION_EVENT.CLOSING_POOL_UPDATE.toLowerCase() ||
        eventName === 'closing pool update' ||
        eventName === 'closing_pool_update' ||
        item.hasClosingPotential !== undefined ||
        meta.hasClosingPotential !== undefined
      ) {
        return {
          ...item,
          isClosingPoolEvent: true,
          id: item._id,
          seqNo: seqNo,
          timestamp: timestamp,
          createdAt: item.createdAt || timestamp,
          updatedAt: item.updatedAt || timestamp,
          hasClosingPotential: item.hasClosingPotential !== undefined ? item.hasClosingPotential : meta.hasClosingPotential
        };
      }

      // 6. Status Update Event
      if (
        eventName === DISPOSITION_EVENT.STATUS_UPDATE.toLowerCase() ||
        eventName === 'status update' ||
        eventName === 'status_update' ||
        (item.type === 'System' && item.status && item.prevStatus && item.prevStatus !== item.status)
      ) {
        return {
          ...item,
          isStatusUpdateEvent: true,
          id: item._id,
          seqNo: seqNo,
          timestamp: timestamp,
          createdAt: item.createdAt || timestamp,
          updatedAt: item.updatedAt || timestamp,
          prevStatus: item.prevStatus || meta.prevStatus || '-',
          status: item.status || meta.status || '-'
        };
      }

      // 7. User Note / General Disposition
      return {
        ...item,
        isUserNote: true,
        id: item._id,
        seqNo: seqNo,
        timestamp: timestamp,
        createdAt: item.createdAt || timestamp,
        updatedAt: item.updatedAt || timestamp,
        userName: item.userName || meta.userName || '-',
        status: item.status || meta.status || '',
        note: item.note || meta.note || ''
      };
    });

    return mapped.sort((a: any, b: any) => {
      const timeA = new Date(a.createdAt || a.timestamp || a.updatedAt || 0).getTime() || 0;
      const timeB = new Date(b.createdAt || b.timestamp || b.updatedAt || 0).getTime() || 0;
      return timeB - timeA;
    });
  }

  updateAssistantTaskNote() {
    const task = this.activeFollowUpTask;
    if (!task || !task._id) return;

    if (!this.assistantTaskNote?.trim()) return;

    this.isUpdatingTaskNote = true;
    const targetLead = this.selectedLead || this.selectedLeadForDetails || this.singleLead;
    const leadObj = targetLead || {};
    const targetProject = task?.project || this.getActualLeadProject(leadObj) || this.project;
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);

    const body: any = {
      note: this.assistantTaskNote.trim(),
      redirectUrl: redirectUrl
    };

    this.crmService.updateFollowUpTask(task._id, body).subscribe({
      next: (res: any) => {
        this.isUpdatingTaskNote = false;
        const taskId = String(task._id || task.id || '');
        if (taskId) {
          this.updatedTaskIds.add(taskId);
        }
        task.note = this.assistantTaskNote.trim();
        this.assistantTaskNote = '';
        alertModalWithoutConfirm('success', 'Follow-up task updated successfully');
        const targetLeadId = this.selectedLead?._id || this.selectedLeadForDetails?._id || this.singleLead?._id;
        if (targetLeadId) {
          this.getSingleLeadById(targetLeadId);
        }
      },
      error: (err: any) => {
        this.isUpdatingTaskNote = false;
        console.error('Error updating follow up task note:', err);
        alertModalWithoutConfirm('error', 'Failed to update follow-up task note');
      }
    });
  }

  markAssistantTaskDone() {
    const task = this.activeFollowUpTask;
    if (!task || !task._id) return;
    if (!this.assistantTaskNote?.trim()) return;
    if (!this.showReminderSection || !this.reminderDueAt || !this.reminderDueTime) {
      alertModalWithoutConfirm('warning', 'Please add a disposition log and set reminder due date and time before marking the task as Done');
      return;
    }

    this.isCompletingTask = true;
    const targetLead = this.selectedLead || this.selectedLeadForDetails || this.singleLead;
    const leadObj = targetLead || {};
    const targetProject = task?.project || this.getActualLeadProject(leadObj) || this.project;
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);
    const isOutbound = this.isOutboundLead(leadObj);
    const rawTab = leadObj?.projectTab || leadObj?.source || leadObj?.sourceLead;
    let projectTab = rawTab;
    const upperProj = (targetProject || '').toUpperCase();
    if (upperProj === 'IIC-LAB' || upperProj === 'IIC' || upperProj === 'V-ESTATE') {
      projectTab = rawTab || 'IVR';
    }

    const taskBody: any = {
      isCompleted: true,
      note: this.assistantTaskNote ? this.assistantTaskNote.trim() : '',
      redirectUrl: redirectUrl
    };

    let dueAtIso: string;
    try {
      if (this.reminderDueTime) {
        dueAtIso = new Date(`${this.reminderDueAt}T${this.reminderDueTime}`).toISOString();
      } else {
        dueAtIso = new Date(this.reminderDueAt).toISOString();
      }
    } catch (e) {
      dueAtIso = new Date().toISOString();
    }

    const selectedStatus = this.selectedReminderStatus || this.pendingReminderTargetStatus || leadObj?.status || this.selectedDispositionStatus || 'Follow-up Task';

    const reminderPayload: any = {
      targetStatus: selectedStatus,
      leadId: leadObj?._id,
      dueAt: dueAtIso
    };

    if (isOutbound) {
      reminderPayload.leadType = 'Outbound';
    } else {
      reminderPayload.project = targetProject;
      if (projectTab) {
        reminderPayload.projectTab = projectTab;
      }
      if (leadObj?.leadType) {
        reminderPayload.leadType = leadObj.leadType;
      } else if (leadObj?.sourceLead || leadObj?.source) {
        reminderPayload.leadType = leadObj.sourceLead || leadObj.source;
      } else {
        reminderPayload.leadType = 'Inbound';
      }
    }

    const requests: any = {
      taskUpdate: this.crmService.updateFollowUpTask(task._id, taskBody),
      reminder: this.crmService.createFollowUpReminder(reminderPayload)
    };

    if (this.pendingDispositionsPayloads && this.pendingDispositionsPayloads.length > 0) {
      requests.dispositions = forkJoin(
        this.pendingDispositionsPayloads.map(item => this.crmService.createDisposition(item.payload))
      );
    }

    forkJoin(requests).subscribe({
      next: (res: any) => {
        this.isCompletingTask = false;
        task.isCompleted = true;
        if (Array.isArray(this.followUpTasks)) {
          const matched = this.followUpTasks.find((t: any) => (t._id || t.id) === (task._id || task.id));
          if (matched) {
            matched.isCompleted = true;
            matched.note = taskBody.note;
          }
        }
        if (res.dispositions && Array.isArray(res.dispositions)) {
          res.dispositions.forEach((apiRes: any, i: number) => {
            const tempId = this.pendingDispositionsPayloads[i]?.tempId || this.pendingDispositions[i]?._id;
            const apiData = apiRes?.data || {};
            const realId = apiData._id || tempId;
            const realCreatedAt = apiData.createdAt;
            const realUpdatedAt = apiData.updatedAt;

            const index = this.dispositions.findIndex(d => d._id === tempId);
            if (index > -1) {
              this.dispositions[index] = {
                ...this.dispositions[index],
                ...apiData,
                _id: realId,
                ...(realCreatedAt ? { createdAt: realCreatedAt } : {}),
                ...(realUpdatedAt ? { updatedAt: realUpdatedAt } : {})
              };
            }

            if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
              const sIndex = this.singleLead.dispositionStatus.findIndex((d: any) => d._id === tempId);
              if (sIndex > -1) {
                this.singleLead.dispositionStatus[sIndex] = {
                  ...this.singleLead.dispositionStatus[sIndex],
                  ...apiData,
                  _id: realId,
                  ...(realCreatedAt ? { createdAt: realCreatedAt } : {}),
                  ...(realUpdatedAt ? { updatedAt: realUpdatedAt } : {})
                };
              }
            }
          });
          this.dispositions = [...this.dispositions];
          if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
            this.singleLead.dispositionStatus = [...this.singleLead.dispositionStatus];
          }
          this.pendingDispositions = [];
          this.pendingDispositionsPayloads = [];
          this.dispositionDirty = false;
        }

        this.assistantTaskNote = '';
        this.assistantTaskReminderDueAt = '';
        this.reminderDueAt = '';
        this.reminderDueTime = '';
        this.showReminderSection = false;
        alertModalWithoutConfirm('success', 'Follow-up task marked as done');
        const targetLeadId = this.selectedLead?._id || this.selectedLeadForDetails?._id || this.singleLead?._id;
        if (targetLeadId) {
          this.getSingleLeadById(targetLeadId);
          this.updateRemindersHasNextTaskScheduled(targetLeadId);
        }
        this.fetchFollowUpReminders();
        this.fetchAllReminderCounts();
        if (this.currentView === 'kanban') {
          this.loadAllColumns();
        }
      },
      error: (err: any) => {
        this.isCompletingTask = false;
        console.error('Error completing follow up task with reminder:', err);
        alertModalWithoutConfirm('error', 'Failed to mark follow-up task as Done');
      }
    });
  }


  showLogoUploadModal = false;
  logoPreview: string | null = null;
  selectedLogoFile: File | null = null;
  imageChangedEvent: any = '';
  showCropper = false;
  private lastCroppedEvent?: ImageCroppedEvent;
  transform: any = { scale: 1 };
  lossReason: string = "";
  showLostReason: boolean = false;
  selectedLeadStatus: string = "";
  selectedStatusIcon: string | null = null;
  statusDropdownOpen: boolean = false;
  selectedAssignedUser: string = "";
  newsLetter: any[] = [];
  newsLetterTable = false;
  iicContact = true;
  newsLetterLength: number = 0;
  selectedUserForLead: string = "";
  selectedAssignee: any = null;
  assignedLeads: any[] = [];
  totalAssignedCount: any;
  projectTab: string = "ALL";

  isIvrLead(lead: any): boolean {
    if (!lead) return false;
    const src = String(lead.source || lead.projectTab || lead.sourceLead || '').toLowerCase();
    return src === 'ivr';
  }

  getMessageWithDemoDate(lead: any): string {
    if (!lead) return 'No message';

    const isIvr = this.isIvrLead(lead);
    const rawMsg = lead.message || lead.note || lead.notes;
    let message = rawMsg || 'No message';
    if (isIvr && !lead.extractedRecordingUrl && (!rawMsg || rawMsg === 'No message')) {
      message = 'No recording available for this call';
    }

    if ((lead.project === 'V-ESTATE' || lead.project === 'V-RETAIL') &&
      (lead.source === 'Book Demo' || lead.source === 'Book A Demo') &&
      lead.demoDate) {
      const datePipe = new DatePipe('en-US');
      const demoDate = new Date(lead.demoDate);
      const formattedDemoDate = datePipe.transform(demoDate, 'dd-MM-yyyy') || lead.demoDate;
      const formattedDemoTime = datePipe.transform(demoDate, 'hh:mm a') || '';
      return formattedDemoTime
        ? `${message}\n\n\nDemo Date: ${formattedDemoDate}\nDemo Time: ${formattedDemoTime}`
        : `${message}\n\n\nDemo Date: ${formattedDemoDate}`;
    }

    return message;
  }

  isEmailLead(lead: any): boolean {
    if (!lead) return false;
    const source = String(lead.source || lead.projectTab || lead.sourceLead || '').toLowerCase();
    return source === 'email';
  }

  getLeadDisplayMessage(lead: any): string {
    if (!lead) return '-';
    const msg = this.getMessageWithDemoDate(lead);
    if (this.isEmailLead(lead) && lead?.subject) {
      return `Subject: ${lead.subject}\n\n${msg}`;
    }
    return msg;
  }

  @ViewChild('salesWaCard') salesWaCard?: WhatsappMessagesCardComponent;

  viewWhatsAppDetail(lead: any): void {
    if (!lead?.phoneNo) return;
    if (this.salesWaCard) {
      this.salesWaCard.openDetailModal();
    }
  }

  shiftToIICLeads(leadId: string) {
    if (!leadId) return;

    this.crmService.transferLead(leadId).subscribe({
      next: (res: any) => {
        alertModalWithoutConfirm('success', 'Lead successfully shifted to IIC Leads!');
        if (typeof (this as any).getLeadsListingDetail === 'function') {
          (this as any).getLeadsListingDetail();
        }
        if (typeof (this as any).fetchLeads === 'function') {
          (this as any).fetchLeads();
        }
      },
      error: (err: any) => {
        console.error('Error shifting lead to IIC:', err);
        const msg = err?.error?.message || err?.message || 'Failed to shift lead to IIC Leads.';
        alertModalWithoutConfirm('error', msg);
      }
    });
  }

  private cleanupModalBackdrop(): void {
    document.querySelectorAll('.modal-backdrop, .modal-backdrop.show, .upload-modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  constructor(
    private crmService: CrmService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private chatService: ChatService,
    private fb: FormBuilder,
    private soundService: NotificationSoundService,
    private themeService: ThemeService,
    private http: HttpClient,
    private zone: NgZone,
    private cdr: ChangeDetectorRef
  ) {
    this.initializeForm();
    //  this.initSalesChart([], [], []); 
  }
  userDepartment: any;
  salesUser: any;
  userRole: any;
  timeOptions: string[] = [];
  todayDate: string = '';
  isStatsLoading = true;
  currentView: 'dashboard' | 'kanban' = 'dashboard';


  indianPhoneValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const raw = control.value.replace(/\s+/g, '');
    const normalized = raw.startsWith('+91')
      ? raw.slice(3)
      : raw.startsWith('91')
        ? raw.slice(2)
        : raw;
    const isValid = /^[6-9]\d{9}$/.test(normalized);
    return isValid ? null : { invalidPhone: true };
  }
  userId: any;

  formatAssignedTo(assignedTo: any, isHtml: boolean = false): string {
    if (!assignedTo) return "";

    const loggedInId = this.userId || localStorage.getItem("guestID") || "";
    const loggedInName = this.loggedInUserName || localStorage.getItem("username") || localStorage.getItem("userName") || "";

    const formatItem = (item: any) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      const userName = item.userName || item.assigneeName || item.username || "";
      if (!userName) return "";

      const assignedByName = item.assignedByName;
      const assignedById = item.assignedById;

      let byText = "";
      if (assignedById && loggedInId && String(assignedById) === String(loggedInId)) {
        byText = "by Me";
      } else if (assignedByName && loggedInName && String(assignedByName).trim().toLowerCase() === String(loggedInName).trim().toLowerCase()) {
        byText = "by Me";
      } else if (assignedByName) {
        byText = `by ${assignedByName}`;
      }

      if (!byText) return userName;

      return isHtml
        ? `${userName}<span class="d-block" style="font-size: 13px; color: grey; font-weight: 400; line-height: 1.2;">(${byText})</span>`
        : `${userName}\n(${byText})`;
    };

    if (Array.isArray(assignedTo)) {
      return assignedTo.map((a) => formatItem(a)).filter(Boolean).join(", ");
    }

    if (typeof assignedTo === "object") {
      return formatItem(assignedTo);
    }

    return String(assignedTo);
  }

  getAssignedToDisplay(lead: any, isHtml: boolean = false): string {
    if (!lead) return "-";
    if (lead.assignedTo) {
      const formatted = this.formatAssignedTo(lead.assignedTo, isHtml);
      if (formatted) return formatted;
    }
    if (lead.assignedToString) {
      return lead.assignedToString;
    }
    return "-";
  }

  getAssignedByName(lead: any): string {
    if (!lead) return "-";
    const assignedObj = lead?.assignedTo || lead?.followUpAssignedTo;
    let name = "";
    let id = "";
    if (assignedObj) {
      if (Array.isArray(assignedObj)) {
        name = assignedObj[0]?.assignedByName || "";
        id = assignedObj[0]?.assignedById || "";
      } else {
        name = assignedObj.assignedByName || "";
        id = assignedObj.assignedById || "";
      }
    } else {
      name = lead?.assignedByName || "";
      id = lead?.assignedById || "";
    }

    if (!name && !id) return "-";

    const loggedInId = this.userId || localStorage.getItem("guestID") || "";
    const loggedInName = this.loggedInUserName || localStorage.getItem("username") || localStorage.getItem("userName") || "";

    if (id && loggedInId && String(id) === String(loggedInId)) {
      return "Me";
    }
    if (name && loggedInName && String(name).trim().toLowerCase() === String(loggedInName).trim().toLowerCase()) {
      return "Me";
    }

    return name || "-";
  }

  getAssignedByImg(lead: any): string {
    if (!lead) return '/assets/leads/user-icon.png';
    const assignedObj = lead?.assignedTo || lead?.followUpAssignedTo;
    let img = '';
    if (assignedObj) {
      if (Array.isArray(assignedObj)) {
        img = assignedObj[0]?.assignedByImg || assignedObj[0]?.userProfileImg || '';
      } else {
        img = assignedObj.assignedByImg || assignedObj.userProfileImg || '';
      }
    }
    if (!img) {
      img = lead?.assignedByImg || lead?.userProfileImg || '';
    }
    return img && typeof img === 'string' && img.trim() ? img.trim() : '/assets/leads/user-icon.png';
  }

  onImgError(event: Event, fallbackSrc: string = '/assets/leads/user-icon.png') {
    const target = event.target as HTMLImageElement;
    if (target && target.src !== fallbackSrc) {
      target.src = fallbackSrc;
    }
  }

  ngOnInit() {
    this.userId = localStorage.getItem("guestID");

    this.themeSub = this.themeService.isDarkMode$.subscribe(() => {
      if (this.chart?.nativeElement) {
        if (this.leadsBreakdownSummary) {
          this.drawTerritoryMapForSummary(this.leadsBreakdownSummary);
        } else {
          d3.select(this.chart.nativeElement).selectAll('*').remove();
        }
      }
    });

    this.route.queryParams.subscribe(params => {
      this.currentView =
        params['view'] === 'kanban' ? 'kanban' : 'dashboard';

      if (!this.salesUsers || this.salesUsers.length === 0) {
        this.getSalesUserList();
      }

      if (this.currentView === 'kanban') {
        this.isCanvasLoading = true;
        this.loadAllColumns();
        if (params['column'] === 'closing-pool') {
          setTimeout(() => {
            const el = document.getElementById('drop-list-6');
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }, 600);
        }
      } else {
        this.isCanvasLoading = false;
        this.getAdminOverView();
        this.getAllLeadsBreakdown();
      }
    });

    if (this.project !== 'ALL' && this.project !== 'all') {
      this.followupLoadingTab['Incomplete'] = true;
      this.followupLoadingTab['Completed'] = true;
      this.followupLoading = true;
      this.getFollowUpMeeting('Incomplete');
      this.getFollowUpMeeting('Completed');
    } else {
      this.followupLoadingTab['Incomplete'] = false;
      this.followupLoadingTab['Completed'] = false;
      this.followupLoading = false;
    }
    this.todayDate = new Date().toISOString().split('T')[0];
    this.followUpForm.get('date')?.setValidators([Validators.required, this.minDateValidator()]);
    this.followUpForm.get('date')?.updateValueAndValidity();
    this.listenOverviewUpdates();
    this.trackFormChanges();
    this.generateTimeOptions();
    const field = {
      project: this.project,
      startDate: "",
      endDate: ""
    };
    this.chatService.leadStatus$.subscribe((data) => {
      console.log("Applying Realtime Status:", data);
      this.applyRealtimeStatusUpdate(data);
    });

    this.userDepartment = localStorage.getItem("department");
    if (this.userDepartment === "ADMIN") {
      this.userRole = "ADMIN";
    }
    else if (this.userDepartment === "SALES" || this.userDepartment === "ASSISTANT-SALES") {
      this.userRole = "SALES";
    }

    this.fetchFollowUpReminders();
    this.fetchAllReminderCounts();
    this.loggedInUser = this.userDepartment === "ADMIN";
    this.assistantUser = this.userDepartment == "ASSISTANT-SALES"
    this.loggedInUserName = localStorage.getItem("username")
    if (!this.loggedInUser) {
      this.getAllAssignedLead();
      this.loadNotes()
    }
  }

  ngOnDestroy() {
    this.resetAudioPlayer();
    this.cleanupModalBackdrop();
    if (this.themeSub) {
      this.themeSub.unsubscribe();
    }
  }

  territoryData: TerritoryNode[] = [];
  getAllLeadsBreakdown() {
    const payload: any = {
      project: this.project
    };

    if (this.startDate && this.endDate) {
      payload.startDate = this.startDate;
      payload.endDate = this.endDate;
    }

    this.crmService.leadsBreakdown(payload).subscribe(
      (res: any) => {
        console.log('Leads Breakdown', res);
        const data = res?.data;
        if (
          data &&
          typeof data.totalLeads === 'number'
        ) {
          this.leadsBreakdownSummary = data;
          this.drawTerritoryMapForSummary(data);
          return;
        }
        this.leadsBreakdownSummary = null;
        d3.select(this.chart.nativeElement).selectAll('*').remove();
      },
      err => console.error(err)
    );
  }

  calculateNormalizedWidths(values: number[], availableWidth: number, minW: number, maxW: number): number[] {
    const n = values.length;
    if (n === 0) return [];
    if (n === 1) return [availableWidth];

    const totalVal = values.reduce((sum, v) => sum + v, 0) || 1;
    let rawWidths = values.map(v => (v / totalVal) * availableWidth);

    let clamped = rawWidths.map(w => Math.max(minW, Math.min(maxW, w)));
    let clampedTotal = clamped.reduce((sum, w) => sum + w, 0);

    if (clampedTotal > 0) {
      let scaled = clamped.map(w => Math.floor(availableWidth * (w / clampedTotal)));
      let currentSum = scaled.reduce((sum, w) => sum + w, 0);
      let diff = availableWidth - currentSum;

      for (let i = 0; i < diff; i++) {
        scaled[i % n] += 1;
      }
      return scaled;
    }

    const eq = Math.floor(availableWidth / n);
    let result = new Array(n).fill(eq);
    result[n - 1] += availableWidth - (eq * n);
    return result;
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.leadsBreakdownSummary) {
      this.drawTerritoryMapForSummary(this.leadsBreakdownSummary);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target && !target.closest('.dropdown.customervalue-dropdown') && !target.closest('.dropdown.daterange-dropdown')) {
      this.isCustomerValueDropdownOpen = false;
    }
    if (!target || !target.closest('.follow-up-assignee-dd')) {
      this.followUpTaskAssigneeDropdownOpen = false;
    }
    if (!target || (!target.closest('.assignee-dd') && !target.closest('.assignee-dropdown'))) {
      this.assigneeDropdownOpen = false;
    }
    if (!target || (!target.closest('.status-dd') && !target.closest('.status-dropdown'))) {
      this.statusDropdownOpen = false;
    }
    if (!target || (!target.closest('.badge-dd') && !target.closest('.badge-dropdown') && !target.closest('.badge-dd-container'))) {
      this.badgeDropdownOpen = false;
    }
    if (!target || (!target.closest('.time-dd') && !target.closest('.time-dropdown'))) {
      this.timeDropdownOpen = false;
    }
    if (!target || (!target.closest('.type-dd') && !target.closest('.type-dropdown'))) {
      this.typeDropdownOpen = false;
    }
    if (!target || !target.closest('.disposition-status-dd')) {
      this.dispositionStatusDropdownOpen = false;
    }
    if (!target || !target.closest('.reminder-status-dd')) {
      this.reminderStatusDropdownOpen = false;
    }
  }

  onDetailsPanelClick(event: MouseEvent) {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    if (!target) return;

    if (!target.closest('.follow-up-assignee-dd')) {
      this.followUpTaskAssigneeDropdownOpen = false;
    }
    if (!target.closest('.assignee-dd') && !target.closest('.assignee-dropdown')) {
      this.assigneeDropdownOpen = false;
    }
    if (!target.closest('.status-dd') && !target.closest('.status-dropdown')) {
      this.statusDropdownOpen = false;
    }
    if (!target.closest('.badge-dd') && !target.closest('.badge-dropdown') && !target.closest('.badge-dd-container')) {
      this.badgeDropdownOpen = false;
    }
    if (!target.closest('.time-dd') && !target.closest('.time-dropdown')) {
      this.timeDropdownOpen = false;
    }
    if (!target.closest('.type-dd') && !target.closest('.type-dropdown')) {
      this.typeDropdownOpen = false;
    }
    if (!target.closest('.disposition-status-dd')) {
      this.dispositionStatusDropdownOpen = false;
    }
    if (!target.closest('.reminder-status-dd')) {
      this.reminderStatusDropdownOpen = false;
    }
  }

  drawTerritoryMapForSummary(summary: { totalLeads: number; notStartedLeads: number; convertedLeads: number; inProgressLeads: number; lostLeads: number; closingPoolLeads?: number; }) {
    if (!this.chart?.nativeElement) return;

    const containerWidth = this.chart.nativeElement.clientWidth || 1000;
    const isMobile = window.innerWidth <= 768;
    const width = isMobile ? Math.max(containerWidth, 680) : containerWidth;
    const height = 310;

    d3.select(this.chart.nativeElement).selectAll('*').remove();

    const isDark = this.themeService.isDarkMode;
    const bg = isDark ? 'transparent' : '#ffffff';

    const svg = d3.select(this.chart.nativeElement)
      .append('svg')
      .attr('viewBox', `0 0 ${width} ${height}`)
      .style('width', isMobile ? `${width}px` : '100%')
      .style('min-width', isMobile ? `${width}px` : '0')
      .style('height', `${height}px`)
      .style('background', bg)
      .style('font-family', "'Poppins', sans-serif")
      .style('overflow', 'hidden');

    const defs = svg.append('defs');

    // Soft Card Drop Shadow Filter matching Admin theme
    const filter = defs.append('filter')
      .attr('id', 'summary-card-drop-shadow')
      .attr('x', '-10%')
      .attr('y', '-10%')
      .attr('width', '130%')
      .attr('height', '140%');

    filter.append('feDropShadow')
      .attr('dx', 0)
      .attr('dy', 6)
      .attr('stdDeviation', 6)
      .attr('flood-color', isDark ? '#000000' : '#64748b')
      .attr('flood-opacity', isDark ? '0.3' : '0.12');

    // Dot matrix background texture pattern (matching Admin UI)
    const dotPattern = defs.append('pattern')
      .attr('id', 'summary-card-dot-matrix')
      .attr('width', 14)
      .attr('height', 14)
      .attr('patternUnits', 'userSpaceOnUse');

    dotPattern.append('circle')
      .attr('cx', 7)
      .attr('cy', 7)
      .attr('r', 1.1)
      .attr('fill', 'rgba(255, 255, 255, 0.18)');

    // 135deg linear gradients for status cards matching Admin theme
    const gradientsData = [
      { id: 'summary-grad-0', stops: [{ offset: '0%', color: '#C58BF2' }, { offset: '100%', color: '#A068ED' }] }, // Not Started (Purple)
      { id: 'summary-grad-1', stops: [{ offset: '0%', color: '#A5C5FE' }, { offset: '100%', color: '#779FF6' }] }, // In Progress (Blue)
      { id: 'summary-grad-2', stops: [{ offset: '0%', color: '#C7ED73' }, { offset: '100%', color: '#99D546' }] }, // Converted (Lime)
      { id: 'summary-grad-3', stops: [{ offset: '0%', color: '#F988C7' }, { offset: '100%', color: '#EE5CA6' }] }, // Lost (Pink)
      { id: 'summary-grad-4', stops: [{ offset: '0%', color: '#FCD34D' }, { offset: '100%', color: '#F59E0B' }] }  // Closing Pool (Gold/Amber)
    ];

    gradientsData.forEach(g => {
      const lg = defs.append('linearGradient')
        .attr('id', g.id)
        .attr('x1', '0%')
        .attr('y1', '0%')
        .attr('x2', '100%')
        .attr('y2', '100%');

      g.stops.forEach(s => {
        lg.append('stop').attr('offset', s.offset).attr('stop-color', s.color);
      });
    });

    const total = Number(summary.totalLeads) || 0;

    const statusNodes = [
      { name: 'Not Started', count: Number(summary.notStartedLeads ?? (summary as any).notStarted) || 0 },
      { name: 'In Progress', count: Number(summary.inProgressLeads ?? (summary as any).inProgress) || 0 },
      { name: 'Converted', count: Number(summary.convertedLeads ?? (summary as any).converted) || 0 },
      { name: 'Lost', count: Number(summary.lostLeads ?? (summary as any).lost) || 0 },
      { name: 'Closing Pool', count: Number(summary.closingPoolLeads ?? (summary as any).closingPoolCount ?? (summary as any).closingPool) || 0 }
    ];

    const base = Math.max(1, Math.round((total || 1) * 0.05));
    const children = statusNodes.map(s => ({
      name: s.name,
      assignedLeads: s.count || 0,
      convertedLeads: s.name === 'Converted' ? s.count || 0 : 0,
      _adjAssigned: (s.count || 0) + base,
      _origAssigned: s.count || 0
    }));

    const rootData: any = {
      name: 'root',
      assignedLeads: d3.sum(children, (d: any) => d._adjAssigned) || 0,
      children
    };

    const root = d3.hierarchy<any>(rootData)
      .sum((d: any) => d._adjAssigned || 0);

    const leaves = root.leaves() as HierarchyRectangularNode<any>[];

    const gap = 14;
    const n = leaves.length;
    const totalGapsX = (n - 1) * gap;
    const availableWidth = width - totalGapsX;
    const minColWidth = Math.max(130, Math.floor(availableWidth / (n * 1.8)));
    const maxColWidth = Math.floor(availableWidth * 0.65);

    const colValues = leaves.map(l => l.data._adjAssigned || 1);
    const colWidths = this.calculateNormalizedWidths(colValues, availableWidth, minColWidth, maxColWidth);

    let currentX = 0;
    leaves.forEach((l, idx) => {
      l.x0 = currentX;
      l.x1 = (idx === n - 1) ? width : currentX + colWidths[idx];
      l.y0 = 0;
      l.y1 = height;
      currentX = l.x1 + gap;
    });

    leaves.forEach((d, i) => {
      const nw = Math.max(0, d.x1 - d.x0);
      const nh = Math.max(0, d.y1 - d.y0);
      if (nw <= 0 || nh <= 0) return;

      const clipId = `summary-card-clip-${i}`;
      const gradId = `summary-grad-${i % gradientsData.length}`;

      defs.append('clipPath')
        .attr('id', clipId)
        .append('rect')
        .attr('width', nw)
        .attr('height', nh)
        .attr('rx', 18)
        .attr('ry', 18);

      const nodeGroup = svg.append('g')
        .attr('transform', `translate(${d.x0}, ${d.y0})`)
        .style('cursor', 'pointer');

      // Card Background Gradient & Shadow
      nodeGroup.append('rect')
        .attr('width', nw)
        .attr('height', nh)
        .attr('rx', 18)
        .attr('ry', 18)
        .attr('fill', `url(#${gradId})`)
        .attr('filter', 'url(#summary-card-drop-shadow)')
        .style('transition', 'transform 0.25s ease, opacity 0.25s ease');

      const innerGroup = nodeGroup.append('g')
        .attr('clip-path', `url(#${clipId})`);

      // Dot matrix pattern overlay (matching Admin UI)
      innerGroup.append('rect')
        .attr('width', nw)
        .attr('height', nh)
        .attr('fill', 'url(#summary-card-dot-matrix)')
        .attr('pointer-events', 'none');

      // Centered Status Title & Lead Count
      const centerX = nw / 2;
      const nameY = nh / 2 - 10;

      // Status Title (Head)
      innerGroup.append('text')
        .attr('x', centerX)
        .attr('y', nameY)
        .attr('text-anchor', 'middle')
        .attr('fill', '#ffffff')
        .style('font-size', `${Math.min(22, Math.max(14, nw * 0.11))}px`)
        .style('font-family', "'Poppins', sans-serif")
        .style('font-weight', '600')
        .style('letter-spacing', '0.3px')
        .style('text-transform', 'capitalize')
        .style('text-shadow', '0px 2px 4px rgba(0, 0, 0, 0.4), 0px 0px 4px rgba(255, 255, 255, 0.4)')
        .text(this.capitalizeName(d.data.name));

      // Lead Count
      const assignedY = nameY + 28;
      innerGroup.append('text')
        .attr('x', centerX)
        .attr('y', assignedY)
        .attr('text-anchor', 'middle')
        .attr('fill', 'rgba(255, 255, 255, 0.95)')
        .style('font-size', `${Math.min(18, Math.max(13, nw * 0.09))}px`)
        .style('font-family', "'Poppins', sans-serif")
        .style('font-weight', '500')
        .style('text-shadow', '0px 1px 3px rgba(0, 0, 0, 0.35), 0px 0px 3px rgba(255, 255, 255, 0.35)')
        .text(`${d.data._origAssigned} leads`);

      // Smooth Hover & Click Effect
      nodeGroup.on('mouseenter', function () {
        d3.select(this).select('rect')
          .transition()
          .duration(200)
          .attr('transform', 'scale(1.015)')
          .style('transform-origin', `${nw / 2}px ${nh / 2}px`);
      }).on('mouseleave', function () {
        d3.select(this).select('rect')
          .transition()
          .duration(200)
          .attr('transform', 'scale(1)')
          .style('transform-origin', `${nw / 2}px ${nh / 2}px`);
      }).on('click', (event: any, leaf: any) => {
        if (leaf?.data?.name === 'Closing Pool') {
          this.zone.run(() => {
            this.goToKanbanClosingPool();
          });
        } else {
          this.zone.run(() => {
            this.goToKanban();
          });
        }
      });
    });
  }


  getAgentName(lead: any): string {
    if (!lead) return '';
    let name = '';
    if (lead.agentName) name = lead.agentName;
    else if (lead.agentFirstName) {
      name = lead.agentFirstName + (lead.agentLastName ? ' ' + lead.agentLastName : '');
    }
    return this.capitalizeName(name);
  }

  capitalizeName(name: string): string {
    if (!name) return '';
    return name.replace(/\b\w/g, char => char.toUpperCase());
  }

  getSummaryNameFont(d: any): number {
    const a = (d.x1 - d.x0) * (d.y1 - d.y0);
    if (a > 140000) return 28;
    if (a > 80000) return 24;
    if (a > 40000) return 20;
    return 14;
  }

  getSummaryValueFont(d: any): number {
    const a = (d.x1 - d.x0) * (d.y1 - d.y0);
    if (a > 140000) return 24;
    if (a > 80000) return 20;
    if (a > 40000) return 18;
    return 12;
  }

  canShowSummaryText(d: any): boolean {
    return (d.y1 - d.y0) >= 45;
  }


  get showCanvasUI(): boolean {
    return this.currentView === 'kanban';
  }


  projectIcons: { [key: string]: string } = {
    'V-RETAIL': '../../assets/vretail-icon-9.png',
    'V-ESTATE': '../../assets/vestate-icon.png',
    'IIC-LAB': '../../assets/iic-leads-icon.png',
    'OUTBOUND': '../../assets/leads/default-icon.png'
  };

  get canvasTitle(): string {
    const proj = (this.project || '').toUpperCase();
    if (proj === 'IIC' || proj === 'IIC-LAB') {
      return 'IIC Leads';
    } else if (proj === 'V-RETAIL') {
      return 'V-Retail Leads';
    } else if (proj === 'V-ESTATE') {
      return 'V-Estate Leads';
    } else if (proj === 'OUTBOUND') {
      return 'Outbound Leads';
    }
    return 'All Leads';
  }

  minDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const selectedDate = new Date(control.value).toISOString().split('T')[0];
      if (selectedDate < this.todayDate) {
        return { minDate: { value: control.value } };
      }
      return null;
    };
  }

  followUpForm = this.fb.group({
    date: ['', Validators.required],
    time: ['', Validators.required],
    type: ['', Validators.required]
  });

  timeDropdownOpen = false;
  typeDropdownOpen = false;
  isClosingPoolLead(lead?: any, col?: any): boolean {
    return false;
  }

  isStatusDropdownDisabled(lead?: any): boolean {
    return false;
  }

  toggleTimeDropdown(event?: Event) {
    if (event) event.stopPropagation();
    const willOpen = !this.timeDropdownOpen;
    this.closeAllDropdowns();
    this.timeDropdownOpen = willOpen;
  }
  toggleStatusDropdown(event?: Event) {
    if (event) event.stopPropagation();
    const willOpen = !this.statusDropdownOpen;
    this.closeAllDropdowns();
    this.statusDropdownOpen = willOpen;
  }

  toggleTypeDropdown(event?: Event) {
    if (event) event.stopPropagation();
    const willOpen = !this.typeDropdownOpen;
    this.closeAllDropdowns();
    this.typeDropdownOpen = willOpen;
  }

  selectTime(time: string) {
    this.followUpForm.patchValue({ time });
    this.followUpForm.get('time')?.markAsDirty();
    this.followUpForm.get('time')?.markAsTouched();
    this.timeDropdownOpen = false;
  }

  selectType(type: string) {
    this.followUpForm.patchValue({ type });
    this.followUpForm.get('type')?.markAsDirty();
    this.followUpForm.get('type')?.markAsTouched();
    this.typeDropdownOpen = false;
  }



  generateTimeOptions() {
    this.timeOptions = [];
    const startHour = 7;
    const endHour = 23;
    const interval = 15;

    for (let h = startHour; h <= endHour; h++) {
      for (let m = 0; m < 60; m += interval) {
        const hour12 = h % 12 || 12;
        const ampm = (h >= 12 && h < 24) ? 'PM' : 'AM';
        const minute = m === 0 ? '00' : m;
        const timeStr = `${hour12}:${minute} ${ampm}`;
        if (!this.timeOptions.includes(timeStr)) {
          this.timeOptions.push(timeStr);
        }
      }
    }
  }



  applyRealtimeStatusUpdate(event: any) {
    const { leadId, status } = event;
    this.assignedLeadsCanvas = this.assignedLeadsCanvas.filter(l => l._id !== leadId);
    this.emptyColumns.forEach(col => {
      col.items = col.items.filter(l => l._id !== leadId);
    });

    const updatedLead = event.lead;

    const colIndex = Object.values(this.columnStatusMap).indexOf(status);

    if (colIndex === 0) {
      this.assignedLeadsCanvas.push(updatedLead);
    } else if (colIndex > 0) {
      this.emptyColumns[colIndex - 1].items.push(updatedLead);
    }

    console.log("✔ UI Updated via Socket");
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.editorTextareas?.forEach((ref) => {
        const textarea = ref.nativeElement;
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      });
    });
    const cards = document.querySelectorAll('.animate-card');
    cards.forEach((card) => {
      card.addEventListener('animationend', () => {
        card.classList.remove('animate-card');
      });
    });
  }


  initializeForm() {
    this.leadForm = this.fb.group({
      leadId: ['', Validators.required],
      companyName: ['', [Validators.required, Validators.maxLength(100)]],
      name: ['', [Validators.required, Validators.maxLength(100)]],
      leadName: [''],
      contactName: [''],
      email: [
        '',
        [
          Validators.maxLength(100),
          Validators.email
        ]
      ],

      phoneNo: [
        '',
        [
          this.indianPhoneValidator
        ]
      ],
      designation: ['', [Validators.required, Validators.maxLength(100)]],
      followUpDate: [''],
      followUpAssignee: [''],
      status: [''],
      userMessage: [''],
      adminNotes: [''],
      customerValue: [''],
      lossReason: ['']
    });

    this.leadForm.get('name')?.valueChanges.subscribe(val => {
      if (this.leadForm.get('leadName')?.value !== val) {
        this.leadForm.get('leadName')?.setValue(val, { emitEvent: false });
      }
      if (this.leadForm.get('contactName')?.value !== val) {
        this.leadForm.get('contactName')?.setValue(val, { emitEvent: false });
      }
    });

    this.leadForm.get('leadName')?.valueChanges.subscribe(val => {
      if (this.leadForm.get('name')?.value !== val) {
        this.leadForm.get('name')?.setValue(val, { emitEvent: false });
      }
      if (this.leadForm.get('contactName')?.value !== val) {
        this.leadForm.get('contactName')?.setValue(val, { emitEvent: false });
      }
    });

    this.leadForm.get('contactName')?.valueChanges.subscribe(val => {
      if (this.leadForm.get('name')?.value !== val) {
        this.leadForm.get('name')?.setValue(val, { emitEvent: false });
      }
      if (this.leadForm.get('leadName')?.value !== val) {
        this.leadForm.get('leadName')?.setValue(val, { emitEvent: false });
      }
    });
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const noSpaces = value.replace(/\s+/g, '');
      console.log('Phone validation - Original:', value, 'No spaces:', noSpaces);

      let phoneDigits: string;
      if (noSpaces.startsWith('+')) {
        const countryCodeMatch = noSpaces.match(/^\+(\d{1,3})/);
        if (countryCodeMatch) {
          phoneDigits = noSpaces.substring(countryCodeMatch[0].length);
          console.log('With country code:', countryCodeMatch[0], 'Phone digits:', phoneDigits);
        } else {
          phoneDigits = noSpaces.substring(1);
        }
      } else {
        phoneDigits = noSpaces;
      }
      if (phoneDigits.length !== 10) {
        console.log('Invalid length:', phoneDigits.length, 'Digits:', phoneDigits);
        return { phoneLength: true };
      }
      if (!/^\d+$/.test(phoneDigits)) {
        console.log('Invalid characters in:', phoneDigits);
        return { phoneInvalid: true };
      }

      console.log('Valid phone number:', phoneDigits);
      return null;
    };
  }

  // DATE RANGE PICKER
  selectedDateRange: any = null;
  locale = {
    format: "MM/DD/YYYY",
    applyLabel: "OK",
    cancelLabel: "Cancel",
    customRangeLabel: "Custom Range",
    daysOfWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    firstDay: 1,
  };

  ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };






  formatPrettyDate(date: Date): string {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  }


  clearDateFilter() {
    this.startDate = "";
    this.endDate = "";
    this.selectedDateRange = null;
    this.displayDateRange = null;
    this.isFilteredView = false;
    this.currentPageNume = 1;
    this.assignedLeads = [];
    console.log("Date filter cleared , loading default year graph");
    this.getAdminOverView();
    this.getAllLeadsBreakdown();
    this.getAllAssignedLead();
  }

  // Filter variables
  isMediaLoading = true;
  folderId: string = "";
  isFilteredView = false;
  displayDateRange: string | null = null;
  onDateSelected(event: any) {
    if (event.startDate && event.endDate) {
      const start = event.startDate;
      const end = event.endDate;

      this.startDate = this.toISODate(start, false);
      this.endDate = this.toISODate(end, true);

      this.displayDateRange = `${this.formatDisplayDate(start)} - ${this.formatDisplayDate(end)}`;
      this.isFilteredView = true;
      this.currentPageNume = 1;
      this.assignedLeads = [];

      this.getAllLeadsBreakdown();
      this.getAdminOverView();
      this.getAllAssignedLead();
    }
  }
  toISODate(momentDate: any, isEndOfDay: boolean = false): string {
    if (!momentDate) return '';
    const year = momentDate.year ? momentDate.year() : new Date(momentDate).getFullYear();
    const month = momentDate.month ? momentDate.month() : new Date(momentDate).getMonth();
    const date = momentDate.date ? momentDate.date() : new Date(momentDate).getDate();

    if (isEndOfDay) {
      return new Date(Date.UTC(year, month, date, 23, 59, 59, 999)).toISOString();
    }
    return new Date(Date.UTC(year, month, date, 0, 0, 0, 0)).toISOString();
  }
  onDatepickerHide() {
    console.log("Datepicker hidden");
  }
  formatDisplayDate(momentDate: any): string {
    const day = String(momentDate.date()).padStart(2, "0");
    const month = String(momentDate.month() + 1).padStart(2, "0");
    const year = momentDate.year();
    return `${day}/${month}/${year}`;
  }



  noteText: string = "";
  editingNoteId: string | null = null;
  notesList = [];
  hasNote: boolean = false;

  loadNotes() {
    if (this.project === 'ALL') return;
    const isOutbound = this.project === 'OUTBOUND' || (this.selectedLead && (this.selectedLead.leadType === 'Outbound' || this.selectedLead.leadType === 'OUTBOUND' || this.selectedLead.project === 'OUTBOUND' || this.selectedLead.source === 'Outbound'));
    const field: any = isOutbound ? { leadType: 'Outbound' } : { project: this.project };

    this.crmService.getNote(field).subscribe((res: any) => {
      if (res?.data) {
        this.noteText = res.data.note || '';
        this.originalNoteText = this.noteText;
        this.editingNoteId = res.data._id;

        this.hasNote = true;
        this.isEditing = false;
      } else {
        this.noteText = '';
        this.originalNoteText = '';
        this.editingNoteId = null;
        this.hasNote = false;
        this.isEditing = true;
      }
    });
  }

  isEditing = false;
  originalNoteText = '';

  editNote(note: any) {
    this.noteText = note.note || '';
    this.originalNoteText = this.noteText;
    this.editingNoteId = note._id;
  }

  enableEditMode() {
    this.isEditing = true;
    if (!this.originalNoteText) {
      this.originalNoteText = this.noteText || '';
    }
    if (this.noteText && !this.noteText.endsWith('\n')) {
      this.noteText += '\n';
    }

    setTimeout(() => {
      const el = document.querySelector('.sticky-text') as HTMLTextAreaElement;
      if (el) {
        el.focus();
        const len = el.value.length;
        el.setSelectionRange(len, len);
      }
    }, 50);
  }

  setEditState(isEditing: boolean) {
    this.isEditing = isEditing;
  }

  get isNoteChanged(): boolean {
    if (!this.editingNoteId) {
      return (this.noteText || '').trim().length > 0;
    }
    return (this.noteText || '').trim() !== (this.originalNoteText || '').trim();
  }

  saveAnimation: boolean = false;
  saveNote() {
    const isOutbound = this.project === 'OUTBOUND' || (this.selectedLead && (this.selectedLead.leadType === 'Outbound' || this.selectedLead.leadType === 'OUTBOUND' || this.selectedLead.project === 'OUTBOUND' || this.selectedLead.source === 'Outbound'));

    const body: any = {
      note: (this.noteText || '').trim()
    };

    if (isOutbound) {
      body.leadType = 'Outbound';
    } else {
      body.project = this.project;
    }

    if (this.editingNoteId) {
      body.noteId = this.editingNoteId;
    }

    this.crmService.createNote(body).subscribe((res: any) => {
      this.noteText = res?.data?.note || '';
      this.originalNoteText = this.noteText;
      this.editingNoteId = res?.data?._id || this.editingNoteId;
      this.hasNote = true;
      this.isEditing = false;

      this.loadNotes();

      this.saveAnimation = true;
      setTimeout(() => (this.saveAnimation = false), 600);
    });
  }


  leads: any = [];
  totalLeads: number;
  onScroll() {
    console.log("Scrolled! Current Leads Length:", this.assignedLeads.length);
    const totalLoaded = this.assignedLeads.length;
    if (totalLoaded >= this.totalAssignedCount) return;
    this.currentPageNume++;
    this.getAllAssignedLead();
  }

  badgeOptions = [
    { label: "Premium", value: "premium", class: "badge-premium" },
    { label: "Emerging", value: "emerging", class: "badge-emerging" },
    { label: "Regular", value: "regular", class: "badge-regular" },
    { label: "Basic", value: "basic", class: "badge-basic" },
  ];

  selectedBadgeDetails: any = null;
  badgeDropdownOpen = false;

  get isAdmin(): boolean {
    const dept = (this.userDepartment || localStorage.getItem("department") || "").toLowerCase();
    return dept === "admin" || dept === "marketing" || this.userRole === "ADMIN" || this.loggedInUser;
  }

  toggleBadgeDropdown() {
    if (!this.isAdmin) return;
    this.badgeDropdownOpen = !this.badgeDropdownOpen;
  }

  selectBadgeDetails(badgeValue: string) {
    const badgeObj = this.badgeOptions.find((b) => b.value === badgeValue);
    this.selectedBadgeDetails = badgeObj;
    this.leadForm.patchValue({ customerValue: badgeValue });
    this.leadForm.get('customerValue')?.markAsDirty();
    this.leadForm.get('customerValue')?.markAsTouched();
    this.leadForm.markAsDirty();
    this.badgeDropdownOpen = false;
  }

  getBadgeClass(value: string) {
    switch (value?.toLowerCase()) {
      case 'premium':
        return 'badge-premium';
      case 'emerging':
        return 'badge-emerging';
      case 'regular':
        return 'badge-regular';
      case 'basic':
        return 'badge-basic';
      default:
        return '';
    }
  }


  // ============== CANVAS SCROLL / TABS ==============

  scrollToColumn(index: number) {
    const container = document.querySelector('.canvas-scroll-container') as HTMLElement;
    if (!container) return;
    const isMobile = window.innerWidth <= 768;
    const columnWidth = isMobile ? (300 + 12) : 432;
    container.scrollTo({ left: index * columnWidth, behavior: "smooth" });
    this.activeTabIndex = index;
  }

  onCanvasScroll(event: any) {
    const scrollLeft = event.target.scrollLeft;
    const isMobile = window.innerWidth <= 768;
    const columnWidth = isMobile ? (300 + 12) : 432;
    this.activeTabIndex = Math.round(scrollLeft / columnWidth);
  }

  onDrop(event: CdkDragDrop<any[]>, targetColumn: string | number) {
    this.stopAutoScroll();
    if (!event.container || !event.previousContainer) return;

    const previousList = event.previousContainer.data;
    const targetList = event.container.data;

    if (!previousList || !targetList) return;

    const movedLead = previousList[event.previousIndex];
    if (!movedLead) return;

    const oldStatus = movedLead?.status;
    const newStatus = typeof targetColumn === 'string'
      ? targetColumn
      : this.columnStatusMap[targetColumn];

    if (!newStatus || newStatus === 'Follow-up Task') {
      return;
    }

    if (newStatus === 'Closing Pool') {
      alertModalWithoutConfirm('warning', 'Already added to the Closing pool!');
      return;
    }

    if (
      event.previousContainer === event.container &&
      oldStatus === newStatus
    ) {
      moveItemInArray(targetList, event.previousIndex, event.currentIndex);
      return;
    }


    // CASE 1: DROP TO UNQUALIFIED 

    if (newStatus === 'Unqualified') {

      transferArrayItem(
        previousList,
        targetList,
        event.previousIndex,
        event.currentIndex
      );

      alertModalDelete(
        'Are you sure you want to delete this lead?',
        ''
      ).then(confirmed => {
        if (!confirmed) {
          // revert UI
          transferArrayItem(
            targetList,
            previousList,
            event.currentIndex,
            event.previousIndex
          );
          return;
        }

        const resolvedProject = (this.project === 'ALL' && movedLead?.project)
          ? movedLead.project
          : this.project;
        const projectTab =
          (resolvedProject === 'IIC-LAB' || resolvedProject === 'V-ESTATE') && movedLead.source
            ? movedLead.source
            : this.projectTab;

        this.crmService.deleteLead(resolvedProject, projectTab, movedLead._id).subscribe({
          next: () => {
            movedLead.isDeleted = true;
            movedLead.status = 'Unqualified';

            this.totalStatusCount[oldStatus] =
              Math.max(0, (this.totalStatusCount[oldStatus] || 0) - 1);

            this.totalStatusCount['Unqualified'] =
              (this.totalStatusCount['Unqualified'] || 0) + 1;

            if (movedLead?.hasClosingPotential || oldStatus === 'Closing Pool') {
              this.refreshClosingPoolColumn();
            }
          },
          error: err => {
            console.error('Delete failed', err);
            transferArrayItem(
              targetList,
              previousList,
              event.currentIndex,
              event.previousIndex
            );
          }
        });
      });

      return;
    }


    // CASE 2: RESTORE FROM UNQUALIFIED

    if ((oldStatus === 'Unqualified' || movedLead.isDeleted) &&
      newStatus !== 'Unqualified') {

      transferArrayItem(
        previousList,
        targetList,
        event.previousIndex,
        event.currentIndex
      );

      const resolvedProject2 = (this.project === 'ALL' && movedLead?.project)
        ? movedLead.project
        : this.project;
      const payload: any = {
        project: resolvedProject2,
        leadId: movedLead._id
      };

      if ((resolvedProject2 === 'IIC-LAB' || resolvedProject2 === 'V-ESTATE') && movedLead.source) {
        payload.projectTab = movedLead.source;
      }

      this.crmService.restoreLead(payload).subscribe({
        next: () => {
          movedLead.isDeleted = false;
          movedLead.status = newStatus;

          this.totalStatusCount['Unqualified'] =
            Math.max(0, (this.totalStatusCount['Unqualified'] || 0) - 1);

          this.totalStatusCount[newStatus] =
            (this.totalStatusCount[newStatus] || 0) + 1;

          const isOutbound = this.isOutboundLead(movedLead);
          const targetProject = this.getActualLeadProject(movedLead);
          const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);
          const payload: any = {
            leadId: movedLead._id,
            status: newStatus,
            redirectUrl: redirectUrl
          };

          if (isOutbound) {
            payload.leadType = 'Outbound';
          } else {
            payload.project = targetProject;
            if ((targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE') && movedLead.source) {
              payload.projectTab = movedLead.source;
            }
          }

          this.crmService.updateDragStatus(payload).subscribe({
            next: () => {
              if (movedLead?.hasClosingPotential || newStatus === 'Closing Pool') {
                this.refreshClosingPoolColumn();
              }
            }
          });
        },
        error: () => {
          // revert UI
          transferArrayItem(
            targetList,
            previousList,
            event.currentIndex,
            event.previousIndex
          );
        }
      });

      return;
    }


    //CASE 3: NORMAL STATUS CHANGE

    transferArrayItem(
      previousList,
      targetList,
      event.previousIndex,
      event.currentIndex
    );

    movedLead.status = newStatus;

    this.totalStatusCount[oldStatus]--;
    this.totalStatusCount[newStatus] =
      (this.totalStatusCount[newStatus] || 0) + 1;

    const isOutbound = this.isOutboundLead(movedLead);
    const targetProject = this.getActualLeadProject(movedLead);
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);
    const payload: any = {
      leadId: movedLead._id,
      status: newStatus,
      redirectUrl: redirectUrl
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      payload.project = targetProject;
      if ((targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE') && movedLead.source) {
        payload.projectTab = movedLead.source;
      }
    }
    this.crmService.updateDragStatus(payload).subscribe({
      next: () => {
        if (movedLead?.hasClosingPotential || oldStatus === 'Closing Pool' || newStatus === 'Closed' || newStatus === 'Lost' || newStatus === 'Unqualified') {
          this.refreshClosingPoolColumn();
        }
      },
      error: err => console.error('Status update failed', err)
    });
  }

  refreshClosingPoolColumn() {
    const payload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: 1,
      limit: 500,
      sort: this.sortOrder,
      hasClosingPotential: true
    };

    if (this.projectTab && this.projectTab !== 'ALL') {
      payload.projectTab = this.projectTab;
    }

    if (this.selectedCustomerValue) {
      payload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      payload.searchQuery = this.kanbanSearchQuery.trim();
    }

    this.crmService.getAssignedLead(payload).subscribe({
      next: (res: any) => {
        const items = res?.data?.data || [];
        const colIndex = this.emptyColumns.findIndex((col: any) => col.status === 'Closing Pool');
        if (colIndex !== -1) {
          this.emptyColumns[colIndex].items = items;
          const countVal = res?.data?.total || items.length;
          this.emptyColumns[colIndex].totalCount = countVal;
          this.totalStatusCount['Closing Pool'] = countVal;
        }
      },
      error: (err: any) => console.error('Error refreshing closing pool column:', err)
    });
  }






  listenOverviewUpdates() {
    this.chatService.leadOverviewUpdates$.subscribe((socketData) => {
      console.log("DATA", socketData)

      if (!socketData?.data || !Array.isArray(socketData.data)) return;

      let overview;

      if (this.userRole === "ADMIN") {
        overview = socketData.data.find(d => d.role !== "Sales Manager");
      } else {
        overview = socketData.data.find(d => d.role === "Sales Manager");
      }

      if (!overview) return;

      console.log("Selected Overview:", overview);

      this.applyOverviewSocketData(overview);
    });
  }

  applyOverviewSocketData(res: any) {
    this.totalsLeadsCounts = res.totalLeadsCount;
    this.salesUserName = res.userName;
    this.role = res.role;

    this.totalInProgressCount = res.inProgressLeadsCount;
    this.totalConvertedLeadsCount = res.convertedLeadsCount;
    this.totalLostLeadsCount = res.lostLeadsCount;
    this.totalClosingPoolCount = res.closingPoolCount;

    this.progressLeadPercentage = res.inProgressLeadsPercentage;
    this.convertedLeadPercentage = res.convertedLeadsPercentage;
    this.lostLeadsPercentage = res.lostLeadsPercentage;


    this.progressLeadTrend = res.inProgressLeadsTrend;
    this.convertedLeadTrend = res.convertedLeadsTrend;
    this.lostLeadTrend = res.lostLeadsTrend;
    this.totalLeadsTrend = res.totalLeadsTrend;
  }



  refreshColumn(index: number) {
    if (index < 0 || index > 7) return;

    const status = this.columnStatusMap[index];

    const basePayload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: 1,
      limit: 500
    };

    if (status === 'Closing Pool') {
      basePayload.hasClosingPotential = true;
    } else {
      basePayload.status = status;
    }

    if (this.selectedCustomerValue) {
      basePayload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      basePayload.searchQuery = this.kanbanSearchQuery.trim();
    }

    this.crmService.getAssignedLead(basePayload).subscribe((res: any) => {
      const list = res.data.data || [];
      if (index === 0) {
        this.assignedLeadsCanvas = list;
      } else {
        this.emptyColumns[index - 1].items = list;
      }
    });
  }

  loadUpdatedLead(leadId: string, targetList: any[], index: number) {
    const payload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: 1,
      limit: 500,
    };

    if (this.projectTab && this.projectTab !== 'ALL') {
      payload.projectTab = this.projectTab;
    }

    if (this.selectedCustomerValue) {
      payload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      payload.searchQuery = this.kanbanSearchQuery.trim();
    }

    this.crmService.getAssignedLead(payload).subscribe((res: any) => {
      const updated = res.data.data.find((l: any) => l._id === leadId);
      if (!updated) {
        console.warn("Updated lead not found in API response");
        return;
      }
      targetList[index] = updated;
      this.syncLeadInAllColumns(updated);
    });
  }

  markColumnLoaded() {
    this.columnsLoaded++;
    if (this.columnsLoaded === this.totalColumnsToLoad) {
      this.isCanvasLoading = false;
    }
  }

  isCustomerValueDropdownOpen = false;
  selectedCustomerValue: '' | 'Premium' | 'Emerging' | 'Basic' | 'Regular' = '';
  customerValueFilterLabel = 'Badge';

  kanbanSearchQuery: string = '';
  private kanbanSearchTimer: any = null;

  onKanbanSearchChange() {
    if (this.kanbanSearchTimer) {
      clearTimeout(this.kanbanSearchTimer);
    }
    this.kanbanSearchTimer = setTimeout(() => {
      this.currentKanbanPages = Object.keys(this.currentKanbanPages).reduce(
        (acc, key) => ({ ...acc, [key]: 1 }),
        {}
      );
      this.loadAllColumns();
    }, 350);
  }

  clearKanbanSearch() {
    this.kanbanSearchQuery = '';
    this.currentKanbanPages = Object.keys(this.currentKanbanPages).reduce(
      (acc, key) => ({ ...acc, [key]: 1 }),
      {}
    );
    this.loadAllColumns();
  }

  toggleCustomerValueDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isCustomerValueDropdownOpen = !this.isCustomerValueDropdownOpen;
  }

  closeAllDropdowns() {
    this.isCustomerValueDropdownOpen = false;
    this.timeDropdownOpen = false;
    this.typeDropdownOpen = false;
    this.statusDropdownOpen = false;
    this.assigneeDropdownOpen = false;
    this.badgeDropdownOpen = false;
    this.dispositionStatusDropdownOpen = false;
    this.reminderStatusDropdownOpen = false;
    this.followUpTaskAssigneeDropdownOpen = false;
    this.reassignDropdownOpen = false;
  }

  applyCustomerValueFilter(value: '' | 'Premium' | 'Emerging' | 'Basic' | 'Regular') {
    this.selectedCustomerValue = value;
    this.isCustomerValueDropdownOpen = false;
    this.customerValueFilterLabel = value ? value : 'Badge';

    this.currentKanbanPages = Object.keys(this.currentKanbanPages).reduce(
      (acc, key) => ({ ...acc, [key]: 1 }),
      {}
    );
    this.loadAllColumns();
  }

  totalStatusCount: Record<string, number> = {};
  currentKanbanPages: { [key: string]: number } = {
    'Not started': 1,
    'Contacted': 1,
    'Email introduction': 1,
    'Meetings in Video call': 1,
    'Meetings in person': 1,
    'Presentation': 1,
    'Cost sheet': 1,
    'Closing Pool': 1,
    'Closed': 1,
    'Lost': 1,
    'Unqualified': 1,
    'Follow-up Task': 1
  };

  sortOrder: number = -1;
  loadAllColumns() {
    this.isCanvasLoading = true;
    this.columnsLoaded = 0;

    Object.keys(this.currentKanbanPages).forEach(key => {
      this.currentKanbanPages[key] = 1;
    });

    const basePayload: any = {
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      limit: this.currentLimit,
      sort: this.sortOrder
    };

    if (this.projectTab && this.projectTab !== 'ALL') {
      basePayload.projectTab = this.projectTab;
    }

    if (this.selectedCustomerValue) {
      basePayload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      basePayload.searchQuery = this.kanbanSearchQuery.trim();
    }

    if (this.project !== 'ALL') {
      basePayload.project = this.project;
    }

    const statuses = [
      { status: "Follow-up Task", target: "followUpLeadsCanvas", isFollowUpTask: true },
      { status: "Not started", target: "assignedLeadsCanvas" },
      { status: "Contacted", target: 0 },
      { status: "Email introduction", target: 1 },
      { status: "Meetings in Video call", target: 2 },
      { status: "Meetings in person", target: 3 },
      { status: "Presentation", target: 4 },
      { status: "Cost sheet", target: 5 },
      { status: "Closing Pool", target: 6 },
      { status: "Closed", target: 7 },
      { status: "Lost", target: 8 },
      { status: "Unqualified", target: 9 }
    ];

    statuses.forEach((s: any) => {
      const columnPayload: any = {
        ...basePayload,
        pageNum: this.currentKanbanPages[s.status] || 1
      };

      if (s.isFollowUpTask) {
        const followUpPayload = this.project === 'ALL'
          ? { ...columnPayload, project: this.project, isAll: true }
          : { ...columnPayload, project: this.project };

        this.crmService.getFollowUpLeads(followUpPayload).subscribe({
          next: (res: any) => {
            const items = res?.data?.leads || res?.data?.data || [];
            const count = res?.data?.leadsCount ?? items.length;
            this.totalStatusCount[s.status] = count;
            this.followUpLeadsCanvas = items;
            this.markColumnLoaded();
          },
          error: (err: any) => {
            console.error('Error fetching follow-up leads:', err);
            this.markColumnLoaded();
          }
        });
      } else {

        if (s.status === 'Closing Pool') {
          columnPayload.hasClosingPotential = true;
        } else {
          columnPayload.status = s.status;
        }

        const assignedLeadsPayload = this.project === 'ALL'
          ? { ...columnPayload, project: this.project, isAll: true }
          : { ...columnPayload, project: this.project };

        this.crmService.getAssignedLead(assignedLeadsPayload).subscribe((res: any) => {
          const items = res.data.data || [];
          const count = res.data.leadsCount || 0;
          this.totalStatusCount[s.status] = count;

          if (s.target === "assignedLeadsCanvas") {
            this.assignedLeadsCanvas = items;
          } else {
            this.emptyColumns[s.target].items = items;
          }
          this.markColumnLoaded();
        });
      }
    });
  }


  toggleSortOrder() {
    this.sortOrder = this.sortOrder === -1 ? 1 : -1;
    this.currentKanbanPages = Object.keys(this.currentKanbanPages).reduce(
      (acc, key) => ({ ...acc, [key]: 1 }),
      {}
    );

    this.loadAllColumns();
  }

  onKanbanScroll(status: string) {
    console.log('Scrolled column:', status);

    const total = this.totalStatusCount[status];

    // Not started column
    if (status === 'Not started') {
      if (this.assignedLeadsCanvas.length >= total) return;

      this.currentKanbanPages[status]++;
      this.loadKanbanColumn(status);
      return;
    }

    // Other columns
    const column = this.emptyColumns.find(c => c.status === status);
    if (!column) return;

    if (column.items.length >= total) return;

    this.currentKanbanPages[status]++;
    this.loadKanbanColumn(status);
  }

  loadKanbanColumn(status: string) {
    const payload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: this.currentKanbanPages[status],
      limit: this.currentLimit,
      status
    };

    if (this.projectTab && this.projectTab !== 'ALL') {
      payload.projectTab = this.projectTab;
    }

    if (this.selectedCustomerValue) {
      payload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      payload.searchQuery = this.kanbanSearchQuery.trim();
    }

    this.crmService.getAssignedLead(payload).subscribe((res: any) => {
      const newItems = res?.data?.data || [];

      if (status === 'Not started') {
        this.assignedLeadsCanvas = [
          ...this.assignedLeadsCanvas,
          ...newItems
        ];
      } else {
        const column = this.emptyColumns.find(c => c.status === status);
        if (!column) return;

        column.items = [...column.items, ...newItems];
      }
    });
  }
  loadMoreKanbanData(status: string) {
    const payload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: this.currentKanbanPages[status],
      limit: this.currentLimit,
      status: status
    };

    if (this.projectTab && this.projectTab !== 'ALL') {
      payload.projectTab = this.projectTab;
    }

    if (this.selectedCustomerValue) {
      payload.customerValue = this.selectedCustomerValue.toLowerCase();
    }

    if (this.kanbanSearchQuery && this.kanbanSearchQuery.trim()) {
      payload.searchQuery = this.kanbanSearchQuery.trim();
    }

    if (status === 'Closing Pool') {
      payload.hasClosingPotential = true;
    } else {
      payload.status = status;
    }

    this.crmService.getAssignedLead(payload).subscribe(
      (response: any) => {
        const newItems = response.data.data || [];

        if (status === "Not started") {
          this.assignedLeadsCanvas = [...this.assignedLeadsCanvas, ...newItems];
        } else {
          const statuses = [
            "Contacted",
            "Email introduction",
            "Meetings in Video call",
            "Meetings in person",
            "Presentation",
            "Cost sheet",
            "Closing Pool",
            "Closed",
            "Lost",
            "Unqualified"
          ];
          const columnIndex = statuses.indexOf(status);

          if (columnIndex !== -1 && this.emptyColumns[columnIndex]) {
            this.emptyColumns[columnIndex].items = [
              ...this.emptyColumns[columnIndex].items,
              ...newItems
            ];
          }
        }

        console.log(`Loaded ${newItems.length} more items for status: ${status}`);
      },
      (error) => {
        console.error(`Error loading more data for ${status}:`, error);
        this.currentKanbanPages[status]--;
      }
    );
  }

  onDragMove(event?: any) {
    // Native CDK auto-scroll is handled reliably by CdkScrollable
  }

  stopAutoScroll() {
    if (this.autoScrollInterval) {
      clearInterval(this.autoScrollInterval);
      this.autoScrollInterval = null;
    }
  }

  findColumnIndex(list: any[]): number {
    if (list === this.assignedLeadsCanvas) return 0;
    const col = this.emptyColumns.find(c => c.items === list);
    return col ? col.index : -1;
  }

  updateLeadStatus(lead: any, newColumnIndex: number) {
    const newStatus = this.columnStatusMap[newColumnIndex];


    if (newStatus === 'Unqualified') {
      return;
    }

    const isOutbound = this.isOutboundLead(lead);
    const targetProject = (this.getActualLeadProject ? this.getActualLeadProject(lead) : null) || lead?.project || this.project;
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);
    const payload: any = {
      leadId: lead._id,
      status: newStatus,
      redirectUrl: redirectUrl
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      payload.project = targetProject;
    }

    this.crmService.updateDragStatus(payload).subscribe({
      next: () => {
        this.socket?.emit("LEAD-STATUS", payload);
      },
      error: err => console.error(err)
    });
  }



  // ============== EDITOR / FILE BLOCKS ==============

  onFileBlockClick(index: number, event: MouseEvent) {
    event.stopPropagation();

    const target = event.target as HTMLElement;
    if (target.closest('textarea')) return;

    let next = this.editorBlocks[index + 1];
    if (!next || next.type !== 'text') {
      next = this.insertNewTextBlockAfter(index);
    }

    requestAnimationFrame(() => {
      this.focusTextAreaByBlockId((next as TextBlock).id);
    });
  }

  focusLastTextBlock() {
    let last = this.editorBlocks[this.editorBlocks.length - 1];
    if (!last || last.type !== 'text') {
      const newBlock: TextBlock = {
        id: crypto.randomUUID(),
        type: 'text',
        value: ''
      };
      this.editorBlocks.push(newBlock);
      last = newBlock;
    }

    setTimeout(() => {
      const areas = document.querySelectorAll('.editor-textarea');
      const t = areas[areas.length - 1] as HTMLTextAreaElement;
      if (t) {
        t.focus();
      }
    }, 10);
  }

  onEditorKeydown(event: KeyboardEvent, block: EditorBlock, index: number) {
    if (block.type !== 'text') return;

    const textarea = event.target as HTMLTextAreaElement;

    // SPLIT BLOCK ON ENTER
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      const cursor = textarea.selectionStart;
      const text = block.value || '';

      const before = text.slice(0, cursor);
      const after = text.slice(cursor);

      // Update current block
      block.value = before;

      const newBlock: TextBlock = {
        id: crypto.randomUUID(),
        type: 'text',
        value: after
      };

      this.editorBlocks.splice(index + 1, 0, newBlock);
      this.editorChanged = true;
      requestAnimationFrame(() => {
        const currentTextarea =
          this.editorTextareas?.toArray()[index]?.nativeElement;

        if (currentTextarea) {
          currentTextarea.style.height = 'auto';
          currentTextarea.style.height =
            currentTextarea.scrollHeight + 'px';
        }

        // FOCUS & RESIZE NEW TEXTAREA
        this.focusTextAreaByBlockId(newBlock.id);

        const nextTextarea =
          this.editorTextareas?.toArray()[index + 1]?.nativeElement;

        if (nextTextarea) {
          nextTextarea.style.height = 'auto';
          nextTextarea.style.height =
            nextTextarea.scrollHeight + 'px';
        }
      });

      return;
    }

    // MERGE ON BACKSPACE
    if (event.key === 'Backspace') {
      const atStart = textarea.selectionStart === 0;
      if (atStart && index > 0) {
        event.preventDefault();
        this.mergeWithPreviousBlock(index);
      }
    }
  }

  insertNewTextBlock(index: number) {

    const newBlock: TextBlock = {
      id: crypto.randomUUID(),
      type: 'text',
      value: ''
    };

    this.editorBlocks.splice(index + 1, 0, newBlock);

    setTimeout(() => {
      const areas = document.querySelectorAll('.editor-textarea');
      const t = areas[index + 1] as HTMLTextAreaElement;
      if (t) {
        t.style.minHeight = "22px";
        t.style.padding = "6px 0";
        this.forceResize(t);
        t.focus();
      }
    }, 20);
  }

  private insertNewTextBlockAfter(index: number): TextBlock {

    const newBlock: TextBlock = {
      id: crypto.randomUUID(),
      type: 'text',
      value: ''
    };
    this.editorBlocks.splice(index + 1, 0, newBlock);
    return newBlock;
  }

  private mergeWithPreviousBlock(index: number) {

    const current = this.editorBlocks[index];
    const prev = this.editorBlocks[index - 1];

    if (!current || !prev) return;
    if (current.type !== 'text' || prev.type !== 'text') return;

    prev.value = (prev.value || '') + (current.value || '');
    this.editorBlocks.splice(index, 1);

    setTimeout(() => {
      this.focusTextAreaByBlockId(prev.id);
    }, 0);
    this.editorChanged = true;
  }

  autoResize(event: any) {
    const ta = event.target as HTMLTextAreaElement;
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }

  onEditorDragOver(event: DragEvent) {

    event.preventDefault();
    event.stopPropagation();
  }

  onEditorDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  private getDynamicChunks(fileSize: number) {
    let chunks = [];
    let totalChunks = Math.ceil(fileSize / CHUNK_SIZE);

    for (let i = 0; i < totalChunks; i++) {
      let start = i * CHUNK_SIZE;
      let end = Math.min(start + CHUNK_SIZE, fileSize);

      if (
        i === totalChunks - 1 &&
        end - start < MIN_CHUNK_SIZE &&
        chunks.length > 0
      ) {
        let previousChunk = chunks.pop();
        start = previousChunk.start;
        end = fileSize;
        totalChunks--;
      }
      chunks.push({ start, end });
    }
    return { chunks, totalChunks };
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const leadId = this.selectedLeadForDetails?._id;
    Array.from(files).forEach(file =>
      this.uploadFileInEditor(file, leadId)
    );
  }

  addFileBlock(file: File, leadId?: string): FileBlock {
    const ext = file.name.split('.').pop()?.toLowerCase();

    const block: FileBlock = {
      id: crypto.randomUUID(),
      type: 'file',
      fileName: file.name,
      fileSize: file.size,
      rawFile: file,
      uploading: true,
      progress: 0,
      parts: [],
      uploadedAt: new Date(),
      extension: ext,
      url: undefined,
      leadId: leadId,
    };

    this.editorBlocks.push(block);
    this.editorChanged = true;
    return block;
  }

  async uploadFileInEditor(file: File, leadId?: string, targetBlock?: FileBlock) {
    try {
      const block = targetBlock ?? this.addFileBlock(file, leadId);
      const leadID = block.leadId;
      const { chunks, totalChunks } = this.getDynamicChunks(file.size);

      const preResp: any = await firstValueFrom(
        this.crmService.getPreSignedUrls(
          file.name,
          totalChunks,
          file.size,
          leadID
        )
      );

      const presigned = preResp.data?.[0];
      const urls = presigned.urls;
      const mediaId = presigned.mediaId;
      const fileUrl = presigned.fileUrl;

      block.uploadId = presigned.uploadId;
      block.mediaId = mediaId;

      let uploadedParts: any[] = [];
      let uploadedBytes = 0;

      for (let i = 0; i < urls.length; i++) {
        const { partNumber, url: signedUrl } = urls[i];
        const chunk = file.slice(chunks[i].start, chunks[i].end);

        const res = await axios.put(signedUrl, chunk, {
          headers: { "Content-Type": "application/octet-stream" },
          onUploadProgress: pe => {
            if (pe.loaded && pe.total) {
              const totalUploaded = uploadedBytes + pe.loaded;
              block.progress = Math.floor((totalUploaded / file.size) * 100);
            }
          }
        });

        const eTag = res.headers["etag"]?.replace(/^"(.*)"$/, "$1");
        uploadedParts.push({ PartNumber: partNumber, ETag: eTag });
        uploadedBytes += chunk.size;
      }

      await firstValueFrom(
        this.crmService.completeUpload(
          [
            {
              uniqueFileName: presigned.uniqueFileName,
              uploadId: block.uploadId,
              mediaId,
              parts: uploadedParts
            }
          ],
          leadID
        )
      );

      block.uploading = false;
      block.progress = 100;
      block.url = fileUrl;

      this.insertPreviewBlock(block, mediaId, fileUrl, file);

      // Refresh lead details to get compressed images and thumbnails once all parallel uploads are done
      const isAnyFileUploading = this.editorBlocks.some(b => b.type === 'file' && b.uploading);
      if (!isAnyFileUploading && leadID) {
        setTimeout(() => {
          this.getSingleLeadById(leadID, this.selectedLead?.source);
        }, 3000);
      }

      setTimeout(() => {
        const index = this.editorBlocks.findIndex(b => b.id === block.id);
        const next = this.editorBlocks[index + 1];

        if (next && next.type === "text") {
          this.focusTextBlock(index + 1);

          setTimeout(() => {
            const areas = document.querySelectorAll(".editor-textarea");
            const ta = areas[index + 1] as HTMLTextAreaElement;
            if (ta) this.forceResize(ta);
          }, 10);
        }
      }, 20);

    } catch (err) {
      console.error("UPLOAD FAILED", err);
      if (targetBlock) targetBlock.uploading = false;
    }
  }

  async onDeleteFile(block: EditorBlock, index: number, event: Event) {
    event.stopPropagation();

    if (block.type !== 'file') return;

    if (block.uploading) {
      this.editorBlocks.splice(index, 1);
      return;
    }

    if (!block.mediaId) return;

    const isConfirmed = await alertModalDelete('Are you sure you want to delete?');

    if (!isConfirmed) return;

    this.crmService.deleteLeadMedia(block.mediaId).subscribe({
      next: () => {
        this.editorBlocks.splice(index, 1);
      },
      error: (err) => {
        console.error('Delete failed', err);
        this.showAlert('Failed to delete file', 'Error', 'error');
      }
    });
  }


  forceResize(textarea: HTMLTextAreaElement) {
    textarea.style.height = "auto";
    textarea.style.minHeight = "22px";
    textarea.style.height = textarea.scrollHeight + "px";
  }

  focusTextBlock(index: number, event?: Event) {
    if (event) event.stopPropagation();
    const areas = document.querySelectorAll('.editor-textarea');
    const t = areas[index] as HTMLTextAreaElement;
    if (!t) return;
    t.focus();
  }

  private focusTextAreaByBlockId(blockId: string) {
    const el = document.querySelector(
      `.editor-textarea[data-block-id="${blockId}"]`
    ) as HTMLTextAreaElement | null;

    if (el) {
      el.focus();
      const len = el.value.length;
      el.setSelectionRange(len, len);
    }
  }

  insertPreviewBlock(block: FileBlock, mediaId: string, fileUrl: string, file: File) {
    block.uploading = false;
    block.progress = 100;
    block.mediaId = mediaId;
    block.url = fileUrl;
    block.extension = file.name.split('.').pop()?.toLowerCase() || "";
    block.uploadedAt = block.uploadedAt || new Date();
  }

  formatBytes(bytes: number) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if (bytes === 0) return '0 Bytes';
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
  }

  getPlaceholderForBlock(block: any, index: number) {
    const isLast = index === this.editorBlocks.length - 1;
    const isEmpty = !block.value || block.value.trim() === "";
    return isLast && isEmpty ? "Ask or find anything from your workspace…" : "";
  }
  openLeadDetails(lead) {
    this.selectedLeadForDetails = lead;
  }


  openFullscreen(block: FileBlock) {
    let type: 'image' | 'video' | 'document' = 'document';

    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(block.extension || '')) {
      type = 'image';
    } else if (['mp4', 'mov', 'webm', 'mkv'].includes(block.extension || '')) {
      type = 'video';
    }

    this.fullscreenPreview = {
      url: block.url!,
      type,
      fileName: block.fileName
    };
  }

  closeFullscreen() {
    this.fullscreenPreview = null;
  }

  downloadFile(preview: any) {
    const link = document.createElement('a');
    link.href = preview.url;
    link.download = preview.fileName;
    link.click();
  }

  // ============== LOGO UPLOAD ==============

  openUploadLogoModal() {
    this.showLogoUploadModal = true;
  }

  closeUploadLogoModal() {
    this.showLogoUploadModal = false;
    this.showCropper = false;
    this.imageChangedEvent = '';
    this.lastCroppedEvent = undefined;
  }


  onLogoSelect(event: any) {
    this.logoChanged = true;
    const file: File = event.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;

    this.showCropper = false;
    this.lastCroppedEvent = undefined;
    this.transform = { scale: 1 };

    setTimeout(() => {
      this.imageChangedEvent = event;
      this.showCropper = true;
      this.isFormDirty = true;
    }, 50);
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.blob) {
      this.lastCroppedEvent = event;
    }
  }

  saveCrop() {
    if (this.lastCroppedEvent && this.lastCroppedEvent.blob) {
      const blob = this.lastCroppedEvent.blob;
      this.selectedLogoFile = new File([blob], 'logo-cropped.png', {
        type: 'image/png',
        lastModified: Date.now()
      });
      this.logoPreview = this.lastCroppedEvent.base64 || URL.createObjectURL(blob);
      this.showCropper = false;
      this.imageChangedEvent = '';
      this.closeUploadLogoModal();
    }
  }

  cancelCrop() {
    this.showCropper = false;
    this.imageChangedEvent = '';
    this.lastCroppedEvent = undefined;
    this.transform = { scale: 1 };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: (this.transform.scale || 1) + 0.1
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: Math.max(0.1, (this.transform.scale || 1) - 0.1)
    };
  }

  saveLogo() {
    if (!this.selectedLogoFile) return;
    this.closeUploadLogoModal();
  }

  // ============== STATUS / LOST REASON ==============

  selectLeadStatus(status: string) {
    this.selectedLeadStatus = status;
    this.statusDropdownOpen = false;
    this.showLostReason = status === 'Lost';

    this.leadForm.patchValue({ status });
    this.leadForm.get('status')?.markAsDirty();

    if (status !== 'Lost') {
      this.leadForm.patchValue({ lossReason: '' });
      this.leadForm.get('lossReason')?.markAsDirty();
    }

    const normalized = (status || '').trim().toLowerCase();
    const isTerminal =
      normalized === 'closed' ||
      normalized === 'closed won' ||
      normalized === 'lost' ||
      normalized === 'unqualified';

    if (isTerminal) {
      this.showReminderSection = false;
      this.reminderDueAt = '';
      this.reminderDueTime = '';
      this.selectedReminderStatus = null;
      this.pendingReminderTargetStatus = '';
    } else {
      this.selectedReminderStatus = status;
      this.selectedReminderStatusIcon = this.getStatusIcon(status);
      this.pendingReminderTargetStatus = status;
      this.showReminderSection = true;
    }
  }

  get isLeadClosedOrLostOrUnqualified(): boolean {
    return this.isLeadClosed || this.isLeadLost || this.isLeadUnqualified;
  }

  get isLeadClosed(): boolean {
    const status = (
      this.selectedLeadStatus ||
      this.leadForm?.get('status')?.value ||
      this.selectedLead?.status ||
      this.singleLead?.status ||
      this.selectedLeadForDetails?.status ||
      ''
    ).toString().trim().toLowerCase();

    const dispStatus = (this.selectedDispositionStatus || '').trim().toLowerCase();

    return (
      status === 'closed' ||
      status === 'closed won' ||
      dispStatus === 'closed' ||
      dispStatus === 'closed won'
    );
  }

  get isLeadLost(): boolean {
    const status = (
      this.selectedLeadStatus ||
      this.leadForm?.get('status')?.value ||
      this.selectedLead?.status ||
      this.singleLead?.status ||
      this.selectedLeadForDetails?.status ||
      ''
    ).toString().trim().toLowerCase();

    const dispStatus = (this.selectedDispositionStatus || '').trim().toLowerCase();

    return status === 'lost' || dispStatus === 'lost';
  }

  get isLeadClosedOrLost(): boolean {
    return this.isLeadClosed || this.isLeadLost;
  }

  get isLeadUnqualified(): boolean {
    const status = (
      this.selectedLeadStatus ||
      this.leadForm?.get('status')?.value ||
      this.selectedLead?.status ||
      this.singleLead?.status ||
      this.selectedLeadForDetails?.status ||
      ''
    ).toString().trim().toLowerCase();

    const dispStatus = (this.selectedDispositionStatus || '').trim().toLowerCase();

    return status === 'unqualified' || dispStatus === 'unqualified';
  }

  get isLeadLostOrUnqualified(): boolean {
    return this.isLeadLost || this.isLeadUnqualified;
  }
  getStatusIcon(status?: string): string {
    if (!status) return '';
    const normalized = status.trim().toLowerCase();
    const found = this.canvasTabs.find(tab =>
      tab.label.toLowerCase() === normalized ||
      tab.status.toLowerCase() === normalized
    );
    if (found?.icon) return found.icon;

    if (normalized.includes('video')) return '/assets/leads/video-meeting.png';
    if (normalized.includes('person')) return '/assets/leads/meeting-icon.png';
    if (normalized.includes('contacted')) return '/assets/leads/circle-phone.png';
    if (normalized.includes('email')) return '/assets/leads/email-tab.png';
    if (normalized.includes('presentation')) return '/assets/leads/presentation-icon.png';
    if (normalized.includes('cost')) return '/assets/leads/cost-sheet-icon.png';
    if (normalized.includes('closed')) return '/assets/leads/closed.png';
    if (normalized.includes('lost')) return '/assets/leads/lost-icon.png';
    if (normalized.includes('unqualified')) return '/assets/leads/unqualified.png';
    if (normalized.includes('not started') || normalized.includes('assigned')) return '/assets/leads/assigned-lead-icon.png';

    return '';
  }



  isFollowUpComplete(): boolean {
    const { date, time, type } = this.followUpForm.value;
    return !!date && !!time && !!type;
  }


  showReminderSection: boolean = false;
  reminderDueAt: string = '';
  reminderDueTime: string = '';
  pendingReminderTargetStatus: string = '';
  reminderStatusDropdownOpen: boolean = false;
  selectedReminderStatus: string | null = null;
  selectedReminderStatusIcon: string | null = null;

  dispositionDirty = false;
  get hasUnsavedChanges(): boolean {
    if (!this.isLeadClosedOrLostOrUnqualified) {
      const hasIncompleteReminder =
        this.showReminderSection &&
        (!this.reminderDueAt ||
          !this.reminderDueTime ||
          !(this.selectedReminderStatus || this.pendingReminderTargetStatus));
      if (hasIncompleteReminder) {
        return false;
      }
    }

    const hasPendingReminder =
      !this.isLeadClosedOrLostOrUnqualified &&
      this.showReminderSection &&
      !!this.reminderDueAt &&
      !!this.reminderDueTime &&
      !!(this.selectedReminderStatus || this.pendingReminderTargetStatus);

    return (
      this.hasLeadValueChanged() ||
      this.hasFollowUpChanged() ||
      this.logoChanged ||
      this.editorChanged ||
      this.dispositionDirty ||
      this.pendingDispositions.length > 0 ||
      this.leadForm.dirty ||
      hasPendingReminder
    );
  }

  hasFollowUpChanged(): boolean {
    const current = this.followUpForm.getRawValue();

    const initial = this.initialFollowUpSnapshot || {};

    const allFilled =
      !!current.date && !!current.time && !!current.type;

    if (!allFilled) return false;

    const currentDateStr = current.date
      ? (typeof current.date === 'string' ? current.date.split('T')[0] : new Date(current.date).toISOString().split('T')[0])
      : '';
    const initialDateStr = initial.date
      ? (typeof initial.date === 'string' ? initial.date.split('T')[0] : new Date(initial.date).toISOString().split('T')[0])
      : '';

    return (
      currentDateStr !== initialDateStr ||
      (current.time || '') !== (initial.time || '') ||
      (current.type || '') !== (initial.type || '')
    );
  }


  hasLeadValueChanged(): boolean {
    const current = this.leadForm.getRawValue();

    return Object.keys(current).some(key => {
      const initial = (this.initialLeadSnapshot[key] ?? '').toString().trim();
      const now = (current[key] ?? '').toString().trim();
      return initial !== now;
    });
  }



  onDispositionTyping(event?: Event) {
    const value = this.dispositionControl.value?.trim() || '';
    this.isAddDispositionEnabled =
      value.length > 0 && !!this.selectedDispositionStatus;

    if (event?.target) {
      const textarea = event.target as HTMLTextAreaElement;
      textarea.style.height = '44px';
      const scrollHeight = textarea.scrollHeight;
      const maxHeight = 140;
      if (scrollHeight > 44) {
        textarea.style.height = Math.min(scrollHeight, maxHeight) + 'px';
      }
    }
  }

  isAddDispositionEnabled = false;
  onDispositionEnter(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    if (!keyboardEvent.shiftKey) {
      keyboardEvent.preventDefault();
      keyboardEvent.stopPropagation();
      this.addDisposition();
    }
  }

  // 1Notes list (only USER + has note)
  get dispositionNotes() {
    return this.dispositions.filter(
      d => d.type === 'User' && !!d.note
    );
  }

  // Status sequence (ONLY system updates)
  get dispositionStatusTimeline() {
    return this.dispositions.filter(d => d.type === 'System');
  }

  isClosingPoolAdded(item: any): boolean {
    return item?.hasClosingPotential == true || item?.hasClosingPotential == 'true' || item?.status === 'Closing Pool' || item?.stageStatus === 'Closing Pool';
  }

  get isLeadInClosingPool(): boolean {
    const lead = this.selectedLead || this.selectedLeadForDetails || this.singleLead;
    if (!lead) return false;
    return lead.hasClosingPotential === true ||
      lead.hasClosingPotential === 'true' ||
      lead.status === 'Closing Pool' ||
      lead.stageStatus === 'Closing Pool';
  }

  getLeadStageStatus(item: any): string {
    if (item?.status && item.status !== 'Closing Pool') return item.status;
    if (item?.prevStatus && item.prevStatus !== 'Closing Pool') return item.prevStatus;
    const lead = this.singleLead || this.selectedLeadForDetails || this.selectedLead;
    if (lead?.status && lead.status !== 'Closing Pool') return lead.status;
    if (lead?.prevStatus && lead.prevStatus !== 'Closing Pool') return lead.prevStatus;
    if (lead?.stageStatus && lead.stageStatus !== 'Closing Pool') return lead.stageStatus;
    return 'Not started';
  }

  getNextLogicalStatus(currentStatusOrLead?: any): string {
    const order = [
      'Not started',
      'Contacted',
      'Email introduction',
      'Meetings in Video call',
      'Meetings in person',
      'Presentation',
      'Cost sheet',
      'Closed'
    ];

    if (typeof currentStatusOrLead === 'string' && currentStatusOrLead.trim()) {
      const idx = order.findIndex(s => s.toLowerCase() === currentStatusOrLead.trim().toLowerCase());
      if (idx !== -1) {
        return idx < order.length - 1 ? order[idx + 1] : order[idx];
      }
    }

    const rawLogs = this.dispositions || this.singleLead?.dispositionStatus || this.selectedLead?.dispositionStatus || [];
    let highestIdx = -1;

    if (Array.isArray(rawLogs) && rawLogs.length > 0) {
      for (const log of rawLogs) {
        if (!log) continue;
        const status = (log.status || log.meta?.status || log.prevStatus || '').toString().trim().toLowerCase();
        if (status) {
          const idx = order.findIndex(s => s.toLowerCase() === status);
          if (idx > highestIdx) {
            highestIdx = idx;
          }
        }
      }
    }

    if (highestIdx === -1) {
      const leadObj = (typeof currentStatusOrLead === 'object' && currentStatusOrLead) ? currentStatusOrLead : (this.selectedLead || this.singleLead);
      const leadStatus = (leadObj?.status || this.selectedLeadStatus || '').toString().trim().toLowerCase();
      if (leadStatus) {
        const idx = order.findIndex(s => s.toLowerCase() === leadStatus);
        if (idx !== -1) {
          highestIdx = idx;
        }
      }
    }

    if (highestIdx >= 0) {
      return highestIdx < order.length - 1 ? order[highestIdx + 1] : order[highestIdx];
    }

    return 'Contacted';
  }

  // DISPOSITION STATUS
  dispositionStatusDropdownOpen = false;
  selectedDispositionStatus: string | null = null;

  getNextDispositionStatus(currentOrLatestStatus?: string | null): string {
    const availableStatuses = this.statusList && this.statusList.length ? this.statusList : [
      'Not started',
      'Contacted',
      'Email introduction',
      'Meetings in Video call',
      'Meetings in person',
      'Presentation',
      'Cost sheet',
      'Closed',
      'Lost',
      'Unqualified'
    ];

    if (!currentOrLatestStatus) {
      return availableStatuses[0] || 'Not started';
    }

    const normalized = currentOrLatestStatus.trim().toLowerCase();
    const currentIndex = availableStatuses.findIndex(
      s => s.trim().toLowerCase() === normalized
    );

    if (currentIndex === -1) {
      return availableStatuses[0] || 'Not started';
    }

    // Always select immediate next status if available
    if (currentIndex + 1 < availableStatuses.length) {
      return availableStatuses[currentIndex + 1];
    }

    // If already at the last status, keep the last status
    return availableStatuses[currentIndex];
  }

  getLatestDispositionStatus(leadObj?: any): string | null {
    const rawDispositions = leadObj?.dispositionStatus || this.dispositions || this.singleLead?.dispositionStatus || this.selectedLead?.dispositionStatus || [];
    if (rawDispositions && rawDispositions.length) {
      // Sort by date descending to find the latest valid status
      const sorted = [...rawDispositions].sort((a: any, b: any) => {
        const timeA = new Date(a.createdAt || a.timestamp || a.updatedAt || 0).getTime() || 0;
        const timeB = new Date(b.createdAt || b.timestamp || b.updatedAt || 0).getTime() || 0;
        return timeB - timeA;
      });

      for (const item of sorted) {
        const status = item.status || item.meta?.status;
        if (status && typeof status === 'string' && status.trim().length > 0) {
          const norm = status.trim().toLowerCase();
          if (norm !== 'follow-up task' && norm !== 'closing pool' && norm !== 'unqualified') {
            return status.trim();
          }
        }
      }
    }

    // Fallback to lead's current status if no disposition log with status is found
    const targetLead = leadObj || this.singleLead || this.selectedLeadForDetails || this.selectedLead;
    if (targetLead?.status && typeof targetLead.status === 'string' && targetLead.status.trim().length > 0) {
      const norm = targetLead.status.trim().toLowerCase();
      if (norm !== 'follow-up task' && norm !== 'closing pool' && norm !== 'unqualified') {
        return targetLead.status.trim();
      }
    }

    return null;
  }

  updatePreselectedStatuses(baseStatus?: string | null, leadObj?: any): void {
    const rawStatus = typeof baseStatus === 'string' ? baseStatus : (leadObj?.status || this.selectedLead?.status || this.selectedLeadStatus);
    const norm = (rawStatus || '').toString().trim().toLowerCase();
    if (norm === 'closed' || norm === 'closed won' || norm === 'lost' || norm === 'unqualified') {
      const statusLabel = typeof baseStatus === 'string' ? baseStatus : (leadObj?.status || this.selectedLead?.status || this.selectedLeadStatus || 'Unqualified');
      this.selectedDispositionStatus = statusLabel;
      this.selectedStatusIcon = this.getStatusIcon(statusLabel);
      this.selectedReminderStatus = null;
      this.selectedReminderStatusIcon = null;
      this.pendingReminderTargetStatus = '';
      this.showReminderSection = false;
      return;
    }

    const nextStatus = this.getNextLogicalStatus(baseStatus || leadObj || this.selectedLead);
    this.selectedDispositionStatus = nextStatus;
    this.selectedStatusIcon = this.getStatusIcon(nextStatus);
    this.selectedReminderStatus = nextStatus;
    this.selectedReminderStatusIcon = this.getStatusIcon(nextStatus);
    this.pendingReminderTargetStatus = nextStatus;
  }

  updatePreselectedDispositionStatus(baseStatus?: string | null, leadObj?: any): void {
    this.updatePreselectedStatuses(baseStatus, leadObj);
  }

  updatePreselectedReminderStatus(baseStatus?: string | null, leadObj?: any): void {
    this.updatePreselectedStatuses(baseStatus, leadObj);
  }

  toggleDispositionStatusDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const willOpen = !this.dispositionStatusDropdownOpen;
    this.closeAllDropdowns();
    this.dispositionStatusDropdownOpen = willOpen;
  }

  toggleReminderStatusDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const willOpen = !this.reminderStatusDropdownOpen;
    this.closeAllDropdowns();
    this.reminderStatusDropdownOpen = willOpen;
  }

  selectDispositionStatus(status: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.selectedDispositionStatus = status;
    this.selectedStatusIcon = this.getStatusIcon(status);

    const normalized = (status || '').trim().toLowerCase();
    const isTerminal =
      normalized === 'closed' ||
      normalized === 'closed won' ||
      normalized === 'lost' ||
      normalized === 'unqualified';

    if (isTerminal) {
      this.showReminderSection = false;
      this.reminderDueAt = '';
      this.reminderDueTime = '';
      this.selectedReminderStatus = null;
      this.pendingReminderTargetStatus = '';
    } else {
      this.selectedReminderStatus = status;
      this.selectedReminderStatusIcon = this.getStatusIcon(status);
      this.pendingReminderTargetStatus = status;
      this.showReminderSection = true;
    }

    this.dispositionStatusDropdownOpen = false;
    const value = this.dispositionControl.value?.trim() || '';
    this.isAddDispositionEnabled = value.length > 0;
  }

  selectReminderStatus(status: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    const normalized = (status || '').trim().toLowerCase();
    const isTerminal =
      normalized === 'closed' ||
      normalized === 'closed won' ||
      normalized === 'lost' ||
      normalized === 'unqualified';

    if (isTerminal) {
      this.showReminderSection = false;
      this.reminderDueAt = '';
      this.reminderDueTime = '';
      this.selectedReminderStatus = null;
      this.pendingReminderTargetStatus = '';
      this.selectedDispositionStatus = status;
      this.selectedStatusIcon = this.getStatusIcon(status);
      this.reminderStatusDropdownOpen = false;
      return;
    }

    this.selectedReminderStatus = status;
    this.selectedReminderStatusIcon = this.getStatusIcon(status);
    this.pendingReminderTargetStatus = status;
    this.selectedDispositionStatus = status;
    this.selectedStatusIcon = this.getStatusIcon(status);
    this.reminderStatusDropdownOpen = false;
    this.showReminderSection = true;
  }


  getActualLeadProject(lead?: any): string {
    const targetLead = lead || this.singleLead || this.selectedLeadForDetails || this.selectedLead;
    const proj = targetLead?.project || this.singleLead?.project || this.selectedLeadForDetails?.project || this.selectedLead?.project;
    if (proj && proj !== 'ALL') {
      return proj.toUpperCase();
    }
    const source = targetLead?.source || targetLead?.sourceLead || targetLead?.projectTab || this.singleLead?.source || this.singleLead?.projectTab;
    if (source) {
      const normalizedSource = String(source).trim().toLowerCase();
      if (normalizedSource === 'outbound') return 'OUTBOUND';
      const vRetailSources = new Set([
        'book demo',
        'contact us',
        'user onboard',
        'lead magnet features',
        'lead magnet book demo',
        'lead magnet pricing',
        'email',
        'website'
      ]);
      const vEstateSources = new Set(['whatsapp', 'email']);
      const iicSources = new Set(['news letter', 'newsletter', 'career']);

      if (vRetailSources.has(normalizedSource)) return 'V-RETAIL';
      if (vEstateSources.has(normalizedSource)) return 'V-ESTATE';
      if (iicSources.has(normalizedSource)) return 'IIC-LAB';
    }
    if (this.project && this.project !== 'ALL') {
      return this.project.toUpperCase();
    }
    return 'V-RETAIL';
  }

  buildFollowUpPayload() {
    const { date, time, type } = this.followUpForm.value;
    if (!date || !time || !type) return null;
    const leadObj = this.singleLead || this.selectedLeadForDetails || this.selectedLead;
    if (!leadObj?._id) return null;

    const normalizedType =
      type === 'Virtual' || type === 'In Person' ? type : null;

    if (!normalizedType) return null;

    const isOutbound = this.isOutboundLead(leadObj);
    const targetProject = this.getActualLeadProject(leadObj);
    const allowedProjects = ['V-RETAIL', 'V-ESTATE', 'IIC-LAB', 'IIC'];
    if (!isOutbound && !allowedProjects.includes(targetProject)) return null;

    const payload: any = {
      leadId: String(leadObj._id),
      date: new Date(date).toISOString(),
      time: String(time),
      type: normalizedType
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      payload.project = targetProject;
      const rawTab = leadObj?.source || leadObj?.sourceLead || leadObj?.projectTab;
      const projectTab = rawTab || ((targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE' || targetProject === 'IIC') ? 'IVR' : undefined);
      if (projectTab) {
        payload.projectTab = projectTab;
      }
    }

    return payload;
  }


  get shouldUpdateLead(): boolean {
    return this.leadForm.dirty || this.logoChanged || this.editorChanged;
  }

  get shouldCreateFollowUp(): boolean {
    return this.hasFollowUpChanged();
  }



  buildLeadPayload(): FormData | any {
    const changedFields = this.getChangedLeadFields();
    if (!Object.keys(changedFields).length && !this.logoChanged) {
      return null;
    }
    const leadObj = this.singleLead || this.selectedLeadForDetails || this.selectedLead;
    const targetProject = this.getActualLeadProject(leadObj);
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);
    const isOutboundLead =
      this.project === 'OUTBOUND' ||
      targetProject === 'OUTBOUND' ||
      (leadObj && (
        String(leadObj.leadType).toLowerCase() === 'outbound' ||
        String(leadObj.project).toLowerCase() === 'outbound' ||
        String(leadObj.source).toLowerCase() === 'outbound' ||
        String(leadObj.sourceLead).toLowerCase() === 'outbound' ||
        String(leadObj.projectTab).toLowerCase() === 'outbound'
      ));

    const rawTab = leadObj?.source || leadObj?.sourceLead || leadObj?.projectTab;
    const projectTab = !isOutboundLead ? (rawTab || (targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE' ? 'IVR' : null)) : null;

    const targetLeadId = leadObj?._id || this.selectedLeadForDetails?._id || this.selectedLead?._id || this.singleLead?._id;

    if (!this.logoChanged) {
      const payload: any = {
        ...changedFields,
        leadId: targetLeadId,
        redirectUrl
      };

      if (isOutboundLead) {
        payload.leadType = 'Outbound';
      } else {
        payload.project = targetProject;
        if (projectTab) {
          payload.projectTab = projectTab;
        }
      }

      if (this.isAdmin) {
        const badgeVal = this.leadForm.get('customerValue')?.value || this.selectedBadgeDetails?.value;
        if (badgeVal) {
          payload.customerValue = badgeVal;
        }
        const aNotes = this.leadForm.get('adminNotes')?.value;
        if (aNotes !== undefined && aNotes !== null) {
          payload.description = aNotes;
        }
      }

      delete payload.adminNotes;
      delete payload.badge;

      return payload;
    }
    const formData = new FormData();
    Object.keys(changedFields).forEach(key => {
      if (key !== 'adminNotes' && key !== 'badge') {
        formData.append(key, changedFields[key]);
      }
    });

    formData.append('leadId', String(targetLeadId || ''));
    if (this.selectedLogoFile) {
      formData.append('file', this.selectedLogoFile);
    }
    formData.append('redirectUrl', redirectUrl);

    if (isOutboundLead) {
      formData.append('leadType', 'Outbound');
    } else {
      if (targetProject) {
        formData.append('project', targetProject);
      }
      if (projectTab) {
        formData.append('projectTab', projectTab);
      }
    }

    if (this.isAdmin) {
      const badgeVal = this.leadForm.get('customerValue')?.value || this.selectedBadgeDetails?.value;
      if (badgeVal) {
        formData.append('customerValue', badgeVal);
      }
      const aNotes = this.leadForm.get('adminNotes')?.value;
      if (aNotes !== undefined && aNotes !== null) {
        formData.append('description', aNotes);
      }
    }

    return formData;
  }


  getChangedLeadFields(): any {
    const changed: any = {};
    Object.keys(this.leadForm.controls).forEach(key => {
      const control = this.leadForm.get(key);

      if (key === 'email') {
        const emailValue = (control?.value || '').trim();
        if (!emailValue) return;
        if (control?.invalid) return;
        changed[key] = emailValue;
        return;
      }

      if (control?.dirty) {
        if (key === 'adminNotes') {
          changed['description'] = control.value;
        } else if (key === 'customerValue') {
          changed['customerValue'] = control.value;
        } else {
          changed[key] = control.value;
        }
      }
    });


    // editor
    if (this.editorChanged) {
      changed.additionalNotes = this.getEditorText();
    }

    delete changed.adminNotes;
    delete changed.badge;

    return changed;
  }

  isUpdatingLead = false;
  logoChanged = false;
  isFormDirty = false;
  editorChanged = false;
  isSavingLead = false;
  updateLead() {
    if (this.isUpdatingLead) return;
    this.isUpdatingLead = true;
    this.isSavingLead = true;
    const requests: any = {};

    // ---------- LEAD UPDATE ---------- //
    const leadPayload = this.buildLeadPayload();
    requests.leadUpdate = leadPayload
      ? this.crmService.updateSalesLead(leadPayload)
      : of(null);

    // ---------- FOLLOW-UP ---------- //
    requests.followUp = this.shouldCreateFollowUp
      ? this.crmService.createFollowUp(this.buildFollowUpPayload())
      : of(null);

    // ---------- DISPOSITIONS ---------- //
    if (this.pendingDispositionsPayloads && this.pendingDispositionsPayloads.length > 0) {
      requests.dispositions = forkJoin(
        this.pendingDispositionsPayloads.map(item => this.crmService.createDisposition(item.payload))
      );
    }

    // ---------- REMINDER ---------- //
    if (this.showReminderSection && this.reminderDueAt && this.reminderDueTime) {
      const isOutbound = this.isOutboundLead(this.selectedLead);
      const targetProject = this.getActualLeadProject(this.selectedLead);
      const rawTab = this.selectedLead?.projectTab || this.selectedLead?.source || this.selectedLead?.sourceLead;
      let projectTab = rawTab;
      const upperProj = (targetProject || '').toUpperCase();
      if (upperProj === 'IIC-LAB' || upperProj === 'IIC' || upperProj === 'V-ESTATE') {
        projectTab = rawTab || 'IVR';
      }

      let dueAtIso: string;
      try {
        if (this.reminderDueTime) {
          dueAtIso = new Date(`${this.reminderDueAt}T${this.reminderDueTime}`).toISOString();
        } else {
          dueAtIso = new Date(this.reminderDueAt).toISOString();
        }
      } catch (e) {
        dueAtIso = new Date().toISOString();
      }

      const selectedStatus = this.selectedReminderStatus || this.pendingReminderTargetStatus || this.selectedLead?.status || this.selectedDispositionStatus || 'Contacted';

      const reminderPayload: any = {
        targetStatus: selectedStatus,
        leadId: this.selectedLead!._id,
        dueAt: dueAtIso
      };

      if (isOutbound) {
        reminderPayload.leadType = 'Outbound';
      } else {
        reminderPayload.project = targetProject;
        if (projectTab) {
          reminderPayload.projectTab = projectTab;
        }
        if (this.selectedLead?.leadType) {
          reminderPayload.leadType = this.selectedLead.leadType;
        } else if (this.selectedLead?.sourceLead || this.selectedLead?.source) {
          reminderPayload.leadType = this.selectedLead.sourceLead || this.selectedLead.source;
        } else {
          reminderPayload.leadType = 'Inbound';
        }
      }

      requests.reminder = this.crmService.createFollowUpReminder(reminderPayload);
    }


    forkJoin(requests).subscribe({
      next: (res: any) => {
        if (res.dispositions && Array.isArray(res.dispositions)) {
          res.dispositions.forEach((apiRes: any, i: number) => {
            const tempId = this.pendingDispositionsPayloads[i]?.tempId || this.pendingDispositions[i]?._id;
            const apiData = apiRes?.data || {};
            const realId = apiData._id || tempId;
            const realCreatedAt = apiData.createdAt;
            const realUpdatedAt = apiData.updatedAt;

            const index = this.dispositions.findIndex(d => d._id === tempId);
            if (index > -1) {
              this.dispositions[index] = {
                ...this.dispositions[index],
                ...apiData,
                _id: realId,
                ...(realCreatedAt ? { createdAt: realCreatedAt } : {}),
                ...(realUpdatedAt ? { updatedAt: realUpdatedAt } : {})
              };
            }

            if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
              const sIndex = this.singleLead.dispositionStatus.findIndex((d: any) => d._id === tempId);
              if (sIndex > -1) {
                this.singleLead.dispositionStatus[sIndex] = {
                  ...this.singleLead.dispositionStatus[sIndex],
                  ...apiData,
                  _id: realId,
                  ...(realCreatedAt ? { createdAt: realCreatedAt } : {}),
                  ...(realUpdatedAt ? { updatedAt: realUpdatedAt } : {})
                };
              }
            }
          });
          this.dispositions = [...this.dispositions];
          if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
            this.singleLead.dispositionStatus = [...this.singleLead.dispositionStatus];
          }
        }
        this.dispositionDirty = false;
        this.pendingDispositions = [];
        this.pendingDispositionsPayloads = [];
        this.showReminderSection = false;
        this.reminderDueAt = '';
        this.reminderDueTime = '';
        this.pendingReminderTargetStatus = '';
        this.selectedReminderStatus = null;
        this.selectedReminderStatusIcon = null;
        this.reminderStatusDropdownOpen = false;
        const targetLeadId = this.selectedLead?._id || this.selectedLeadForDetails?._id || this.singleLead?._id || (leadPayload instanceof FormData ? leadPayload.get('leadId') : leadPayload?.leadId);
        const rawForm = this.leadForm ? this.leadForm.getRawValue() : {};
        const badgeVal = rawForm.customerValue || this.selectedBadgeDetails?.value || (leadPayload instanceof FormData ? leadPayload.get('customerValue') : leadPayload?.customerValue);
        const aNotes = rawForm.adminNotes !== undefined && rawForm.adminNotes !== null ? rawForm.adminNotes : (leadPayload instanceof FormData ? leadPayload.get('description') : leadPayload?.description);

        const updatedFields: any = {
          ...rawForm,
          _id: targetLeadId
        };
        if (badgeVal) {
          updatedFields.customerValue = badgeVal;
          updatedFields.badge = badgeVal;
          if (this.selectedLead) {
            this.selectedLead.customerValue = badgeVal;
            this.selectedLead.badge = badgeVal;
          }
          if (this.selectedLeadForDetails) {
            this.selectedLeadForDetails.customerValue = badgeVal;
            this.selectedLeadForDetails.badge = badgeVal;
          }
          if (this.singleLead) {
            this.singleLead.customerValue = badgeVal;
            this.singleLead.badge = badgeVal;
          }
        }
        if (aNotes !== undefined && aNotes !== null) {
          updatedFields.adminNotes = aNotes;
          updatedFields.description = aNotes;
          if (this.selectedLead) {
            this.selectedLead.adminNotes = aNotes;
            this.selectedLead.description = aNotes;
          }
          if (this.selectedLeadForDetails) {
            this.selectedLeadForDetails.adminNotes = aNotes;
            this.selectedLeadForDetails.description = aNotes;
          }
          if (this.singleLead) {
            this.singleLead.adminNotes = aNotes;
            this.singleLead.description = aNotes;
          }
        }
        this.syncLeadInAllColumns(updatedFields);
        alertModalWithoutConfirm('success', 'Successfully Saved!');
        this.resetFormsAfterSave();
        this.handlePostUpdateUI();
        const savedLeadId = this.selectedLead?._id || this.selectedLeadForDetails?._id || this.singleLead?._id;
        if (savedLeadId) {
          this.updateRemindersHasNextTaskScheduled(savedLeadId);
        }
        this.fetchFollowUpReminders();
        this.fetchAllReminderCounts();
        this.isUpdatingLead = false;
      },
      error: err => {
        console.error('Update failed', err);
        alertModalWithoutConfirm('error', 'Save failed');
        this.isUpdatingLead = false;
        this.isSavingLead = false;
      }
    });
  }


  resetFormsAfterSave() {
    this.initialLeadSnapshot = this.leadForm.getRawValue();
    this.initialFollowUpSnapshot = this.followUpForm.getRawValue();
    // reset dirty state
    // this.typeDropdownOpen = false;
    // this.statusDropdownOpen = false;
    // this.showLostReason = false;
    // this.assigneeDropdownOpen = false;
    this.leadForm.markAsPristine();
    this.leadForm.markAsUntouched();
    this.followUpForm.markAsPristine();
    this.followUpForm.markAsUntouched();
    // reset custom flags
    this.logoChanged = false;
    this.editorChanged = false;
    this.dispositionDirty = false;
    this.pendingDispositions = [];
    this.pendingDispositionsPayloads = [];
    this.showReminderSection = false;
    this.reminderDueAt = '';
    this.reminderDueTime = '';
    this.pendingReminderTargetStatus = '';
    this.selectedReminderStatus = null;
    this.selectedReminderStatusIcon = null;
    this.reminderStatusDropdownOpen = false;
  }


  trackFormChanges() {
    // this.leadForm.valueChanges.subscribe(() => {
    //   this.isFormDirty = true;
    // });
    this.leadForm.valueChanges.subscribe(() => {
      if (this.leadForm.dirty) {
        this.isFormDirty = true;
      }
    });


    this.followUpForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  activeFollowupTab: 'Incomplete' | 'Completed' = 'Incomplete';
  followup: any[] = [];
  followupLoadingTab: { [key: string]: boolean } = {
    Incomplete: false,
    Completed: false
  };
  followupLoading = false;
  followupLoadingMore = false;

  get isFollowupLoading(): boolean {
    return !!this.followupLoadingTab[this.activeFollowupTab];
  }

  onFollowupTabChange(status: 'Incomplete' | 'Completed') {
    if (this.activeFollowupTab === status) return;

    this.activeFollowupTab = status;
    this.followupPage[status] = 1;
    this.followupHasMore[status] = true;
    this.followup = [];
    this.followupLoadingTab[status] = true;
    this.followupLoading = true;

    this.getFollowUpMeeting(status);
  }

  followupPage: { [key: string]: number } = {
    Incomplete: 1,
    Completed: 1
  };
  followupLimit = 100;
  followupHasMore: { [key: string]: boolean } = {
    Incomplete: true,
    Completed: true
  };

  onFollowupScroll() {
    if (this.isFollowupLoading || this.followupLoadingMore) return;

    const status = this.activeFollowupTab;
    if (!this.followupHasMore[status]) return;

    this.followupPage[status]++;
    this.getFollowUpMeeting(status, true);
  }

  upcomingCount = 0;
  completedCount = 0;

  getFollowUpMeeting(
    status: 'Incomplete' | 'Completed',
    loadMore = false
  ) {
    if (this.project === 'ALL' || this.project === 'all') return;
    if (loadMore && (this.followupLoadingMore || !this.followupHasMore[status])) return;

    if (loadMore) {
      this.followupLoadingMore = true;
    } else {
      this.followupLoadingTab[status] = true;
      this.followupLoading = true;
    }

    const body: any = {
      project: this.project,
      status,
      page: this.followupPage[status],
      limit: this.followupLimit
    };

    this.crmService.getFollowUp(body).subscribe({
      next: (res: any) => {
        if (loadMore) {
          this.followupLoadingMore = false;
        } else {
          this.followupLoadingTab[status] = false;
          this.followupLoading = this.isFollowupLoading;
        }

        const data = res?.data;
        if (!data) return;

        const list = data.followUpMeetingsData || [];

        if (loadMore) {
          if (this.activeFollowupTab === status) {
            this.followup = [...this.followup, ...list];
            if (this.followup.length >= data.totalCount) {
              this.followupHasMore[status] = false;
            }
          }
        } else if (this.activeFollowupTab === status) {
          this.followup = list;
          if (this.followup.length >= data.totalCount) {
            this.followupHasMore[status] = false;
          }
        }

        // counts always update
        if (status === 'Incomplete') {
          this.upcomingCount = data.totalCount;
        } else {
          this.completedCount = data.totalCount;
        }
      },
      error: () => {
        if (loadMore) {
          this.followupLoadingMore = false;
        } else {
          this.followupLoadingTab[status] = false;
          this.followupLoading = this.isFollowupLoading;
        }
      }
    });
  }

  formatTimeTo12Hour(time: string): string {
    if (!time) return '';

    const [hours, minutes] = time.split(':').map(Number);

    const period = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 || 12;

    return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  onUpdateFollowUp(follow: any, status: 'Removed' | 'Completed') {
    const body = {
      meetId: follow._id,
      status: status,
      type: follow.type,
      date: follow.date,
      time: follow.time
    };

    const params = {
      project: this.project
    };

    console.log('PATCH FOLLOW-UP BODY:', body);

    this.crmService.updateFollowUp(params, body).subscribe({
      next: () => {
        this.getFollowUpMeeting('Incomplete');
        this.getFollowUpMeeting('Completed');
      },
      error: err => {
        console.error('Follow-up update failed', err);
      }
    });
  }


  handlePostUpdateUI() {
    this.isUpdatingLead = false;
    const targetLeadId = this.selectedLead?._id || this.selectedLeadForDetails?._id || this.singleLead?._id;
    if (targetLeadId) {
      this.syncLeadInAllColumns({
        _id: targetLeadId,
        companyName: this.leadForm.get('companyName')?.value,
        designation: this.leadForm.get('designation')?.value
      });
    }

    this.closeDetailsPanel();

    setTimeout(() => {
      this.getAllAssignedLead();
      this.loadAllColumns();
      this.listenOverviewUpdates();
    }, 300);
  }


  private getEditorText(): string {
    const editorText = this.editorBlocks
      .filter(block => block.type === 'text' && block.value && block.value.trim())
      .map(block => block.value as string)
      .join('\n\n');
    return editorText;
  }

  onTextBlockInput(event: Event, index: number) {
    const textarea = event.target as HTMLTextAreaElement;

    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';

    this.editorBlocks[index].value = textarea.value;
    this.editorChanged = true;
  }





  getAssignedOnDate(dateStr: any): string {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "-";

    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "June",
      "July", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthName = months[date.getMonth()];
    const day = date.getDate();
    const formattedDate = `${monthName} ${day}`;

    const today = new Date();
    const d1 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const d2 = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const diffTime = d1.getTime() - d2.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `${formattedDate} (${diffDays}days ago)`;
    }
    return formattedDate || "-";
  }

  // ============== ASSIGN LEAD / ASSIGNEE SELECT ==============

  assignLeadToUser(user: any, lead: any) {
    if (this.assistantUser) return;

    this.selectedUserForLead = user.username || user.userName;
    lead.assignedToString = user.username || user.userName;

    const targetProject = (this.getActualLeadProject ? this.getActualLeadProject(lead) : null) || lead?.project || this.project;
    const isOutbound = this.project === 'OUTBOUND' || (lead && (lead.leadType === 'Outbound' || lead.leadType === 'OUTBOUND' || lead.project === 'OUTBOUND' || lead.source === 'Outbound' || lead.projectTab === 'Outbound')) || targetProject === 'OUTBOUND';

    const body: any = {
      userId: user._id || user.id,
      userName: user.userName || user.username,
      leadId: lead._id,
      redirectUrl: this.getKanbanRedirectUrlByProject(targetProject || this.project),
      chatRedirectUrl: `${environment.redirectUrl}#/main-chat?chatType=single&userId=${this.userId}`
    };

    if (isOutbound) {
      body.leadType = 'Outbound';
    } else {
      const rawSource = lead?.source || lead?.sourceLead || lead?.projectTab;
      let projectTab: string | undefined = undefined;
      if (targetProject === 'V-ESTATE' || targetProject === 'IIC-LAB' || targetProject === 'IIC') {
        projectTab = rawSource || 'IVR';
      } else if (rawSource) {
        projectTab = rawSource;
      }
      body.project = targetProject;
      if (projectTab) {
        body.projectTab = projectTab;
      }
    }

    this.crmService.assignLead(body).subscribe(
      (res) => {
        console.log("Lead assigned", res);
        this.getAdminOverView();
      },
      (err) => console.error(err)
    );
  }

  async unassignLead(lead: any) {
    if (!lead || !lead._id) return;

    const confirmed = await alertModalConfirm("Are you sure you want to unassign this lead?");
    if (!confirmed) return;

    const targetProject = (this.getActualLeadProject ? this.getActualLeadProject(lead) : null) || lead?.project || this.project;
    const isOutbound = this.project === 'OUTBOUND' || (lead && (lead.leadType === 'Outbound' || lead.leadType === 'OUTBOUND' || lead.project === 'OUTBOUND' || lead.source === 'Outbound' || lead.projectTab === 'Outbound')) || targetProject === 'OUTBOUND';

    const payload: any = {
      leadId: lead._id,
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      const rawSource = lead?.source || lead?.sourceLead || lead?.projectTab;
      let projectTab: string | undefined = undefined;
      if (targetProject === 'V-ESTATE' || targetProject === 'IIC-LAB' || targetProject === 'IIC') {
        projectTab = rawSource || 'IVR';
      } else if (rawSource) {
        projectTab = rawSource;
      }
      payload.project = targetProject;
      if (projectTab) {
        payload.projectTab = projectTab;
      }
    }

    this.crmService.unassignLead(payload).subscribe({
      next: (res: any) => {
        alertModalWithoutConfirm("success", "Successfully Unassigned");

        lead.assignedTo = null;
        lead.followUpAssignedTo = null;
        lead.assignedToString = "";
        this.selectedAssigneeName = "";
        this.selectedAssigneeId = "";

        this.getAdminOverView();

        if (this.getAllAssignedLead) {
          this.getAllAssignedLead();
        }
      },
      error: (err: any) => {
        console.error("Unassign error", err);
        alertModalWithoutConfirm("error", "Failed to unassign lead");
      }
    });
  }

  onAssigneeSelect(user: any) {
    this.selectedAssignee = user;
    this.singleLead.assignedToString = user.userName;
  }

  // ============== ASSIGNED LEADS LIST (TOP GRID) ==============

  searchText: string = "";
  assignedUserLead: any = []
  getAllAssignedLead() {
    const payload: any = {
      project: this.project,
      startDate: this.startDate ? this.formatDate(this.startDate) : "",
      endDate: this.endDate ? this.formatDate(this.endDate) : "",
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      searchQuery: (this.searchText || "").trim(),
      isActive: true
    };

    if (this.selectedCustomerValue) {
      payload.customerValue = this.selectedCustomerValue;
    }

    if (this.projectTab && this.projectTab !== 'ALL') {
      payload.projectTab = this.projectTab;
    }

    if (this.project === 'ALL') {
      payload.isAll = true;
    }

    this.crmService.getAssignedLead(payload).subscribe(
      (response: any) => {
        const newAssignedLeads = response.data.data;
        this.isCanvasLoading = false;

        this.assignedLeads = this.currentPageNume === 1 ? newAssignedLeads : [...this.assignedLeads, ...newAssignedLeads]
        this.totalAssignedCount = response?.data.leadsCount || 0;
        this.showNoDataMessage = this.assignedLeads.length === 0;
      }
    );
  }

  searchDebounce: any;

  onSearchChange() {
    clearTimeout(this.searchDebounce);

    this.searchDebounce = setTimeout(() => {
      this.currentPageNume = 1;
      this.assignedLeads = [];
      this.getAllAssignedLead();
    }, 400);
  }

  clearSearch() {
    this.searchText = "";
    this.currentPageNume = 1;
    this.assignedLeads = [];
    this.getAllAssignedLead();
  }

  salesUsers: any[] = [];
  selectedAssigneeId: string = "";
  userProgress: any;
  getSalesUserList() {
    this.crmService.getSalesUser().subscribe((res: any) => {
      const list = (res && (res.data || res)) || [];
      if (Array.isArray(list)) {
        this.salesUsers = list.map((u: any) => ({
          ...u,
          _id: u._id || u.id || u.userId,
          userName: u.userName || u.username || u.firstName || "",
          profileImg: u.profileImg || u.profileImage || u.userProfileImg || u.avatar || u.image || u.photo || ""
        }));
      } else {
        this.salesUsers = [];
      }

      this.userService.getUsersByDepartment('SALES,ASSISTANT-SALES').subscribe({
        next: (userRes: any) => {
          const fullUsers = (userRes && (userRes.data || userRes)) || [];
          if (Array.isArray(fullUsers) && fullUsers.length > 0) {
            const userMap = new Map<string, any>();
            fullUsers.forEach((fu: any) => {
              const name = (fu.userName || fu.username || fu.firstName || '').toLowerCase().trim();
              const id = String(fu._id || fu.id || fu.userId || '').trim();
              if (name) userMap.set(name, fu);
              if (id) userMap.set(id, fu);
            });

            this.salesUsers = this.salesUsers.map((su: any) => {
              const nameKey = (su.userName || '').toLowerCase().trim();
              const idKey = String(su._id || '').trim();
              const matched = userMap.get(nameKey) || userMap.get(idKey);
              return {
                ...su,
                profileImg: su.profileImg || matched?.profileImg || matched?.profileImage || matched?.avatar || ''
              };
            });
          }
        },
        error: () => { }
      });
    }, err => {
      console.error("Error fetching sales users list:", err);
    });
  }

  get isAssistantSalesUser(): boolean {
    const dept = String(this.userDepartment || localStorage.getItem('department') || '').trim().toLowerCase();
    const role = String((this as any).userRole || localStorage.getItem('role') || localStorage.getItem('userRole') || '').trim().toLowerCase();
    return (
      this.assistantUser === true ||
      dept.includes('assistant') ||
      role.includes('assistant')
    );
  }

  get isSalesAccount(): boolean {
    const dept = String(this.userDepartment || localStorage.getItem('department') || '').trim().toLowerCase();
    return (dept === 'sales' || this.isSalesDepartment) && !this.isAssistantSalesUser && !this.loggedInUser && !this.isAdmin;
  }

  selectedReassignUser: any = null;
  reassignDropdownOpen: boolean = false;
  isReassigning: boolean = false;

  getLeadFollowUpAssigneeId(lead?: any): string {
    const targetLead = lead || this.selectedLeadForDetails || this.selectedLead || this.singleLead;
    if (!targetLead) return '';
    return String(
      targetLead.followUpAssignedTo?.userId ||
      targetLead.followUpAssignedTo?._id ||
      targetLead.followUpAssignedTo?.id ||
      targetLead.followUpAssignee ||
      targetLead.followUpAssigneeId ||
      targetLead.assignedTo?.userId ||
      targetLead.assignedTo?._id ||
      targetLead.assignedTo?.id ||
      (Array.isArray(targetLead.assignedTo) && (targetLead.assignedTo[0]?.userId || targetLead.assignedTo[0]?._id || targetLead.assignedTo[0]?.id)) ||
      ''
    ).trim();
  }

  canAssistantSalesReassign(lead?: any): boolean {
    const targetLead = lead || this.selectedLeadForDetails || this.selectedLead || this.singleLead;
    if (!targetLead) return false;
    return true;
  }

  toggleReassignDropdown(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (!this.salesUsers || this.salesUsers.length === 0) {
      this.getSalesUserList();
    }
    const willOpen = !this.reassignDropdownOpen;
    this.closeAllDropdowns();
    this.reassignDropdownOpen = willOpen;
  }

  selectReassignUser(user: any, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.selectedReassignUser = user;
    this.reassignDropdownOpen = false;
  }

  clearReassignUser(event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.selectedReassignUser = null;
  }

  reassignLead() {
    const targetLead = this.selectedLeadForDetails || this.selectedLead || this.singleLead;
    if (!targetLead || !targetLead._id) {
      alertModalWithoutConfirm('error', 'No lead selected');
      return;
    }

    if (!this.selectedReassignUser) {
      alertModalWithoutConfirm('warning', 'Please select a sales user to reassign');
      return;
    }

    this.isReassigning = true;

    const leadId = targetLead._id || targetLead.id;
    const targetProject = (this.getActualLeadProject ? this.getActualLeadProject(targetLead) : null) || targetLead?.project || this.project || 'V-RETAIL';
    const isOutbound = this.project === 'OUTBOUND' || (targetLead && (targetLead.leadType === 'Outbound' || targetLead.leadType === 'OUTBOUND' || targetLead.project === 'OUTBOUND' || targetLead.source === 'Outbound' || targetLead.projectTab === 'Outbound')) || targetProject === 'OUTBOUND';

    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject || this.project);
    const chatRedirectUrl = `${environment.redirectUrl}#/main-chat?chatType=single&userId=${this.userId}`;

    const payload: any = {
      leadId: leadId,
      userId: this.selectedReassignUser._id || this.selectedReassignUser.id || this.selectedReassignUser.userId,
      userName: this.selectedReassignUser.userName || this.selectedReassignUser.username || this.selectedReassignUser.name,
      redirectUrl: redirectUrl,
      chatRedirectUrl: chatRedirectUrl
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      const rawSource = targetLead?.source || targetLead?.sourceLead || targetLead?.projectTab;
      let projectTab: string | undefined = undefined;
      if (targetProject === 'V-ESTATE' || targetProject === 'IIC-LAB' || targetProject === 'IIC') {
        projectTab = rawSource || 'IVR';
      } else if (rawSource) {
        projectTab = rawSource;
      }
      payload.project = targetProject;
      if (projectTab) {
        payload.projectTab = projectTab;
      }
    }

    this.crmService.reassignLead(payload).subscribe({
      next: (res: any) => {
        this.isReassigning = false;
        alertModalWithoutConfirm('success', 'Lead reassigned successfully!');

        const newUserName = this.selectedReassignUser.userName || this.selectedReassignUser.username || '';
        const newUserId = this.selectedReassignUser._id || this.selectedReassignUser.id || '';

        targetLead.followUpAssignedTo = {
          userId: newUserId,
          userName: newUserName
        };
        targetLead.followUpAssignee = newUserId;
        targetLead.assignedToString = newUserName;
        this.selectedAssigneeName = newUserName;
        this.selectedReassignUser = null;

        this.getAdminOverView();
        if (this.getAllAssignedLead) {
          this.getAllAssignedLead();
        }
        if (leadId) {
          this.getSingleLeadById(leadId, targetLead.source, targetProject);
        }
        if (this.currentView === 'kanban') {
          this.loadAllColumns();
        }
      },
      error: (err: any) => {
        this.isReassigning = false;
        console.error('Reassign error:', err);
        alertModalWithoutConfirm('error', err?.error?.message || 'Failed to reassign lead');
      }
    });
  }

  assigneeDropdownOpen = false;
  selectedAssigneeName = "";
  toggleAssigneeDropdown(event: Event) {
    if (this.assistantUser) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    if (!this.salesUsers || this.salesUsers.length === 0) {
      this.getSalesUserList();
    }
    const willOpen = !this.assigneeDropdownOpen;
    this.closeAllDropdowns();
    this.assigneeDropdownOpen = willOpen;
  }



  selectAssignee(user: any, event?: Event) {
    // Prevent ASSISTANT-SALES users from selecting an assignee
    if (this.assistantUser) {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      return;
    }

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    this.selectedAssigneeId = user._id;
    this.selectedAssigneeName = user.userName;
    this.assigneeDropdownOpen = false;
    this.leadForm.patchValue({ followUpAssignee: user._id });
    this.leadForm.get('followUpAssignee')?.markAsDirty();
    this.leadForm.get('followUpAssignee')?.markAsTouched();
  }

  private getProjectForSource(source?: string): string | undefined {
    if (!source) {
      return undefined;
    }

    const normalizedSource = source.trim().toLowerCase();
    const vRetailSources = new Set([
      'book demo',
      'user onboard',
      'lead magnet features',
      'lead magnet book demo',
      'lead magnet pricing'
    ]);
    const vEstateSources = new Set(['whatsapp', 'ivr', 'ads']);
    const iicLabSources = new Set(['news letter', 'newsletter', 'career']);

    if (vRetailSources.has(normalizedSource)) {
      return 'V-RETAIL';
    }

    if (vEstateSources.has(normalizedSource)) {
      return 'V-ESTATE';
    }

    if (iicLabSources.has(normalizedSource)) {
      return 'IIC-LAB';
    }

    if (normalizedSource === 'contact us') {
      return 'V-RETAIL';
    }

    return undefined;
  }

  onProjectTabChange(tab: string) {
    this.projectTab = tab;
    this.currentPageNume = 1;
    this.getAllAssignedLead();
  }

  // ADMIN OVERVIEW COUNT
  totalsLeadsCounts: any;
  totalInProgressCount: any;
  totalConvertedLeadsCount: any;
  totalLostLeadsCount: any;
  totalClosingPoolCount: any;
  progressLeadPercentage: any;
  convertedLeadPercentage: any;
  lostLeadsPercentage: any;
  salesUserName: any;
  progressLeadTrend: any = { type: 'neutral', value: 0, text: 'No change from last week' };
  convertedLeadTrend: any = { type: 'neutral', value: 0, text: 'No change from last week' };
  lostLeadTrend: any = { type: 'neutral', value: 0, text: 'No change from last week' };
  totalLeadsTrend: any = { type: 'neutral', value: 0, text: 'No change from last week' };
  role: any;
  isUserCardLoading = true;

  //Dashboard overview 
  getAdminOverView() {
    this.crmService
      .getLeadsOverview(this.project, this.startDate, this.endDate)
      .subscribe((res: any) => {
        this.isStatsLoading = false;
        this.isUserCardLoading = false;
        this.isLeadDataLoading = false;

        this.totalsLeadsCounts = res.data.totalLeadsCount;
        this.salesUserName = res.data.userName;
        this.role = res.data.role;

        this.totalInProgressCount = res.data.inProgressLeadsCount;
        this.totalConvertedLeadsCount = res.data.convertedLeadsCount;
        this.totalLostLeadsCount = res.data.lostLeadsCount;
        this.totalClosingPoolCount = res.data.closingPoolCount;

        this.progressLeadPercentage = res.data.inProgressLeadsPercentage;
        this.convertedLeadPercentage = res.data.convertedLeadsPercentage;
        this.lostLeadsPercentage = res.data.lostLeadsPercentage;

        this.userProgress = res.data.userProgress;

        this.progressLeadTrend = this.getTrendText(res.data.inProgressLeadsChange);
        this.convertedLeadTrend = this.getTrendText(res.data.convertedLeadsChange);
        this.lostLeadTrend = this.getTrendText(res.data.lostLeadsChange);
        this.totalLeadsTrend = this.getTrendText(res.data.totalLeadsChange);

        this.updateLeadData();
        // Use breakdown API for complete counts update in sales dashboard for territory maps (do not use overview API)
        this.getAllLeadsBreakdown();
      });
  }

  getTrendText(change: number) {
    if (change > 0) {
      return {
        value: change,
        text: 'more than last week',
        type: 'positive'
      };
    }

    if (change < 0) {
      return {
        value: Math.abs(change),
        text: 'less than last week',
        type: 'negative'
      };
    }

    return {
      value: 0,
      text: 'No change from last week',
      type: 'neutral'
    };
  }



  isLeadDataLoading: boolean = true;
  updateLeadData() {
    this.isLeadDataLoading = true;
    this.isStatsLoading = true;
    setTimeout(() => {
      this.leadData = [
        { label: "Converted Leads", color: "#00c506", value: parseFloat(this.convertedLeadPercentage) || 0 },
        { label: "In Progress Leads", color: "#249eff", value: parseFloat(this.progressLeadPercentage) || 0 },
        { label: "Lost Leads", color: "#f16c6c", value: parseFloat(this.lostLeadsPercentage) || 0 }
      ];

      this.isLeadDataLoading = false;
      this.isStatsLoading = false;
    }, 300);

  }

  // Progress template
  get isGoodProgress(): boolean {
    return this.userProgress === 'Good';
  }

  get isBadProgress(): boolean {
    return this.userProgress === 'Bad';
  }

  getModuleRouteByProject(project?: string): string {
    const p = (project || this.project || 'ALL').toUpperCase().trim();
    if (p.includes('IIC')) return 'iic-leads';
    if (p.includes('ESTATE')) return 'vestate-leads';
    if (p.includes('RETAIL')) return 'vretail-leads';
    if (p.includes('OUTBOUND')) return 'outbound-leads';
    return 'all-leads';
  }

  getKanbanRedirectUrlByProject(project: string): string {
    const path = this.getModuleRouteByProject(project);

    return `${environment.redirectUrl}#/lead-track/${path}?view=kanban`;
  }

  openKanbanFromRoute() {
    // this.showCanvasUI = true;
    this.isCanvasLoading = true;
    this.loadAllColumns();
  }


  //  to view Kanban
  goToKanban() {
    const moduleRoute = this.getModuleRouteByProject(this.project);
    this.router.navigate([`/lead-track/${moduleRoute}`], { queryParams: { view: 'kanban' } });
  }

  goToKanbanClosingPool() {
    const moduleRoute = this.getModuleRouteByProject(this.project);
    this.router.navigate([`/lead-track/${moduleRoute}`], { queryParams: { view: 'kanban', column: 'closing-pool' } });

    setTimeout(() => {
      const el = document.getElementById('drop-list-6');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }, 500);
  }

  //update Lead
  updateLeadLocally(updatedLead: any) {
    if (!updatedLead) return;
    this.syncLeadInAllColumns(updatedLead);
  }

  syncLeadInAllColumns(updatedLead: any) {
    if (!updatedLead) return;
    const leadId = String(updatedLead._id || updatedLead.id || updatedLead.leadId || '');
    if (!leadId) return;

    const matchLead = (l: any) => {
      if (!l) return false;
      const id = String(l._id || l.id || l.leadId || '');
      return id === leadId;
    };

    if (this.assignedLeadsCanvas) {
      this.assignedLeadsCanvas = this.assignedLeadsCanvas.map((l: any) =>
        matchLead(l) ? { ...l, ...updatedLead } : l
      );
    }
    if (this.followUpLeadsCanvas) {
      this.followUpLeadsCanvas = this.followUpLeadsCanvas.map((l: any) =>
        matchLead(l) ? { ...l, ...updatedLead } : l
      );
    }
    if (this.emptyColumns) {
      this.emptyColumns = this.emptyColumns.map((col: any) => ({
        ...col,
        items: (col.items || []).map((item: any) =>
          matchLead(item) ? { ...item, ...updatedLead } : item
        )
      }));
    }
    if (this.assignedLeads) {
      this.assignedLeads = this.assignedLeads.map((l: any) =>
        matchLead(l) ? { ...l, ...updatedLead } : l
      );
    }
    if (this.leads) {
      this.leads = this.leads.map((l: any) =>
        matchLead(l) ? { ...l, ...updatedLead } : l
      );
    }
    if (this.singleLead && matchLead(this.singleLead)) {
      this.singleLead = { ...this.singleLead, ...updatedLead };
    }
    if (this.selectedLead && matchLead(this.selectedLead)) {
      this.selectedLead = { ...this.selectedLead, ...updatedLead };
    }
    if (this.selectedLeadForDetails && matchLead(this.selectedLeadForDetails)) {
      this.selectedLeadForDetails = { ...this.selectedLeadForDetails, ...updatedLead };
    }
    this.cdr.markForCheck();
  }

  isUpdatingClosingPool = false;
  toggleClosingPool(leadParam?: any) {
    if (this.isUpdatingClosingPool) return;
    const targetLead = leadParam || this.selectedLead || this.selectedLeadForDetails || this.singleLead;
    if (!targetLead || !targetLead._id) return;

    const currentVal = !!(targetLead.hasClosingPotential === true || targetLead.hasClosingPotential === 'true' || targetLead.status === 'Closing Pool' || targetLead.stageStatus === 'Closing Pool');
    const newVal = !currentVal;

    this.isUpdatingClosingPool = true;

    const leadObj = targetLead;
    const isOutboundLead =
      this.project === 'OUTBOUND' ||
      (leadObj && (
        String(leadObj.leadType).toLowerCase() === 'outbound' ||
        String(leadObj.project).toLowerCase() === 'outbound' ||
        String(leadObj.source).toLowerCase() === 'outbound' ||
        String(leadObj.sourceLead).toLowerCase() === 'outbound' ||
        String(leadObj.projectTab).toLowerCase() === 'outbound'
      ));

    const targetProject = this.getActualLeadProject(leadObj);
    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);

    const payload: any = {
      leadId: targetLead._id,
      hasClosingPotential: newVal,
      redirectUrl: redirectUrl
    };

    if (isOutboundLead) {
      payload.leadType = 'Outbound';
    } else {
      if (targetProject && targetProject !== 'ALL') {
        payload.project = targetProject;
      }
      const rawTab = leadObj?.source || leadObj?.sourceLead || leadObj?.projectTab || this.singleLead?.source || this.singleLead?.projectTab;
      const projectTab = rawTab || (targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE' || targetProject === 'IIC' ? 'IVR' : undefined);
      if (projectTab) {
        payload.projectTab = projectTab;
      }
    }

    this.crmService.updateSalesLead(payload).subscribe({
      next: () => {
        this.isUpdatingClosingPool = false;
        targetLead.hasClosingPotential = newVal;
        if (this.selectedLead) this.selectedLead.hasClosingPotential = newVal;
        if (this.selectedLeadForDetails) this.selectedLeadForDetails.hasClosingPotential = newVal;
        if (this.singleLead) this.singleLead.hasClosingPotential = newVal;

        // Update Closing Pool column immediately (index 6 in emptyColumns)
        const closingPoolCol = this.emptyColumns[6];
        if (closingPoolCol) {
          if (newVal) {
            const exists = closingPoolCol.items.some((item: any) => item._id === targetLead._id);
            if (!exists) {
              closingPoolCol.items = [targetLead, ...closingPoolCol.items];
              this.totalStatusCount['Closing Pool'] = (this.totalStatusCount['Closing Pool'] || 0) + 1;
            }
          } else {
            const prevLen = closingPoolCol.items.length;
            closingPoolCol.items = closingPoolCol.items.filter((item: any) => item._id !== targetLead._id);
            if (closingPoolCol.items.length < prevLen) {
              this.totalStatusCount['Closing Pool'] = Math.max(0, (this.totalStatusCount['Closing Pool'] || 0) - 1);
            }
          }
        }

        // Sync updated lead across all other columns so the card state is updated
        this.syncLeadInAllColumns({ ...targetLead, hasClosingPotential: newVal });
        this.getAllLeadsBreakdown();

        const newDisposition: Disposition = {
          _id: 'temp_' + Date.now(),
          leadId: targetLead._id,
          type: 'System',
          event: 'Closing Pool Update',
          hasClosingPotential: newVal,
          updatedAt: new Date().toISOString(),
          createdAt: new Date().toISOString()
        };
        this.dispositions = [newDisposition, ...this.dispositions];

        alertModalWithoutConfirm('success', newVal ? 'Added to Closing Pool!' : 'Removed from Closing Pool!');
      },
      error: (err: any) => {
        this.isUpdatingClosingPool = false;
        console.error('Error updating closing pool status:', err);
        alertModalWithoutConfirm('error', 'Failed to update Closing Pool');
      }
    });
  }

  //Go Back to Dashboard
  goBackToLeads() {
    const moduleRoute = this.getModuleRouteByProject(this.project);
    this.router.navigate([`/lead-track/${moduleRoute}`], { queryParams: {} });
    this.showDetailsPanel = false;
    this.startDate = "";
    this.endDate = "";
    this.selectedDateRange = null;
    this.displayDateRange = null;
    this.isFilteredView = false;
    this.getFollowUpMeeting('Incomplete');
    this.getAllAssignedLead();
    this.listenOverviewUpdates();
  }  //Open Update Lead Form
  activeDetailsLeadId: string | null = null;
  isLoadingLeadDetails: boolean = false;

  openDetailsPanel(lead: any) {
    if (!lead) return;
    this.closeAllDropdowns();
    this.resetAudioPlayer();
    this.isUpdatingLead = false;
    this.pendingDispositions = [];
    this.pendingDispositionsPayloads = [];
    this.dispositionDirty = false;
    this.showReminderSection = false;
    this.reminderDueAt = '';
    this.pendingReminderTargetStatus = '';
    this.assistantTaskReminderDueAt = '';
    this.selectedLead = lead;
    this.selectedLeadForDetails = lead;
    this.showDetailsPanel = true;
    const currentId = String(lead._id || lead.id || '');
    this.activeDetailsLeadId = currentId;
    this.isLoadingLeadDetails = true;

    if (!this.salesUsers || this.salesUsers.length === 0) {
      this.getSalesUserList();
    }

    this.followUpForm.reset();

    // Immediately populate the form from the known Kanban card data to eliminate blank fields
    this.patchLeadForm(lead);
    this.followUpTasks = lead?.followUpTasks || [];
    this.dispositions = lead?.dispositionStatus || [];
    this.updatePreselectedStatuses(null, lead);
    this.selectedAssigneeName = this.isSalesAccount
      ? (lead?.followUpAssignedTo?.userName || lead?.followUpAssigneeName || '')
      : (lead?.followUpAssignedTo?.userName || lead?.assignedTo?.userName || '');

    this.getSingleLeadById(lead._id, lead.source, lead.project, lead);
    this.getLatestFollowUpForLead(lead._id, lead);

    setTimeout(() => {
      const panel = document.querySelector('.details-panel');
      const backdrop = document.querySelector('.details-panel-backdrop');

      panel?.classList.add('slide-in');
      backdrop?.classList.add('fade-in');
    });
  }

  selectLeadInCanvas(lead: any) {
    if (!lead) return;
    console.log("SELECTED LEAD:", lead._id);
    this.selectedLeadForDetails = lead;
    this.selectedLead = lead;
    console.log("ACTIVE LEAD ID:", lead._id);

    this.editorBlocks = [];
    if (this.activeDetailsLeadId === String(lead._id || lead.id)) {
      return;
    }
    if (!this.showDetailsPanel || this.singleLead?._id !== lead._id) {
      this.getSingleLeadById(lead._id, lead.source, lead.project, lead);
    }
  }

  getLatestFollowUpForLead(leadId: string, lead?: any) {
    const leadObj = lead || this.selectedLead || this.selectedLeadForDetails || (this.assignedLeadsCanvas && this.assignedLeadsCanvas.find(l => l._id === leadId)) || (this.leads && this.leads.find(l => l._id === leadId));
    const targetProject = this.getActualLeadProject(leadObj);
    const isOutboundLead =
      this.project === 'OUTBOUND' ||
      (leadObj && (
        String(leadObj.leadType).toLowerCase() === 'outbound' ||
        String(leadObj.project).toLowerCase() === 'outbound' ||
        String(leadObj.source).toLowerCase() === 'outbound' ||
        String(leadObj.sourceLead).toLowerCase() === 'outbound' ||
        String(leadObj.projectTab).toLowerCase() === 'outbound'
      )) ||
      (targetProject && targetProject.toUpperCase() === 'OUTBOUND');

    const body: any = {
      leadId,
      status: 'Incomplete'
    };

    if (isOutboundLead) {
      body.leadType = 'Outbound';
    } else {
      body.project = targetProject;
      const rawTab = leadObj?.source || leadObj?.sourceLead || leadObj?.projectTab;
      const projectTab = rawTab || ((targetProject === 'IIC-LAB' || targetProject === 'V-ESTATE' || targetProject === 'IIC') ? 'IVR' : undefined);
      if (projectTab) {
        body.projectTab = projectTab;
      }
    }

    this.crmService.getFollowUp(body).subscribe((res: any) => {
      if (this.activeDetailsLeadId && this.activeDetailsLeadId !== String(leadId)) {
        return;
      }
      const followUps = res?.data?.followUpMeetingsData || [];

      if (!followUps.length) {
        this.followUpForm.reset();
        this.initialFollowUpSnapshot = this.followUpForm.getRawValue();
        return;
      }

      const leadFollowUps = followUps.filter(
        (f: any) => f.leadId === leadId
      );

      if (!leadFollowUps.length) {
        this.followUpForm.reset();
        this.initialFollowUpSnapshot = this.followUpForm.getRawValue();
        return;
      }
      const latest = leadFollowUps.sort(
        (a: any, b: any) =>
          new Date(b.createdAt).getTime() -
          new Date(a.createdAt).getTime()
      )[0];

      this.populateFollowUpForm(latest);
    });
  }


  // Populate follow-up form with data
  populateFollowUpForm(followUp: any) {
    const formattedDate = followUp.date
      ? (typeof followUp.date === 'string' ? followUp.date.split('T')[0] : new Date(followUp.date).toISOString().split('T')[0])
      : (followUp.followUpDate ? (typeof followUp.followUpDate === 'string' ? followUp.followUpDate.split('T')[0] : new Date(followUp.followUpDate).toISOString().split('T')[0]) : '');

    this.followUpForm.patchValue({
      date: formattedDate,
      time: followUp.time || followUp.followUpTime || '',
      type: followUp.type || followUp.followUpType || ''
    });

    this.followUpForm.markAsPristine();
    this.followUpForm.markAsUntouched();
    this.initialFollowUpSnapshot = this.followUpForm.getRawValue();
  }

  // Clear selected assignee
  clearAssignee(event: MouseEvent) {
    // Prevent ASSISTANT-SALES users from clearing the assignee
    if (this.assistantUser) {
      event.stopPropagation();
      return;
    }

    event.stopPropagation();
    this.selectedAssigneeName = '';
    this.selectedAssignee = null;
  }


  // Format date for input fields (YYYY-MM-DD)
  formatDateForInput(dateString: string): string {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  }

  // Close details panel (update lead Form)
  closeDetailsPanel() {
    this.activeDetailsLeadId = null;
    this.isLoadingLeadDetails = false;
    this.selectedAssigneeName = '';
    this.selectedAssignee = null;
    this.selectedReassignUser = null;
    this.reassignDropdownOpen = false;
    this.followUpTasks = [];
    this.followUpTaskDescription = '';
    this.selectedFollowUpTaskAssignee = null;
    this.followUpTaskAssigneeDropdownOpen = false;
    this.assistantTaskNote = '';
    this.assistantTaskReminderDueAt = '';
    this.resetAudioPlayer();
    this.isUpdatingLead = false;
    this.pendingDispositions = [];
    this.pendingDispositionsPayloads = [];
    this.dispositions = (this.dispositions || []).filter(d => !String(d._id).startsWith('temp-'));
    if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
      this.singleLead.dispositionStatus = this.singleLead.dispositionStatus.filter((d: any) => !String(d._id).startsWith('temp-'));
    }
    this.dispositionDirty = false;
    this.showReminderSection = false;
    this.reminderDueAt = '';
    this.pendingReminderTargetStatus = '';
    const panel = document.querySelector('.details-panel');
    const backdrop = document.querySelector('.details-panel-backdrop');

    if (panel) panel.classList.remove('slide-in');
    if (panel) panel.classList.add('slide-out');

    if (backdrop) backdrop.classList.remove('fade-in');
    if (backdrop) backdrop.classList.add('fade-out');

    setTimeout(() => {
      this.showDetailsPanel = false;
      this.cdr.markForCheck();
    }, 300);
  }


  // Fetch single lead details by ID into update Lead Form
  initialLeadSnapshot: any = {};
  initialFollowUpSnapshot: any = {};
  getSingleLeadById(id: string | number, projectTab?: string | any, targetProject?: string, leadParam?: any) {
    const leadObj = leadParam || (typeof projectTab === 'object' ? projectTab : null) || (typeof targetProject === 'object' ? targetProject : null) || this.selectedLead || this.selectedLeadForDetails || (this.assignedLeadsCanvas && this.assignedLeadsCanvas.find((l: any) => l._id === id)) || (this.leads && this.leads.find((l: any) => l._id === id));
    const isOutboundLead =
      this.project === 'OUTBOUND' ||
      (leadObj && (
        String(leadObj.leadType).toLowerCase() === 'outbound' ||
        String(leadObj.project).toLowerCase() === 'outbound' ||
        String(leadObj.source).toLowerCase() === 'outbound' ||
        String(leadObj.sourceLead).toLowerCase() === 'outbound' ||
        String(leadObj.projectTab).toLowerCase() === 'outbound'
      )) ||
      (targetProject && String(targetProject).toUpperCase() === 'OUTBOUND') ||
      (typeof projectTab === 'string' && projectTab.toLowerCase() === 'outbound');

    const resolvedProject = this.getActualLeadProject(leadObj);
    let project = isOutboundLead ? 'OUTBOUND' : (targetProject && targetProject !== 'ALL' ? targetProject : (resolvedProject || leadObj?.project || this.project));
    if (project === 'ALL') {
      project = resolvedProject || '';
    }
    const uppercaseProject = (project || '').toUpperCase();
    const rawTab = (typeof projectTab === 'string' ? projectTab : undefined) || (leadObj?.source) || (leadObj?.sourceLead) || (this.selectedLeadForDetails?.source) || (this.selectedLead?.source) || (this.selectedLead?.sourceLead);
    let tabToPass = isOutboundLead ? undefined : rawTab;
    if (!isOutboundLead && (uppercaseProject === 'IIC-LAB' || uppercaseProject === 'IIC' || uppercaseProject === 'V-ESTATE')) {
      tabToPass = rawTab || 'IVR';
    }

    const requestLeadId = String(id);
    this.crmService.getSingleLead(id, isOutboundLead ? undefined : project, tabToPass, isOutboundLead ? 'Outbound' : undefined).subscribe({
      next: (res: any) => {
        if (this.activeDetailsLeadId && this.activeDetailsLeadId !== requestLeadId) {
          console.log(`[getSingleLeadById] Discarding response for ${requestLeadId} because active is ${this.activeDetailsLeadId}`);
          return;
        }
        this.isLoadingLeadDetails = false;
        this.resetAudioPlayer();
        const apiLead = res?.data;
        if (!apiLead) return;

        const apiHasClosing = apiLead.hasClosingPotential !== undefined
          ? (apiLead.hasClosingPotential === true || apiLead.hasClosingPotential === 'true')
          : (leadObj?.hasClosingPotential === true || leadObj?.hasClosingPotential === 'true');

        const mergedLead = {
          ...leadObj,
          ...apiLead,
          hasClosingPotential: apiHasClosing,
          contactName: apiLead.contactName || apiLead.leadName || apiLead.name || leadObj?.contactName || leadObj?.leadName || leadObj?.name || '',
          name: apiLead.name || apiLead.contactName || apiLead.leadName || leadObj?.name || leadObj?.contactName || leadObj?.leadName || '',
          leadName: apiLead.leadName || apiLead.contactName || apiLead.name || leadObj?.leadName || leadObj?.contactName || leadObj?.name || '',
          companyName: apiLead.companyName || leadObj?.companyName || '',
          phoneNo: apiLead.phoneNo || apiLead.callerId || apiLead.phone || apiLead.phoneNumber || apiLead.mobile || apiLead.mobileNo || leadObj?.phoneNo || leadObj?.callerId || leadObj?.phone || leadObj?.phoneNumber || leadObj?.mobile || '',
          email: apiLead.email || (Array.isArray(apiLead.emails) && apiLead.emails[0]) || leadObj?.email || (Array.isArray(leadObj?.emails) && leadObj?.emails[0]) || '',
          designation: apiLead.designation || leadObj?.designation || '',
          status: apiLead.status || leadObj?.status || '',
          customerValue: apiLead.customerValue || leadObj?.customerValue || leadObj?.badge || '',
          dispositionStatus: apiLead.dispositionStatus || leadObj?.dispositionStatus || [],
          followUpTasks: apiLead.followUpTasks || leadObj?.followUpTasks || [],
          media: apiLead.media || leadObj?.media || [],
          additionalNotes: apiLead.additionalNotes || leadObj?.additionalNotes || ''
        };

        this.singleLead = mergedLead;
        this.selectedLead = mergedLead;
        this.selectedLeadForDetails = mergedLead;
        this.dispositions = mergedLead.dispositionStatus || [];
        this.followUpTasks = mergedLead.followUpTasks || [];
        this.assistantTaskNote = '';
        this.assistantTaskReminderDueAt = '';

        this.patchLeadForm(mergedLead);
        this.initialLeadSnapshot = this.leadForm.getRawValue();
        this.initialFollowUpSnapshot = this.followUpForm.getRawValue();
        this.selectedLeadStatus = mergedLead.status || "";
        this.updatePreselectedStatuses(null, mergedLead);
        this.selectedAssigneeName = this.isSalesAccount
          ? (mergedLead.followUpAssignedTo?.userName || mergedLead.followUpAssigneeName || "")
          : (mergedLead.followUpAssignedTo?.userName || mergedLead.assignedTo?.userName || "");
        this.selectedReassignUser = null;
        this.reassignDropdownOpen = false;
        this.logoPreview = mergedLead.companyProfileImg || null;
        this.loadEditorBlocks(mergedLead.additionalNotes || "");
        this.loadMediaBlocks(mergedLead.media || []);
        this.showDetailsPanel = true;
        this.pendingDispositions = [];
        this.pendingDispositionsPayloads = [];
        this.dispositionDirty = false;
        this.showReminderSection = false;
        this.reminderDueAt = '';
        this.pendingReminderTargetStatus = '';
      },
      error: (err) => {
        console.error("Error fetching lead:", err);
        // If query with tabToPass failed, retry once without tabToPass
        if (tabToPass && (!this.activeDetailsLeadId || this.activeDetailsLeadId === requestLeadId)) {
          this.crmService.getSingleLead(id, isOutboundLead ? undefined : project, undefined, isOutboundLead ? 'Outbound' : undefined).subscribe({
            next: (fallbackRes: any) => {
              if (this.activeDetailsLeadId && this.activeDetailsLeadId !== requestLeadId) return;
              this.isLoadingLeadDetails = false;
              const apiLead = fallbackRes?.data;
              if (!apiLead) return;
              const fallbackHasClosing = apiLead.hasClosingPotential !== undefined
                ? (apiLead.hasClosingPotential === true || apiLead.hasClosingPotential === 'true')
                : (leadObj?.hasClosingPotential === true || leadObj?.hasClosingPotential === 'true');
              const mergedLead = {
                ...leadObj,
                ...apiLead,
                hasClosingPotential: fallbackHasClosing,
                contactName: apiLead.contactName || apiLead.leadName || apiLead.name || leadObj?.contactName || leadObj?.leadName || leadObj?.name || '',
                name: apiLead.name || apiLead.contactName || apiLead.leadName || leadObj?.name || leadObj?.contactName || leadObj?.leadName || '',
                leadName: apiLead.leadName || apiLead.contactName || apiLead.name || leadObj?.leadName || leadObj?.contactName || leadObj?.name || '',
                companyName: apiLead.companyName || leadObj?.companyName || '',
                phoneNo: apiLead.phoneNo || apiLead.callerId || apiLead.phone || apiLead.phoneNumber || apiLead.mobile || apiLead.mobileNo || leadObj?.phoneNo || leadObj?.callerId || leadObj?.phone || leadObj?.phoneNumber || leadObj?.mobile || '',
                email: apiLead.email || (Array.isArray(apiLead.emails) && apiLead.emails[0]) || leadObj?.email || (Array.isArray(leadObj?.emails) && leadObj?.emails[0]) || '',
                designation: apiLead.designation || leadObj?.designation || '',
                status: apiLead.status || leadObj?.status || '',
                customerValue: apiLead.customerValue || leadObj?.customerValue || leadObj?.badge || '',
                dispositionStatus: apiLead.dispositionStatus || leadObj?.dispositionStatus || [],
                followUpTasks: apiLead.followUpTasks || leadObj?.followUpTasks || [],
                media: apiLead.media || leadObj?.media || [],
                additionalNotes: apiLead.additionalNotes || leadObj?.additionalNotes || ''
              };
              this.singleLead = mergedLead;
              this.selectedLead = mergedLead;
              this.selectedLeadForDetails = mergedLead;
              this.dispositions = mergedLead.dispositionStatus || [];
              this.followUpTasks = mergedLead.followUpTasks || [];
              this.assistantTaskNote = '';
              this.assistantTaskReminderDueAt = '';
              this.selectedAssigneeName = this.isSalesAccount
                ? (mergedLead.followUpAssignedTo?.userName || mergedLead.followUpAssigneeName || "")
                : (mergedLead.followUpAssignedTo?.userName || mergedLead.assignedTo?.userName || "");
              this.selectedReassignUser = null;
              this.reassignDropdownOpen = false;
              this.selectedLeadStatus = mergedLead.status || "";
              this.updatePreselectedStatuses(null, mergedLead);
              this.patchLeadForm(mergedLead);
              this.pendingDispositions = [];
              this.pendingDispositionsPayloads = [];
              this.dispositionDirty = false;
              this.showReminderSection = false;
              this.reminderDueAt = '';
              this.pendingReminderTargetStatus = '';
            },
            error: (fallbackErr) => {
              console.error("Fallback fetch lead failed:", fallbackErr);
              if (this.activeDetailsLeadId && this.activeDetailsLeadId === requestLeadId) {
                this.isLoadingLeadDetails = false;
              }
            }
          });
        } else {
          if (this.activeDetailsLeadId && this.activeDetailsLeadId === requestLeadId) {
            this.isLoadingLeadDetails = false;
          }
        }
      }
    });
  }


  openLead(lead: any) {
    this.getSingleLeadById(lead._id, lead.source, lead.project);
  } expandedTextBlocks: { [key: number]: boolean } = {};

  // Auto-resize textarea on input
  expandTextBlock(index: number) {
    const textarea = this.editorTextareas?.toArray()[index]?.nativeElement;
    if (!textarea) return;
    this.expandedTextBlocks[index] = !this.expandedTextBlocks[index];
    requestAnimationFrame(() => {
      if (this.expandedTextBlocks[index]) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      } else {
        textarea.style.height = '80px';
      }
    });
  }

  // Load text into editor blocks
  loadEditorBlocks(text: string) {
    this.expandedTextBlocks = {};
    this.editorBlocks = [
      {
        id: crypto.randomUUID(),
        type: "text",
        value: text
      }
    ];
  }




  // Accordion toggle for lead details in Kanban view
  expandedLeadId: string | null = null;
  toggleAccordion(lead: any, event: Event) {
    event.stopPropagation();
    this.expandedLeadId =
      this.expandedLeadId === lead._id ? null : lead._id;
  }

  getLeadEmail(lead: any): string {
    if (!lead) return '-';
    if (lead.email) return lead.email;
    if (Array.isArray(lead.emails) && lead.emails.length > 0 && lead.emails[0]) {
      return lead.emails[0];
    }
    if (typeof lead.emails === 'string' && lead.emails) {
      return lead.emails;
    }
    if (lead.senderEmail) return lead.senderEmail;
    if (lead.fromEmail) return lead.fromEmail;
    if (lead.from) return lead.from;
    if (lead.sourceEmail) return lead.sourceEmail;
    if (lead.mail) return lead.mail;
    if (lead.emailId) return lead.emailId;
    if (Array.isArray(lead.customerInformation) && lead.customerInformation[0]?.email) {
      return lead.customerInformation[0].email;
    }
    return '-';
  }

  getLeadPhone(lead: any): string {
    if (!lead) return '-';
    const phone =
      lead.phoneNo ||
      lead.callerId ||
      lead.phone ||
      lead.phoneNumber ||
      lead.mobile ||
      lead.mobileNo ||
      lead.calledNo ||
      lead.contactNo ||
      lead.contactNumber ||
      lead.tel ||
      (Array.isArray(lead.phoneNumbers) && lead.phoneNumbers[0]) ||
      (Array.isArray(lead.customerInformation) && (lead.customerInformation[0]?.phoneNo || lead.customerInformation[0]?.phoneNumber || lead.customerInformation[0]?.phone || lead.customerInformation[0]?.mobile)) ||
      '';
    return phone ? String(phone) : '-';
  }

  // Patch lead data into the form
  patchLeadForm(lead: any) {
    if (!lead) return;

    let emailValue = lead.email || '';
    if (!emailValue) {
      if (Array.isArray(lead.emails) && lead.emails.length > 0 && lead.emails[0]) {
        emailValue = lead.emails[0];
      } else if (typeof lead.emails === 'string' && lead.emails) {
        emailValue = lead.emails;
      } else if (lead.senderEmail) {
        emailValue = lead.senderEmail;
      } else if (lead.fromEmail) {
        emailValue = lead.fromEmail;
      } else if (lead.from) {
        emailValue = lead.from;
      } else if (lead.sourceEmail) {
        emailValue = lead.sourceEmail;
      } else if (lead.mail) {
        emailValue = lead.mail;
      } else if (lead.emailId) {
        emailValue = lead.emailId;
      } else if (Array.isArray(lead.customerInformation) && lead.customerInformation[0]?.email) {
        emailValue = lead.customerInformation[0].email;
      }
    }

    const rawBadge = (lead.customerValue || lead.badge || '').toLowerCase();
    const badgeObj = this.badgeOptions.find(b => b.value === rawBadge) || null;
    this.selectedBadgeDetails = badgeObj;
    this.badgeDropdownOpen = false;
    const notesVal = lead.adminNotes || lead.description || '';

    this.selectedLeadStatus = lead.status || "";
    this.updatePreselectedStatuses(null, lead);
    this.showLostReason = this.selectedLeadStatus === "Lost";

    const resolvedPhone =
      lead.phoneNo ||
      lead.callerId ||
      lead.phone ||
      lead.phoneNumber ||
      lead.mobile ||
      lead.mobileNo ||
      lead.calledNo ||
      lead.contactNo ||
      lead.contactNumber ||
      lead.tel ||
      (Array.isArray(lead.phoneNumbers) && lead.phoneNumbers[0]) ||
      (Array.isArray(lead.customerInformation) && (lead.customerInformation[0]?.phoneNo || lead.customerInformation[0]?.phoneNumber || lead.customerInformation[0]?.phone || lead.customerInformation[0]?.mobile)) ||
      '';

    const resolvedName =
      lead.contactName ||
      lead.leadName ||
      lead.name ||
      lead.fullName ||
      lead.customerName ||
      lead.personName ||
      (Array.isArray(lead.customerInformation) && (lead.customerInformation[0]?.contactName || lead.customerInformation[0]?.name || lead.customerInformation[0]?.fullName)) ||
      '';

    const resolvedCompany =
      lead.companyName ||
      lead.company ||
      lead.organization ||
      lead.orgName ||
      (Array.isArray(lead.customerInformation) && (lead.customerInformation[0]?.companyName || lead.customerInformation[0]?.company)) ||
      '';

    const resolvedDesignation =
      lead.designation ||
      lead.title ||
      lead.jobTitle ||
      lead.role ||
      (Array.isArray(lead.customerInformation) && lead.customerInformation[0]?.designation) ||
      '';

    this.leadForm.patchValue(
      {
        companyName: resolvedCompany,
        name: resolvedName,
        leadName: resolvedName,
        contactName: resolvedName,
        phoneNo: resolvedPhone,
        email: emailValue,
        designation: resolvedDesignation,
        followUpDate: lead.followUpDate
          ? (typeof lead.followUpDate === 'string' ? lead.followUpDate.substring(0, 10) : new Date(lead.followUpDate).toISOString().substring(0, 10))
          : '',
        followUpAssignee: lead.followUpAssignedTo?.userId || lead.followUpAssignee || '',
        status: lead.status || '',
        leadId: lead._id || lead.id,
        adminNotes: notesVal,
        customerValue: rawBadge,
        lossReason: lead.lossReason || '',
      },
      { emitEvent: false }
    );

    this.initialLeadSnapshot = this.leadForm.getRawValue();
    this.leadForm.markAsPristine();
    this.leadForm.markAsUntouched();
  }



  // Load media files into editor blocks
  loadMediaBlocks(media: any[]) {
    media.forEach(file => {
      const extension = file.extension.replace(".", "").toLowerCase();

      let url = "";
      let thumbnail = "";

      // IMAGE 
      if (["jpg", "jpeg", "png", "webp", "gif"].includes(extension)) {
        url = file.compressedImgUrl || file.fileUrl;
        thumbnail = url;
      }

      // VIDEO 
      else if (["mp4", "mov", "webm", "mkv"].includes(extension)) {
        url = file.fileUrl;
        thumbnail = file.thumbnailUrl;
      }


      else {
        url = file.fileUrl;
        thumbnail = "/assets/leads/document-files-icon.png";
      }

      const fileBlock: FileBlock = {
        id: crypto.randomUUID(),
        type: "file",

        fileName: file.fileName || "unknown",
        fileSize: file.size || 0,
        rawFile: null as any,
        uploading: false,
        progress: 100,
        parts: [],

        url: url,
        thumbnailUrl: thumbnail,
        extension: extension,
        uploadedAt: file.updatedAt,
        uploadId: file._id,
        mediaId: file._id
      };

      this.editorBlocks.push(fileBlock);
    });
  }

  // Format date to YYYY-MM-DD
  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Set follow-up type
  setFollowUpType(type: string) {
    this.followUpForm.patchValue({ type });
  }


  // Convert 12-hour time format to 24-hour format
  convertTo24Hour(time12h: string): string {
    if (!time12h) return '';

    const [time, modifier] = time12h.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    }

    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes}`;
  }

  //Add Disposition status in update lead form
  pendingDispositions: Disposition[] = [];
  pendingDispositionsPayloads: { tempId: string; payload: any }[] = [];
  isAddingDisposition = false;
  addDisposition() {
    const value = this.dispositionControl.value?.trim();

    if (!value || !this.selectedDispositionStatus || this.isAddingDisposition) {
      return;
    }

    const currentAddedStatus = this.selectedDispositionStatus || 'Contacted';
    const isOutbound = this.isOutboundLead(this.selectedLead);
    const targetProject = this.getActualLeadProject(this.selectedLead);
    const rawTab = this.selectedLead?.projectTab || this.selectedLead?.source || this.selectedLead?.sourceLead;
    let projectTab = rawTab;
    const upperProj = (targetProject || '').toUpperCase();
    if (upperProj === 'IIC-LAB' || upperProj === 'IIC' || upperProj === 'V-ESTATE') {
      projectTab = rawTab || 'IVR';
    }

    const redirectUrl = this.getKanbanRedirectUrlByProject(targetProject);

    const payload: any = {
      note: value,
      leadId: this.selectedLead!._id,
      status: currentAddedStatus,
      redirectUrl: redirectUrl
    };

    if (isOutbound) {
      payload.leadType = 'Outbound';
    } else {
      payload.project = targetProject;
      if (projectTab) {
        payload.projectTab = projectTab;
      }
    }

    this.isAddingDisposition = true;

    this.crmService.createDisposition(payload).subscribe({
      next: (res: any) => {
        this.isAddingDisposition = false;
        const apiData = res?.data || {};
        const nowIso = new Date().toISOString();
        const createdDisposition: Disposition = {
          _id: apiData._id || 'disp-' + Date.now(),
          leadId: payload.leadId,
          note: payload.note,
          userName: apiData.userName || this.loggedInUserName,
          status: payload.status,
          createdAt: apiData.createdAt || nowIso,
          updatedAt: apiData.updatedAt || nowIso,
          type: 'User',
          ...apiData
        };

        // Update logs list ONLY after successful API response confirming creation
        this.dispositions = [createdDisposition, ...this.dispositions];
        if (this.singleLead && Array.isArray(this.singleLead.dispositionStatus)) {
          this.singleLead.dispositionStatus = [createdDisposition, ...this.singleLead.dispositionStatus];
        }
        if (this.selectedLead && Array.isArray(this.selectedLead.dispositionStatus)) {
          this.selectedLead.dispositionStatus = [createdDisposition, ...this.selectedLead.dispositionStatus];
        }
        if (this.selectedLeadForDetails && Array.isArray(this.selectedLeadForDetails.dispositionStatus)) {
          this.selectedLeadForDetails.dispositionStatus = [createdDisposition, ...this.selectedLeadForDetails.dispositionStatus];
        }

        const normalizedAdded = (currentAddedStatus || '').trim().toLowerCase();
        const isAddedTerminal =
          normalizedAdded === 'closed' ||
          normalizedAdded === 'closed won' ||
          normalizedAdded === 'lost' ||
          normalizedAdded === 'unqualified';

        if (isAddedTerminal) {
          this.showReminderSection = false;
          this.reminderDueAt = '';
          this.reminderDueTime = '';
          this.selectedReminderStatus = null;
          this.pendingReminderTargetStatus = '';
          this.selectedDispositionStatus = currentAddedStatus;
          this.selectedStatusIcon = this.getStatusIcon(currentAddedStatus);
        } else {
          // Advance to next logical status and show reminder section
          const nextStatus = this.getNextLogicalStatus(currentAddedStatus);
          this.pendingReminderTargetStatus = nextStatus;
          this.selectedReminderStatus = nextStatus;
          this.selectedReminderStatusIcon = this.getStatusIcon(nextStatus);
          this.showReminderSection = true;
          this.reminderDueAt = '';
          this.reminderDueTime = '';
          this.selectedDispositionStatus = nextStatus;
          this.selectedStatusIcon = this.getStatusIcon(this.selectedDispositionStatus);

          const submittedStatus = payload.status;
          this.updatePreselectedDispositionStatus(submittedStatus);
        }

        // reset input + button state
        this.dispositionControl.reset();
        this.isAddDispositionEnabled = false;
        const textarea = document.querySelector('.disposition-input') as HTMLTextAreaElement;
        if (textarea) {
          textarea.style.height = '44px';
        }
      },
      error: (err: any) => {
        this.isAddingDisposition = false;
        console.error('Error creating disposition log:', err);
        const errMsg = err?.error?.message || err?.message || 'Failed to create disposition log';
        alertModalWithoutConfirm('error', errMsg);
      }
    });
  }

  followUpTasks: any[] = [];
  followUpTaskAssigneeDropdownOpen: boolean = false;
  selectedFollowUpTaskAssignee: any = null;
  followUpTaskDescription: string = '';
  isSubmittingFollowUpTask: boolean = false;

  toggleFollowUpTaskAssigneeDropdown(event: Event): void {
    event.stopPropagation();
    const willOpen = !this.followUpTaskAssigneeDropdownOpen;
    this.closeAllDropdowns();
    this.followUpTaskAssigneeDropdownOpen = willOpen;
  }

  selectFollowUpTaskAssignee(user: any, event: Event): void {
    event.stopPropagation();
    this.selectedFollowUpTaskAssignee = user;
    this.followUpTaskAssigneeDropdownOpen = false;
  }

  clearFollowUpTaskAssignee(event: Event): void {
    event.stopPropagation();
    this.selectedFollowUpTaskAssignee = null;
    this.followUpTaskAssigneeDropdownOpen = false;
  }

  submitFollowUpTask(): void {
    if (this.isAssistantSalesUser || this.assistantUser || !this.canCreateFollowUpTask) {
      alertModalWithoutConfirm('error', 'Only sales account can create follow-up tasks.');
      return;
    }

    if (this.isLeadLost) {
      alertModalWithoutConfirm('warning', 'Follow-up tasks cannot be created for lost leads.');
      return;
    }

    if (this.isLeadUnqualified) {
      alertModalWithoutConfirm('warning', 'Follow-up tasks cannot be created for unqualified leads.');
      return;
    }

    if (this.hasActiveFollowUpTask) {
      alertModalWithoutConfirm('warning', 'An active follow-up task already exists for this lead.');
      return;
    }

    if (!this.selectedFollowUpTaskAssignee || !this.followUpTaskDescription?.trim()) {
      return;
    }

    const selectedLeadObj = this.selectedLeadForDetails || this.selectedLead || this.singleLead;
    const leadId = selectedLeadObj?._id || selectedLeadObj?.id;

    if (!leadId) {
      alertModalWithoutConfirm('error', 'Lead ID not found.');
      return;
    }

    this.isSubmittingFollowUpTask = true;

    const leadObj = selectedLeadObj || {};
    const projectVal = selectedLeadObj?.project || this.getActualLeadProject(leadObj) || this.project || 'V-RETAIL';
    const leadTypeVal = selectedLeadObj?.leadType || (this.project === 'OUTBOUND' ? 'Outbound' : 'Inbound');

    const redirectUrl = this.getKanbanRedirectUrlByProject(projectVal);

    const payload: any = {
      leadId: leadId,
      project: projectVal,
      leadType: leadTypeVal,
      taskDescription: this.followUpTaskDescription.trim(),
      redirectUrl: redirectUrl,
      assignee: {
        userId: this.selectedFollowUpTaskAssignee?._id || this.selectedFollowUpTaskAssignee?.userId || this.selectedFollowUpTaskAssignee?.id || '',
        userName: this.selectedFollowUpTaskAssignee?.userName || this.selectedFollowUpTaskAssignee?.username || this.selectedFollowUpTaskAssignee?.name || ''
      }
    };

    const rawTab = selectedLeadObj?.source || selectedLeadObj?.sourceLead || selectedLeadObj?.projectTab || (this.projectTab && this.projectTab !== 'ALL' ? this.projectTab : undefined);
    if (rawTab && rawTab !== 'ALL') {
      payload.projectTab = rawTab;
    }

    this.crmService.createFollowUpTask(payload).subscribe({
      next: (res: any) => {
        this.isSubmittingFollowUpTask = false;
        const newDescription = this.followUpTaskDescription.trim();
        const newAssignee = { ...this.selectedFollowUpTaskAssignee };
        this.followUpTaskDescription = '';
        this.selectedFollowUpTaskAssignee = null;

        const createdTask = res?.data || {
          _id: res?.taskId || ('task_' + Date.now()),
          leadId: leadId,
          taskDescription: newDescription,
          assignee: newAssignee,
          isCompleted: false,
          createdAt: new Date().toISOString()
        };
        if (!this.followUpTasks) {
          this.followUpTasks = [];
        }
        this.followUpTasks.push(createdTask);

        alertModalWithoutConfirm('success', 'Follow up task created successfully!');
        this.updateRemindersHasNextTaskScheduled(leadId);
        this.fetchFollowUpReminders();
        this.fetchAllReminderCounts();
        this.getSingleLeadById(leadId, rawTab || selectedLeadObj?.source, projectVal);
        if (this.currentView === 'kanban') {
          this.loadAllColumns();
        }
      },

      error: (err: any) => {
        this.isSubmittingFollowUpTask = false;
        console.error('Error creating follow up task:', err);
        alertModalWithoutConfirm('error', err?.error?.message || 'Failed to create follow up task.');
      }
    });
  }



  get systemDispositions(): Disposition[] {
    const raw = this.dispositions
      .filter(d => d.type === 'System')
      .sort(
        (a, b) =>
          new Date(a.updatedAt!).getTime() -
          new Date(b.updatedAt!).getTime()
      );

    return raw.filter(
      (item, index, arr) =>
        index === 0 || item.status !== arr[index - 1].status
    );
  }


  // Kept for later use if needed
  removeDisposition(tag: Disposition) {
    this.crmService.deleteDisposition(tag._id).subscribe({
      next: () => {
        this.dispositions = this.dispositions.filter(
          t => t._id !== tag._id
        );
      }
    });
  }


  showCreateOutboundModal: boolean = false;
  isSubmittingOutbound: boolean = false;
  outboundErrorMessage: string = '';

  userAlertModal = {
    show: false,
    title: 'Notice',
    message: '',
    type: 'warning'
  };

  showAlert(message: string, title: string = 'Notice', type: string = 'warning') {
    this.userAlertModal = {
      show: true,
      title,
      message,
      type
    };
  }

  closeAlertModal() {
    this.userAlertModal.show = false;
  }

  isEditOutboundMode = false;
  editingOutboundLeadId: string | null = null;

  isOutboundLead(leadObj: any): boolean {
    if (!leadObj) return false;
    const type = String(leadObj.leadType || '').toLowerCase();
    const proj = String(leadObj.project || '').toLowerCase();
    const src = String(leadObj.source || leadObj.sourceLead || '').toLowerCase();
    const tab = String(leadObj.projectTab || '').toLowerCase();
    return (
      this.project === 'OUTBOUND' ||
      type === 'outbound' ||
      proj === 'outbound' ||
      src === 'outbound' ||
      tab === 'outbound'
    );
  }

  getLeadProjectBadge(leadObj: any): string {
    if (!leadObj) return this.project || 'ALL';
    if (this.isOutboundLead(leadObj)) {
      return 'OUTBOUND';
    }
    const proj = leadObj.project || this.project || '';
    if (!proj || proj === 'ALL') {
      return 'ALL';
    }
    return proj;
  }

  outboundForm = {
    name: '',
    email: '',
    companyName: '',
    designation: '',
    phoneNo: '',
    source: 'Outbound',
    message: ''
  };

  openCreateOutboundLeadModal() {
    this.outboundErrorMessage = '';
    this.isEditOutboundMode = false;
    this.editingOutboundLeadId = null;
    this.outboundForm = {
      name: '',
      email: '',
      companyName: '',
      designation: '',
      phoneNo: '',
      source: 'Outbound',
      message: ''
    };
    this.showCreateOutboundModal = true;
  }

  isLeadUnassigned(lead: any): boolean {
    if (!lead) return true;

    const assigned = lead.assignedTo || lead.followUpAssignedTo;
    if (assigned) {
      if (Array.isArray(assigned)) {
        if (assigned.length > 0 && (assigned[0].userId || assigned[0].userName)) {
          return false;
        }
      } else if (typeof assigned === 'object') {
        if (assigned.userId || assigned.userName) {
          return false;
        }
      } else if (typeof assigned === 'string' && assigned.trim() !== '' && assigned !== '-') {
        return false;
      }
    }

    if (lead.assignedToString && typeof lead.assignedToString === 'string') {
      const trimmed = lead.assignedToString.trim();
      if (trimmed !== '' && trimmed !== '-') {
        return false;
      }
    }

    return true;
  }

  openEditOutboundLeadModal(lead: any) {
    if (!lead) return;
    if (!this.isLeadUnassigned(lead)) {
      alertModalWithoutConfirm("warning", "Assigned Outbound leads cannot be edited.");
      return;
    }
    this.outboundErrorMessage = '';
    this.isEditOutboundMode = true;
    this.editingOutboundLeadId = lead._id || lead.id || null;
    this.outboundForm = {
      name: lead.name || '',
      email: lead.email || '',
      companyName: lead.companyName || '',
      designation: lead.designation || '',
      phoneNo: lead.phoneNo || lead.phone || '',
      source: lead.source || lead.sourceLead || 'Outbound',
      message: lead.message || ''
    };
    this.showCreateOutboundModal = true;
  }

  closeCreateOutboundLeadModal() {
    this.showCreateOutboundModal = false;
    this.isEditOutboundMode = false;
    this.editingOutboundLeadId = null;
    this.outboundErrorMessage = '';
  }

  submitCreateOutboundLead() {
    if (!this.outboundForm.name?.trim()) {
      this.outboundErrorMessage = 'Please enter lead name';
      return;
    }
    this.outboundErrorMessage = '';
    this.isSubmittingOutbound = true;
    const payload = {
      name: this.outboundForm.name.trim(),
      email: this.outboundForm.email?.trim() || '',
      companyName: this.outboundForm.companyName?.trim() || '',
      designation: this.outboundForm.designation?.trim() || '',
      phoneNo: this.outboundForm.phoneNo?.trim() || '',
      source: 'Outbound',
      message: this.outboundForm.message?.trim() || ''
    };

    if (this.isEditOutboundMode && this.editingOutboundLeadId) {
      this.crmService.updateOutboundLead(this.editingOutboundLeadId, payload).subscribe({
        next: (res: any) => {
          this.isSubmittingOutbound = false;
          this.closeCreateOutboundLeadModal();
          if (this.currentView === 'kanban') {
            this.loadAllColumns();
          } else {
            this.currentPageNume = 1;
            this.getAllAssignedLead();
            this.getAdminOverView();
          }
        },
        error: (err: any) => {
          this.isSubmittingOutbound = false;
          console.error('Error updating outbound lead:', err);
          this.outboundErrorMessage = err?.error?.message || 'Failed to update outbound lead. Please try again.';
        }
      });
    } else {
      this.crmService.createOutboundLead(payload).subscribe({
        next: (res: any) => {
          this.isSubmittingOutbound = false;
          this.closeCreateOutboundLeadModal();
          const createdLead = res?.data || res?.lead || res?.data?.lead;
          if (createdLead && createdLead._id) {
            const exists = Array.isArray(this.assignedLeads) && this.assignedLeads.some((l: any) => l._id === createdLead._id);
            if (!exists) {
              if (!Array.isArray(this.assignedLeads)) {
                this.assignedLeads = [];
              }
              this.assignedLeads.unshift(createdLead);
              this.totalAssignedCount = (this.totalAssignedCount || 0) + 1;
            }
          }
          if (this.currentView === 'kanban') {
            this.loadAllColumns();
          } else {
            this.currentPageNume = 1;
            this.getAllAssignedLead();
            this.getAdminOverView();
          }
        },
        error: (err: any) => {
          this.isSubmittingOutbound = false;
          console.error('Error creating outbound lead:', err);
          this.outboundErrorMessage = err?.error?.message || 'Failed to create outbound lead. Please try again.';
        }
      });
    }
  }
}
